import * as $ from 'jquery';
import 'bootstrap';
import 'datepicker';
import 'selectize';
import * as Cookies from 'js-cookie';
import 'MagnificPopup';
import * as moment from 'moment';
import { bookingFormBackend } from "./c005-bookingform-backend";
import { bookingFormInfant } from "./c005-bookingform-infant";
import { headerContent } from "./c002";
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";

export class bookingFormSubmit {
	private bookingFormBackend = new bookingFormBackend();
	private bookflightinfant = new bookingFormInfant();
	private adobeDataLayer = new adobeDataLayerWrapper();

	/**
	 * [singleBookingFormValidation description]
	 * @param  {any} callback [description]
	 * @return {any}          [description]
	 */
	singleBookingFormValidation($instance: any, $officeCode: any, callback: any): any {
		let ieversion = new headerContent();
		ieversion.checkIEVersion_disablePupup();
		let _self = this;
		let $errorList: Array<string> = [];

		let $errorValidation = $instance.find('.error-validation').first();
		let formDataValid = true;

		let $fromLocation: any = $instance.find('.ibe-from--location'),
			$fromBookingTitle: any = $fromLocation.parent().find('.booking-form--title'),
			$fromSelectize: any = $fromLocation.parent().find('.selectize-control .selectize-input');

		let $passengerDetailsActive: any = $('[data-booking-passenger-details-selected]');
		let $originalInstance: any;

		// Validation: IBE From Location empty field
		if ($fromLocation.val() == '') {
			$fromSelectize.addClass('has-error');
			$fromBookingTitle.addClass('has-error');
			let $fromLocValidate: any = $fromLocation.attr('data-departloc');
			$errorList.push('<strong>' + $fromLocation.parent().find('label').text() + ':</strong> ' + $fromLocValidate);
			formDataValid = false;
		} else {
			$fromSelectize.removeClass('has-error');
			$fromBookingTitle.removeClass('has-error');
		}

		let $toLocation: any = $instance.find('.ibe-to--location'),
			$toBookingTitle: any = $toLocation.parent().find('.booking-form--title'),
			$toSelectize: any = $toLocation.parent().find('.selectize-control .selectize-input');

		// Validation: IBE To Location empty field
		if ($toLocation.val() == '') {
			$toSelectize.addClass('has-error');
			$toBookingTitle.addClass('has-error');

			let $toLocValidate: any = $toLocation.attr('data-destloc');
			$errorList.push('<strong>' + $toLocation.parent().find('label').text() + ':</strong> ' + $toLocValidate);
			formDataValid = false;
		} else {
			$toSelectize.removeClass('has-error');
			$toBookingTitle.removeClass('has-error');
		}

		// Validation: IBE From/To Location identical value
		if ($fromLocation.val().split('_')[0] === $toLocation.val()) {
			$toSelectize.addClass('has-error');
			$toBookingTitle.addClass('has-error');
			formDataValid = false;

			if (!($fromLocation.val() == '' || $toLocation.val() == '')) {
				let $fromLoLocValidate: any = $fromLocation.attr('data-deptDestLoc');
				$errorList.push('<strong>' + $fromLocation.parent().find('label').text() + ', ' + $toLocation.parent().find('label').text() + ':</strong> ' + $fromLoLocValidate);
			}
		}
		let $oneWayTripEl: any = $instance.find('.trip-type--container .oneWayTrip');

		if ($('.enrich-revamp .date-ipad-container').is(':visible')) {
			$originalInstance = $instance;
			$instance = $instance.find('.date-ipad-container');
		}

		// Validation: IBE One Way Trip Date empty field		
		let $oneWayDepDate: any = $instance.find('.oneWayTrip .departureDate'),
			$returnDepDate: any = $instance.find('.returnTrip .departureDate'),
			$returnRetDate: any = $instance.find('.returnTrip .returnDate');

		if ($oneWayTripEl.hasClass('selected')) {
			if ($oneWayDepDate.val() == '') {
				$oneWayDepDate.parent().parent().addClass('has-error');
				let $travelDateOne: any = $instance.find('.departureDate.oneWay-trip').attr('data-traveldateOne');
				$errorList.push('<strong>' + $oneWayDepDate.parent().find('label.one-dep-title').text() + ':</strong> ' + $travelDateOne);
				formDataValid = false;
			} else {
				$oneWayDepDate.parent().parent().removeClass('has-error');
			}
		} else {
			/** IBE Return Trip Departure Date empty field validation */
			if ($returnDepDate.val() == '') {
				$returnDepDate.parent().parent().parent().addClass('has-error');
				let $travelDate: any = $returnDepDate.attr('data-travelDepdate');
				$errorList.push('<strong>' + $returnDepDate.parent().find('label.dep-title').text() + ':</strong> ' + $travelDate);
				formDataValid = false;
			} else {
				$returnDepDate.parent().parent().parent().removeClass('has-error');
			}
			/** IBE Return Trip Return Date empty field validation */
			if ($returnRetDate.val() == '') {
				$returnRetDate.parent().parent().parent().addClass('has-error');
				let $travelEndDate: any = $instance.find('.returnDate').attr('data-travelRetdate');
				$errorList.push('<strong>' + $returnRetDate.parent().find('label.ret-title').text() + ':</strong> ' + $travelEndDate);
				formDataValid = false;
			} else {
				$returnRetDate.parent().parent().parent().removeClass('has-error');
			}
		}

		if ($('.enrich-revamp .date-ipad-container').is(':visible')) {
			$instance = $originalInstance;
		}

		// Validation: Cabin class input validation
		let $cabinClassEl: any = $instance.find('.cabin-class'),
			$cabinClassSelectize = $cabinClassEl.find('.selectize-control .selectize-input'),
			$cabinClassBookingTitle = $cabinClassEl.find('booking-form--title');

		if ($cabinClassEl.val() == '') {
			$cabinClassSelectize.addClass('has-error');
			$cabinClassBookingTitle.addClass('has-error');
			let $cabin: any = $cabinClassEl.attr('data-cabin');
			$errorList.push('<strong>' + $cabinClassEl.parent().find('label').text() + ':</strong> ' + $cabin);
			formDataValid = false;
		} else {
			$cabinClassSelectize.removeClass('has-error');
			$cabinClassBookingTitle.removeClass('has-error');
		}

		let $totalTicketsEl: any = $instance.find('input.total-tickets--value'),
			$passengerDetailsContainer: any = $instance.find('[data-booking-passenger-details]');

		// Validation: total ticket value input
		if ($totalTicketsEl.val() == 0) {
			let $nopassenger: any = $totalTicketsEl.attr('data-passenger');
			$passengerDetailsContainer.addClass('has-errors');
			$errorList.push('<strong>' + $totalTicketsEl.parent().find('label').text() + ':</strong> ' + $nopassenger);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-errors');
		}

		// Validation: Passenger type input
		let $adultBookingError: any = $instance.find('.adult-booking--error'),
			$infantBookingError: any = $instance.find('.infant-booking--error');

		if ($adultBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $lessAdult: any = $adultBookingError.attr('data-lessadult');
			$errorList.push('<strong>' + $passengerDetailsContainer.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.adult-cat .booking-category').text() + ':</strong> ' + $lessAdult);
			formDataValid = false;
		} else if ($infantBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $moreInfant: any = $infantBookingError.attr('data-moreinfant');
			$errorList.push('<strong>' + $passengerDetailsContainer.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.infant-cat .booking-category').text() + ':</strong> ' + $moreInfant);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-error');
		}

		let $cabinClass = $instance.find('.cabin-class').val();
		let $paymentMethod = $instance.find('input[name="cash_miles_type"]:checked').val();
		let $infantTicketValue = $instance.find('.ticket-infant--input').val();
		let $infantAlertContainer: any = $('#infant-alert--container');
		let $warningAccepted: any = $infantAlertContainer.find('input[name="infant_warning"]');
		let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';

		// Validation: infant booking
		// single booking form
		// open popup if these conditions are met:
		// - cabinclass = 'CFFFIRST'
		// - warning != 'accepted'
		// - infantTicketvalue > 0
		// - form submission is valid till this point
		if (formDataValid === true && $cabinClass == "CFFFIRST" && $warningAccepted.val() !== 'accepted' && $infantTicketValue > 0) {
			$instance.find('.error-validation').hide();
			if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
				$.magnificPopup.open({
					items: {
						src: '#infant-alert--container'
					},
					type: 'inline',
					midClick: true,
					callbacks: {
						open: function () {
							let instance = this;
							let $el: any = instance.content;
							// console.log('single booking mobile booking form', $instance, instance);
							_self.bookflightinfant.submitBtns($instance);

							if ($paymentMethod === 'cash') {
								$el.find('input[name="tripflow"]').val('single_desk');
								$el.find('input[name="payment_method"]').val('cash');
							} else if ($paymentMethod !== 'cash') {
								$el.find('input[name="tripflow"]').val('single_desk');
								$el.find('input[name="payment_method"]').val('miles');
							}

						}
					}
				}, 0);
			}
			else {
				$.magnificPopup.proto.close.call(this);
				$.magnificPopup.instance.close = function () {
					$.magnificPopup.open({
						items: {
							src: '#infant-alert--container'
						},
						type: 'inline',
						midClick: true,
						callbacks: {
							open: function () {
								let instance = this;
								let $el: any = instance.content;
								// console.log('single booking mobile booking form', $instance, instance);
								_self.bookflightinfant.submitBtns($instance);

								if ($paymentMethod === 'cash') {
									$el.find('input[name="tripflow"]').val('single_desk');
									$el.find('input[name="payment_method"]').val('cash');
								} else if ($paymentMethod !== 'cash') {
									$el.find('input[name="tripflow"]').val('single_desk');
									$el.find('input[name="payment_method"]').val('miles');
								}

							}
						}
					}, 0);
				};
			}
			return false;
		}

		// Validation: Coupon code input
		////// let $couponCodeEl:any = $instance.find('.couponcode-input');
		////// if (!$couponCodeEl.attr('disabled') && $couponCodeEl.val() != '1234') {
		////// 	$couponCodeEl.parent().addClass('has-error');
		////// 	let $couponCode:any = $couponCodeEl.attr('data-couponcode');
		////// 	$errorList.push('<strong>'+$couponCodeEl.parent().find('label').text()+':</strong> '+$couponCode);
		////// 	formDataValid = false;
		////// } else {
		////// 	$couponCodeEl.parent().removeClass('has-error');
		////// }


		// workaround:
		// validate all fields except redemption login
		// hide error validation container if everything up to this point
		// is valid. this is because redemption login has its own error
		// container.
		if (formDataValid) {
			$errorValidation.hide();
		}

		// Validation: Redemption login fields
		// only validate if selected payment type is miles/cash+miles
		// cash_miles_type
		let loginContainer = $instance.find('.container--redemption-login');
		if ($paymentMethod !== 'cash') {
			let redemptionLoginValidation = _self.loginFieldsValidation($instance);

			if (loginContainer.hasClass('hidden')) {
				redemptionLoginValidation = true;
			}

			if (!redemptionLoginValidation) {
				formDataValid = false;
			}
		}

		let $validationContainer: any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist: any = $validationContainer;

		for (var i = 0, len = $errorList.length; i < len; i++) {
			$validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
		}
		// travel pass balance check
		if ($("#travel_pass").length > 0 && formDataValid) {
			let $travelpass_id = $('select.travel-pass--id option')[0].value.split('|')[0];
			let $travelpassbalancecheckurl: string = $('[data-get-travel-pass-details]').attr('data-get-travel-pass-details');
			let $data = {
			}
			$data['TRAVELPASS_ID'] = $travelpass_id;
			$.ajax({
				type: 'GET',
				async: false,
				url: $travelpassbalancecheckurl,
				data: $data,
				success: function (msg: any) {
					let json: any = null;
					if (typeof msg === 'string') {
						json = JSON.parse(msg);
					} else {
						json = msg;
					}
					var success = json.travelPassInfo[0].remainingQuota;
					if (success > 0) {
						$errorValidation.hide();
						if (typeof callback === "function") {
							callback($officeCode);
						}
					}
					else {
						$errorValidation.find(".validation-content").html("Balance is in sufficient.Please check");
						$errorValidation.show();
					}
				},
				error: function (error: any) {
					$errorValidation.find(".validation-content").html("Please try after some time");
				}
			});
		}
		else {


			if (formDataValid) {
				// proceed to retrieve input vars (callback fn)
				if (typeof callback === "function") {
					callback($officeCode);
				}
			} else {
				return false;
			}
		}
	}
	/**
	 * [mholidays singleBookingFormValidation description]
	 * @param  {any} callback [description]
	 * @return {any}          [description]
	 */
	mholidaysingleBookingFormValidation($instance: any, $officeCode: any, callback: any): any {
		let $errorList: Array<string> = [];

		let $errorValidation = $instance.find('.error-validation').first();
		let formDataValid = true;

		let $fromLocation: any = $instance.find('.mholidays-ibe-from--location'),
			$fromBookingTitle: any = $fromLocation.parent().find('.booking-form--title'),
			$fromSelectize: any = $fromLocation.parent().find('.selectize-control .selectize-input');

		let $passengerDetailsActive: any = $('.flight-container [data-booking-passenger-details-selected]');
		let $originalInstance: any;

		// Validation: mholidays From Location empty field
		if ($fromLocation.val() == '') {
			$fromSelectize.addClass('has-error');
			$fromBookingTitle.addClass('has-error');
			let $fromLocValidate: any = $fromLocation.attr('data-departloc');
			$errorList.push('<strong>' + $fromLocation.parent().find('label').clone().children().remove().end().text() + ':</strong> ' + $fromLocValidate);
			formDataValid = false;
		} else {
			$fromSelectize.removeClass('has-error');
			$fromBookingTitle.removeClass('has-error');
		}

		let $toLocation: any = $instance.find('.mholidays-ibe-to--location'),
			$toBookingTitle: any = $toLocation.parent().find('.booking-form--title'),
			$toSelectize: any = $toLocation.parent().find('.selectize-control .selectize-input');

		// Validation: mholidays To Location empty field
		if ($toLocation.val() == '') {
			// $toSelectize.addClass('has-error');
			// $toBookingTitle.addClass('has-error');

			// let $toLocValidate:any = $toLocation.attr('data-destloc');
			// $errorList.push('<strong>'+$toLocation.parent().find('label').text()+':</strong> '+$toLocValidate);
			// formDataValid = false;
		} else {
			$toSelectize.removeClass('has-error');
			$toBookingTitle.removeClass('has-error');
		}

		// Validation: mholidays From/To Location identical value
		if ($fromLocation.val().split('_')[0] === $toLocation.val()) {
			if ($toLocation.val() !== '') {
				$toSelectize.addClass('has-error');
				$toBookingTitle.addClass('has-error');
				formDataValid = false;
			}

			if (!($fromLocation.val() == '' || $toLocation.val() == '')) {
				let $fromLoLocValidate: any = $fromLocation.attr('data-deptDestLoc');
				$errorList.push('<strong>' + $fromLocation.parent().find('label').clone().children().remove().end().text() + ', ' + $toLocation.parent().find('label').text() + ':</strong> ' + $fromLoLocValidate);
			}
		}
		// Validation: Date empty field
		if ($('.enrich-revamp .date-mholidays-ipad-container').is(':visible')) {
			$originalInstance = $instance;
			$instance = $instance.find('.date-mholidays-ipad-container');
		}

		let $returnDepDate: any = $instance.find('.returnTrip .departureDate'),
			$returnRetDate: any = $instance.find('.returnTrip .returnDate');

		/** IBE Return Trip Departure Date empty field validation */
		if ($returnDepDate.val() == '') {
			$returnDepDate.parent().parent().parent().addClass('has-error');
			let $travelDate: any = $returnDepDate.attr('data-travelDepdate');
			$errorList.push('<strong>' + $returnDepDate.parent().find('label.dep-title').clone().children().remove().end().text() + ':</strong> ' + $travelDate);
			formDataValid = false;
		} else {
			$returnDepDate.parent().parent().parent().removeClass('has-error');
		}
		/** IBE Return Trip Return Date empty field validation */
		if ($returnRetDate.val() == '') {
			$returnRetDate.parent().parent().parent().addClass('has-error');
			let $travelEndDate: any = $returnRetDate.attr('data-travelRetdate');
			$errorList.push('<strong>' + $returnRetDate.parent().find('label.ret-title').clone().children().remove().end().text() + ':</strong> ' + $travelEndDate);
			formDataValid = false;
		} else {
			$returnRetDate.parent().parent().parent().removeClass('has-error');
		}
		if ($('.enrich-revamp .date-mholidays-ipad-container').is(':visible')) {
			$instance = $originalInstance;
		}
		//Validation - LHR (minimum 5 nights)
		let $cabinClass = $instance.find('.cabin-class').val();
		if ($fromLocation.val() != '' && $toLocation.val() != '' && $cabinClass == 'CFFBUS' && $returnDepDate.val() != '' && $returnRetDate.val() != '') {
			if ($fromLocation.val().split('_')[0].toUpperCase() === 'LHR' && $toLocation.val().split('-')[1].toUpperCase() === 'KUL') {
				let $formatDepDate: any = moment(new Date($returnDepDate.val()), 'DD/MM/YYYY');
				let $formatRetDate: any = moment(new Date($returnRetDate.val()), 'DD/MM/YYYY');
				if ($formatRetDate.diff($formatDepDate, 'days') < 5) {

					$returnDepDate.parent().parent().parent().addClass('has-error');
					$returnRetDate.parent().parent().parent().addClass('has-error');
					let $travelMinDate: any = $returnRetDate.attr('data-travelMinDays');
					$errorList.push('<strong>' + $returnRetDate.parent().find('label.ret-title').clone().children().remove().end().text() + ':</strong> ' + $travelMinDate);
					formDataValid = false;
				}
				else {
					$returnRetDate.parent().parent().parent().removeClass('has-error');
					$returnDepDate.parent().parent().parent().removeClass('has-error');
				}
			}

		}
		let $totalTicketsEl: any = $instance.find('.flight-container input.total-tickets--value'),
			$passengerDetailsContainer: any = $instance.find('.flight-container [data-booking-passenger-details]');

		// Validation: total ticket value input
		if ($totalTicketsEl.val() == 0) {
			let $nopassenger: any = $totalTicketsEl.attr('data-passenger');
			$passengerDetailsContainer.addClass('has-errors');
			$errorList.push('<strong>' + $totalTicketsEl.parent().find('label').clone().children().remove().end().text() + ':</strong> ' + $nopassenger);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-errors');
		}

		// Validation: Passenger type input
		let $adultBookingError: any = $instance.find('.adult-booking--error'),
			$infantBookingError: any = $instance.find('.infant-booking--error'),
			$childBookingError: any = $instance.find('.child-age-error');

		if ($adultBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $lessAdult: any = $adultBookingError.attr('data-lessadult');
			$errorList.push('<strong>' + $passengerDetailsContainer.find('.title-caption').clone().children().remove().end().text() + ' - ' + $passengerDetailsActive.find('.adult-cat .booking-category').text() + ':</strong> ' + $lessAdult);
			formDataValid = false;
		} else if ($infantBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $moreInfant: any = $infantBookingError.attr('data-moreinfant');
			$errorList.push('<strong>Passengers - Infant:</strong> ' + $moreInfant);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-error');
		}

		let $infantTicketValue = $instance.find('.flight-container .ticket-infant--input').val();
		let $infantAlertContainer: any = $('#infant-alert--container');
		let $warningAccepted: any = $infantAlertContainer.find('input[name="infant_warning"]');
		// let $childSelectedEle    = parseInt($instance.find('.flight-container .passengersChildren').val());
		// if($childSelectedEle){
		// 	let $childAgeMsg =0;
		// 	for(var i= 1; i<= $childSelectedEle ; i++){
		// 		let $childAgeVal = $('.flight-container #childAgeInput'+i).val();
		// 		if($childAgeVal<=0 && $childAgeMsg ==0){
		// 			$passengerDetailsContainer.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge');
		// 			$errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		} else {
		// 			$passengerDetailsContainer.removeClass('has-error');
		// 		}
		// 	}
		// }

		/* Adult infant limit check */
		let $adultCount = parseInt($instance.find('.flight-container .passengersAdult').val());
		let $childrenCount = parseInt($instance.find('.flight-container .passengersChildren').val());
		var adultChildComb = 0;
		var $childSel;
		for ($childSel = 1; $childSel <= $childrenCount; $childSel++) {
			var childAgeTemp = parseInt($('.flight-container #childAgeInput' + $childSel).val());
			if (childAgeTemp < 2) {
				adultChildComb++;
			}
		}
		if ($childrenCount > 0) {
			if (adultChildComb > $adultCount) {
				$instance.find('.flight-container .passenger-details').addClass('has-error');
				let $lessAdultInfant: any = $adultBookingError.attr('data-adult-infant-limit');
				$errorList.push('<strong>' + $('.flight-container [data-booking-passenger-details]').find('.title-caption').clone().children().remove().end().text() + ':</strong> ' + $lessAdultInfant);
				formDataValid = false;
			} else {
				$instance.find('.flight-container .passenger-details').removeClass('has-error');
			}
		}
		// container.
		if (formDataValid) {
			$errorValidation.hide();
		}


		let $validationContainer: any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist: any = $validationContainer;

		for (var i = 0, len = $errorList.length; i < len; i++) {
			$validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback($officeCode);
			}
		} else {
			return false;
		}
	}
	mholidaysHotelFormValidation($instance: any, $officeCode: any, callback: any): any {
		let _self = this;
		let $errorList: Array<string> = [];

		let $errorValidation = $instance.find('.error-validation').first();
		let formDataValid = true;
		let $hotelInputVal: any = $instance.find('#hotelInputVal');
		let $hotelInputClass: any = $instance.find('.hotelInputClass');

		if ($hotelInputVal.val() == '') {
			//	$fromSelectize.addClass('has-error');
			$hotelInputClass.addClass('has-error');
			let $hotelValidate: any = $hotelInputVal.attr('data-hotelMsg');
			$errorList.push('<strong>' + $hotelInputVal.parent().find('label').text() + ':</strong> ' + $hotelValidate);
			formDataValid = false;
		} else {
			$hotelInputClass.removeClass('has-error');
			//	$fromBookingTitle.removeClass('has-error');
		}

		let $passengerDetailsActive: any = $('.hotel-container [data-booking-passenger-details-selected]');
		// Validation: IBE One Way Trip Date empty field
		let $checkinDate: any = $instance.find('.checkinCheckout .departureDate');
		let $checkoutDate: any = $instance.find('.checkinCheckout .returnDate');


		// /** IBE Return Trip Departure Date empty field validation */
		if ($checkinDate.val() == '') {
			//	$returnDepDate.parent().parent().parent().addClass('has-error');
			let $travelDate: any = $checkinDate.attr('data-travelDepdate');
			$errorList.push('<strong>' + $checkinDate.parent().find('label.dep-title').text() + ':</strong> ' + $travelDate);
			formDataValid = false;
		} else {
			//$returnDepDate.parent().parent().parent().removeClass('has-error');
		}
		/** IBE Return Trip Return Date empty field validation */
		if ($checkoutDate.val() == '') {
			$checkoutDate.parent().parent().parent().addClass('has-error');
			let $travelEndDate: any = $instance.find('.returnDate').attr('data-travelRetdate');
			$errorList.push('<strong>' + $checkoutDate.parent().find('label.ret-title').text() + ':</strong> ' + $travelEndDate);
			formDataValid = false;
		} else {
			//$returnRetDate.parent().parent().parent().removeClass('has-error');
		}

		let $totalTicketsEl: any = $instance.find('.hotel-container input.total-tickets--value'),
			$passengerDetailsContainer: any = $instance.find('.hotel-container [data-booking-passenger-details]');

		// Validation: total ticket value input
		if ($totalTicketsEl.val() == 0) {
			let $nopassenger: any = $totalTicketsEl.attr('data-passenger');
			$passengerDetailsContainer.addClass('has-errors');
			$errorList.push('<strong>' + $totalTicketsEl.parent().find('label').text() + ':</strong> ' + $nopassenger);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-errors');
		}

		// Validation: Passenger type input
		let $adultBookingError: any = $instance.find('.adult-booking--error'),
			$infantBookingError: any = $instance.find('.infant-booking--error'),
			$childBookingError: any = $instance.find('.child-age-error');

		if ($adultBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $lessAdult: any = $adultBookingError.attr('data-lessadult');
			$errorList.push('<strong>' + $passengerDetailsContainer.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.adult-cat .booking-category').text() + ':</strong> ' + $lessAdult);
			formDataValid = false;
		} else if ($infantBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $moreInfant: any = $infantBookingError.attr('data-moreinfant');
			$errorList.push('<strong>' + $passengerDetailsContainer.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.infant-cat .booking-category').text() + ':</strong> ' + $moreInfant);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-error');
		}

		let $infantTicketValue = $instance.find('.hotel-container .ticket-infant--input').val();
		let $infantAlertContainer: any = $('#infant-alert--container');
		let $warningAccepted: any = $infantAlertContainer.find('input[name="infant_warning"]');
		// let $childSelectedEle    = parseInt($instance.find('.hotel-container .passengersChildren').val());
		// if($childSelectedEle){
		// 	let $childAgeMsg =0;
		// 	for(var i= 1; i<= $childSelectedEle ; i++){
		// 		let $childAgeVal = $('.hotel-container #childAgeInput'+i).val();
		// 		if($childAgeVal<=0 && $childAgeMsg ==0){
		// 			$passengerDetailsContainer.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge');
		// 			$errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}else if(($childAgeVal<1 || $childAgeVal >17) && $childAgeMsg ==0) {
		// 			$passengerDetailsContainer.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge-limit');
		// 			$errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}
		// 		else{
		// 			$passengerDetailsContainer.removeClass('has-error');
		// 		}
		// 	}
		// }

		/* Adult infant limit check */
		let $adultCount = parseInt($instance.find('.hotel-container .passengersAdult').val());
		let $childrenCount = parseInt($instance.find('.hotel-container .passengersChildren').val());
		var adultChildComb = 0;
		var $childSel;
		for ($childSel = 1; $childSel <= $childrenCount; $childSel++) {
			var childAgeTemp = parseInt($('.hotel-container #childAgeInput' + $childSel).val());
			if (childAgeTemp < 2) {
				adultChildComb++;
			}
		}
		if ($childrenCount > 0) {
			if (adultChildComb > $adultCount) {
				$instance.find('.hotel-container .passenger-details').addClass('has-error');
				let $lessAdultInfant: any = $adultBookingError.attr('data-adult-infant-limit');
				$errorList.push('<strong>' + $('.hotel-container [data-booking-passenger-details]').find('.title-caption').text() + ':</strong> ' + $lessAdultInfant);
				formDataValid = false;
			} else {
				$instance.find('.hotel-container .passenger-details').removeClass('has-error');
			}
		}

		if (formDataValid) {
			$errorValidation.hide();
		}


		let $validationContainer: any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist: any = $validationContainer;

		for (var i = 0, len = $errorList.length; i < len; i++) {
			$validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback($officeCode);
			}
		} else {
			return false;
		}
	}
	mholidaysMobileBookingFormValidation($instance: any, $officeCode: any, callback: any): any {

		let _self = this;
		let formDataValid = true;

		let $errorList: Array<any> = [];
		let $errorValidation = $instance.find('.error-validation').first();
		let $passengerDetails: any = $instance.find('.mob-flight-container [data-mob-mholidays-passenger-details]');
		let $passengerDetailsActive: any = $instance.find('.mob-flight-container [data-mob-mholidays-passenger-details-selected]');

		$errorValidation.show();

		// Validation: empty from location
		let $mobFromLocation: any = $instance.find('.ibe-mob-from--location');
		if ($mobFromLocation.val() == '') {
			$mobFromLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
			$mobFromLocation.parent().find('.booking-form--title').addClass('has-error');
			let $mobileFromLocValidate: any = $mobFromLocation.attr('data-mobiledepartloc');
			$errorList.push('<strong>' + $mobFromLocation.parent().find('.booking-form--title').clone().children().remove().end().text() + '</strong>: ' + $mobileFromLocValidate);
			formDataValid = false;
			// formDataWhichFail.push('emptyfromlocation');
		} else {
			$mobFromLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
			$mobFromLocation.parent().find('.booking-form--title').removeClass('has-error');
		}

		// Validation: empty to location
		let $mobToLocation: any = $instance.find('.ibe-mob-to--location');
		if ($mobToLocation.val() == '') {
			// $mobToLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
			// $mobToLocation.parent().find('.booking-form--title').addClass('has-error');
			// let $mobileToLocValidate:any = $mobToLocation.attr('data-mobiledestloc');
			// $errorList.push('<strong>'+ $mobToLocation.parent().find('.booking-form--title').text() +'</strong>: '+$mobileToLocValidate);
			// formDataValid = false;
			// formDataWhichFail.push('emptytolocation');
		} else {
			$mobToLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
			$mobToLocation.parent().find('.booking-form--title').removeClass('has-error');
		}

		// Validation: from and to location the same
		if ($mobFromLocation.val().split('_')[0] === $mobToLocation.val()) {
			if ($mobToLocation.val() !== '') {
				$mobToLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$mobToLocation.parent().find('.booking-form--title').addClass('has-error');
				formDataValid = false;
			}
			// formDataWhichFail.push('fromtosame');
			if (!($mobFromLocation.val() == '' || $mobToLocation.val() == '')) {
				let $mobileFromToLocValidate: any = $mobToLocation.attr('data-mobiledeptlestloc');
				$errorList.push('<strong>' + $mobFromLocation.parent().find('.booking-form--title').clone().children().remove().end().text() + ', ' + $mobToLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $mobileFromToLocValidate);
			}
		}
		let $oneWayTripEl: any = $instance.find('.trip-type--container .oneWayTrip'),
			$oneWayDepDate: any = $instance.find('.oneWayTrip .departureDateMobile'),
			$returnDepDate: any = $instance.find('.mob-flight-container .departureDateMobile'),
			$returnRetDate: any = $instance.find('.mob-flight-container .returnDateMobile');

		// Validation: return way departure date missing
		if ($returnDepDate.val() == '') {
			$returnDepDate.parent().parent().addClass('has-error');
			let $mobileTravelDate: any = $returnDepDate.attr('data-mobiletravelDepdate');
			$errorList.push('<strong>' + $returnDepDate.parent().find('label.dep-title').clone().children().remove().end().text() + '</strong>: ' + $mobileTravelDate);
			formDataValid = false;
			// formDataWhichFail.push('returndepdatemissing');
		} else {
			$returnDepDate.parent().parent().removeClass('has-error');
		}

		// Validation: return return date missing
		if ($returnRetDate.val() == '') {
			$returnRetDate.parent().parent().addClass('has-error');
			let $travelEndDate: any = $returnRetDate.attr('data-mobiletravelRetdate');
			$errorList.push('<strong>' + $returnRetDate.parent().find('label.ret-title').clone().children().remove().end().text() + '</strong>: ' + $travelEndDate);
			formDataValid = false;
			// formDataWhichFail.push('returnretdatemissing');
		} else {
			$returnRetDate.parent().parent().removeClass('has-error');
		}

		//Validation - LHR (minimum 5 nights)
		let $cabinClass = $instance.find('.cabin-class-mob').val();
		if ($mobFromLocation.val() != '' && $mobToLocation.val() != '' && $cabinClass == 'CFFBUS' && $returnDepDate.val() != '' && $returnRetDate.val() != '') {
			if ($mobFromLocation.val().split('_')[0].toUpperCase() === 'LHR' && $mobToLocation.val().split('-')[1].toUpperCase() === 'KUL') {
				let $formatDepDate: any = moment(new Date($returnDepDate.val()), 'DD/MM/YYYY');
				let $formatRetDate: any = moment(new Date($returnRetDate.val()), 'DD/MM/YYYY');
				if ($formatRetDate.diff($formatDepDate, 'days') < 5) {

					$returnDepDate.parent().parent().addClass('has-error');
					$returnRetDate.parent().parent().addClass('has-error');
					let $travelMinDate: any = $returnRetDate.attr('data-mobiletravelMinDays');
					$errorList.push('<strong>' + $returnRetDate.parent().find('label.ret-title').clone().children().remove().end().text() + ':</strong> ' + $travelMinDate);
					formDataValid = false;
				}
				else {
					$returnRetDate.parent().parent().removeClass('has-error');
					$returnDepDate.parent().parent().removeClass('has-error');
				}
			}

		}

		// Validation: no passengers selected
		if ($instance.find('.mob-flight-container input.total-tickets--value').val() == 0) {
			let $nopassengerMob: any = $instance.find('.mob-flight-container .total-tickets--value.mobile').attr('data-mob-passenger');
			$passengerDetails.addClass('has-errors');
			$errorList.push('<strong>' + $mobToLocation.parent().find('.booking-form--title').clone().children().remove().end().text() + '</strong>: ' + $nopassengerMob);
			formDataValid = false;
			// formDataWhichFail.push('nopsgselected');
		} else {
			$passengerDetails.removeClass('has-errors');
		}

		// Validation: infant booking
		// infants > adults
		if ($instance.find('.infant-booking--error---mobile').css('display') == 'block') {
			$passengerDetails.addClass('has-error');
			let $mobileMoreInfant: any = $instance.find('.infant-booking--error---mobile').attr('data-mobilemoreinfant');
			$errorList.push('<strong>' + $passengerDetails.find('.title-caption').clone().children().remove().end().text() + ' - ' + $passengerDetailsActive.find('.adult-cat .booking-category').text() + '</strong>: ' + $mobileMoreInfant);
			formDataValid = false;
			// formDataWhichFail.push('moreinfants');
		} else if ($instance.find('.adult-booking--error---mobile').css('display') == 'block') {
			// adults > infants
			$passengerDetails.addClass('has-error');
			let $mobileLessAdult: any = $instance.find('.adult-booking--error---mobile').attr('data-mobilelessadult');
			$errorList.push('<strong>' + $passengerDetails.find('.title-caption').clone().children().remove().end().text() + ' - ' + $passengerDetailsActive.find('.infant-cat .booking-category').text() + +'</strong>: ' + $mobileLessAdult);
			formDataValid = false;
			// formDataWhichFail.push('moreadults');
		} else {
			$passengerDetails.removeClass('has-error');
		}

		// let $childSelectedEle    = parseInt($instance.find('.mob-flight-container input[name="passengersChildren"]').val());
		// let $childBookingError:any   = $instance.find('.child-age-error');

		// if($childSelectedEle){
		// 	let $childAgeMsg =0;
		// 	for(var i= 1; i<= $childSelectedEle ; i++){
		// 		let $childAgeVal = $('.mob-flight-container #childAgeInput'+i).val();
		// 		if($childAgeVal<=0 && $childAgeMsg ==0){
		// 			$passengerDetails.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge');
		// 			$errorList.push('<strong>'+$passengerDetails.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}else if(($childAgeVal<1 || $childAgeVal >17) && $childAgeMsg ==0) {
		// 			$passengerDetails.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge-limit');
		// 			$errorList.push('<strong>'+$passengerDetails.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}
		// 		else{
		// 			$passengerDetails.removeClass('has-error');
		// 		}
		// 	}
		// }

		/* Adult infant limit check */
		let $adultCount = parseInt($instance.find('.mob-flight-container input[name="passengersAdult"]').val());
		let $childrenCount = parseInt($instance.find('.mob-flight-container input[name="passengersChildren"]').val());
		var adultChildComb = 0;
		var $childSel;
		for ($childSel = 1; $childSel <= $childrenCount; $childSel++) {
			var childAgeTemp = parseInt($('.mob-flight-container .mob-mholiday-passengers #childAgeInput' + $childSel).val());
			if (childAgeTemp < 2) {
				adultChildComb++;
			}
		}
		if ($childrenCount > 0) {
			if (adultChildComb > $adultCount) {
				$instance.find('.mob-flight-container .passenger-details').addClass('has-error');
				let $lessAdultInfant: any = $('.mob-flight-container .adult-booking--error---mobile').attr('data-adult-infant-limit');
				$errorList.push('<strong>' + $('.mob-flight-container [data-mob-mholidays-passenger-details]').find('.title-caption').clone().children().remove().end().text() + ':</strong> ' + $lessAdultInfant);
				formDataValid = false;
			} else {
				$instance.find('.mob-flight-container .passenger-details').removeClass('has-error');
			}
		}
		// submit and parse errors
		let $validationContainer: any = $errorValidation.find(".mobile-validation--content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist: any = $validationContainer;

		for (var i = 0, len = $errorList.length; i < len; i++) {
			$validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
			$errorValidation.hide();
		}

		// console.log(formDataValid);
		// console.log(formDataWhichFail);

		if (formDataValid && typeof callback === 'function') {
			callback($officeCode);
		} else { return false; }
	}
	mholidaysMobileHotelValidation($instance: any, $officeCode: any, callback: any): any {
		//checkinCheckout	
		let _self = this;
		let formDataValid = true;

		let $errorList: Array<any> = [];
		let $errorValidation = $instance.find('.error-validation').first();
		let $passengerDetails: any = $instance.find('.mob-hotel-container [data-mob-mholidays-passenger-details]');
		let $passengerDetailsActive: any = $instance.find('.mob-hotel-container [data-mob-mholidays-passenger-details-selected]');

		$errorValidation.show();

		let $hotelInputVal: any = $instance.find('#hotelInputVal');
		//$fromBookingTitle:any = $fromLocation.parent().find('.booking-form--title'),
		let $hotelInputClass: any = $instance.find('.hotelInputClass');
		if ($hotelInputVal.val() == '') {
			//	$fromSelectize.addClass('has-error');
			$hotelInputClass.addClass('has-error');
			let $hotelValidate: any = $hotelInputVal.attr('data-hotelMsg');
			$errorList.push('<strong>' + $hotelInputVal.parent().find('label').text() + ':</strong> ' + $hotelValidate);
			formDataValid = false;
		} else {
			//	$fromSelectize.removeClass('has-error');
			$hotelInputClass.removeClass('has-error');
		}
		let $oneWayTripEl: any = $instance.find('.trip-type--container .oneWayTrip'),
			$oneWayDepDate: any = $instance.find('.oneWayTrip .departureDateMobile'),
			$returnDepDate: any = $instance.find('.mob-hotel-container .departureDateMobile'),
			$returnRetDate: any = $instance.find('.mob-hotel-container .returnDateMobile');

		// Validation: return way departure date missing
		if ($returnDepDate.val() == '') {
			$returnDepDate.parent().parent().addClass('has-error');
			let $mobileTravelDate: any = $returnDepDate.attr('data-mobiletravelDepdate');
			$errorList.push('<strong>' + $returnDepDate.parent().find('label.dep-title').text() + '</strong>: ' + $mobileTravelDate);
			formDataValid = false;
			// formDataWhichFail.push('returndepdatemissing');
		} else {
			$returnDepDate.parent().parent().removeClass('has-error');
		}

		// Validation: return return date missing
		if ($returnRetDate.val() == '') {
			$returnRetDate.parent().parent().addClass('has-error');
			let $travelEndDate: any = $returnRetDate.attr('data-mobiletravelRetdate');
			$errorList.push('<strong>' + $returnRetDate.parent().find('label.ret-title').text() + '</strong>: ' + $travelEndDate);
			formDataValid = false;
			// formDataWhichFail.push('returnretdatemissing');
		} else {
			$returnRetDate.parent().parent().removeClass('has-error');
		}
		if ($instance.find('.adult-booking--error---mobile').css('display') == 'block') {
			// adults > infants
			$passengerDetails.addClass('has-error');
			let $mobileLessAdult: any = $instance.find('.adult-booking--error---mobile').attr('data-mobilelessadult');
			$errorList.push('<strong>' + $passengerDetails.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.infant-cat .booking-category').text() + +'</strong>: ' + $mobileLessAdult);
			formDataValid = false;
			// formDataWhichFail.push('moreadults');
		} else {
			$passengerDetails.removeClass('has-error');
		}

		// let $childSelectedEle    = parseInt($instance.find('.mob-hotel-container input[name="passengersChildren"]').val());
		// let $childBookingError:any   = $instance.find('.child-age-error');

		// if($childSelectedEle){
		// 	let $childAgeMsg =0;
		// 	for(var i= 1; i<= $childSelectedEle ; i++){
		// 		let $childAgeVal = $('.mob-hotel-container #childAgeInput'+i).val();
		// 		if($childAgeVal<=0 && $childAgeMsg ==0){
		// 			$passengerDetails.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge');
		// 			$errorList.push('<strong>'+$passengerDetails.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}else if(($childAgeVal<1 || $childAgeVal >17) && $childAgeMsg ==0) {
		// 			$passengerDetails.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge-limit');
		// 			$errorList.push('<strong>'+$passengerDetails.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}
		// 		else{
		// 			$passengerDetails.removeClass('has-error');
		// 		}
		// 	}
		// }

		/* Adult infant limit check */
		let $adultCount = parseInt($instance.find('.mob-hotel-container input[name="passengersAdult"]').val());
		let $childrenCount = parseInt($instance.find('.mob-hotel-container input[name="passengersChildren"]').val());
		var adultChildComb = 0;
		var $childSel;
		for ($childSel = 1; $childSel <= $childrenCount; $childSel++) {
			var childAgeTemp = parseInt($('.mob-hotel-container #childAgeInput' + $childSel).val());
			if (childAgeTemp < 2) {
				adultChildComb++;
			}
		}
		if ($childrenCount > 0) {
			if (adultChildComb > $adultCount) {
				$instance.find('.mob-hotel-container .passenger-details').addClass('has-error');
				let $lessAdultInfant: any = $('.mob-hotel-container .adult-booking--error---mobile').attr('data-adult-infant-limit');
				$errorList.push('<strong>' + $('.mob-hotel-container [data-mob-mholidays-passenger-details]').find('.title-caption').text() + ':</strong> ' + $lessAdultInfant);
				formDataValid = false;
			} else {
				$instance.find('.mob-hotel-container .passenger-details').removeClass('has-error');
			}
		}
		// submit and parse errors
		let $validationContainer: any = $errorValidation.find(".mobile-validation--content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist: any = $validationContainer;

		for (var i = 0, len = $errorList.length; i < len; i++) {
			$validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
			$errorValidation.hide();
		}

		// console.log(formDataValid);
		// console.log(formDataWhichFail);

		if (formDataValid && typeof callback === 'function') {
			callback($officeCode);
		} else { return false; }
	}
	readValueFromCookie(name: string): any {
		var json = "";
		var ca = document.cookie.split(';');
		name = name + "=";
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			};
		}
		return json;
	}

	getAdobeTargetValue() {
		let _self = this;
		//Adobe target value appending
		let externalId = _self.readValueFromCookie('External_Id1');
		let adoTargetUrl = _self.readValueFromCookie('ADO_target_URL');
		if (externalId) {
			adoTargetUrl = adoTargetUrl.split(',');
			if (adoTargetUrl.length > 0) {
				let k;
				for (k = 0; k < adoTargetUrl.length; k++) {
					if (adoTargetUrl[k].indexOf('*') > 0) {
						var adoUrlPart = adoTargetUrl[k].split('*');
						if (window.location.href.indexOf(adoUrlPart[0]) != -1) {
							//set external id
							return externalId;
						}
					} else {
						if (window.location.href.indexOf(adoTargetUrl[k]) != -1) {
							//set external id
							return externalId;
						}
					}
				}
			}
		}
		return false;
	}
	mholidaysDeeplinknew($instance: any): any {
		let $departureStationCode = $instance.find('.mholidays-ibe-from--location').val().split('_')[0];
		let $arrivalCityCode = $instance.find('.mholidays-ibe-to--location').val();
		let $departureStationName = $instance.find('.mholidays-ibe-from--location option').text();
		let $arrivalCityName = $instance.find('.mholidays-ibe-to--location option').text();
		let mhHolidaysDeeplinkBaseURL = $('#mhHolidaysDeeplinkBaseURL').val();
		let $arrivalCityCodeArray: any = $arrivalCityCode.split('-');
		if ($arrivalCityCodeArray.length == 2) {
			$arrivalCityCode = $arrivalCityCodeArray[1];
		}
		else {
			$arrivalCityCode = $arrivalCityCodeArray[0];
		}
		let $getDepartureDate: any;
		let $getReturnDate: any;

		let mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL + '/package/search';

		$getDepartureDate = $instance.find('.returnTrip .departureDate').val();

		if ($('.enrich-revamp .date-mholidays-ipad-container').is(':visible')) {
			$getDepartureDate = $instance.find('.date-mholidays-ipad-container .returnTrip .departureDate').val();
		}

		let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
		$getReturnDate = $instance.find('.returnTrip .returnDate').val();
		if ($('.enrich-revamp .date-mholidays-ipad-container').is(':visible')) {
			$getReturnDate = $instance.find('.date-mholidays-ipad-container .returnTrip .returnDate').val();
		}
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');
		let $childSel: any, $infantSel: any;

		let $adultCount = parseInt($instance.find('.flight-container .ticket-adult--input1').val());
		let $childCount = parseInt($instance.find('.flight-container .passengersChildren').val());
		var InfantCount = 0;
		var childCount = 0;
		// Room count 
		let room2Adult: any = parseInt($instance.find('.flight-container .ticket-adult--input2').val()) || 0;
		let room3Adult: any = parseInt($instance.find('.flight-container .ticket-adult--input3').val()) || 0;
		let totalRoomCount: any = 1;
		if (room2Adult > 0) {
			totalRoomCount++;
		} if (room3Adult > 0) {
			totalRoomCount++;
		}
		let $cabinClass = $instance.find('.cabin-class').val()
		if ($cabinClass == "CFFFIRST") {
			$cabinClass = "3"
		}
		else if ($cabinClass == "CFFBUS") {
			$cabinClass = "2"
		}
		else if ($cabinClass == "CFFECO") {
			$cabinClass = "1"
		}
		let $currencyCode = $("#currencyCode").val();
		let $data = {
			'From': $departureStationCode,
			'To': $arrivalCityCode,
			'DepartureDate': $departureDate,
			'ReturnDate': $returnDate,
			'CabinClass': $cabinClass,
			'CultureCode': 'en-US',
			'Currency': $currencyCode,
			'JourneyType': '1',
			'RoomCount': totalRoomCount,
			'ProductId': 'f4fc4fdf-39ef-4978-ac62-3be1a42267c7'
		}

		/* Room 1 ,2,3, Pax details*/
		let adultCntArray: Array<any> = [];
		let childCntArray: Array<any> = [];
		let infantCntArray: Array<any> = [];

		adultCntArray.push(parseInt($instance.find('.flight-container .ticket-adult--input1').val()) || 0);
		adultCntArray.push(parseInt($instance.find('.flight-container .ticket-adult--input2').val()) || 0);
		adultCntArray.push(parseInt($instance.find('.flight-container .ticket-adult--input3').val()) || 0);

		childCntArray.push(parseInt($instance.find('.flight-container .ticket-child--input').val()) || 0);
		childCntArray.push(parseInt($instance.find('.flight-container .ticket-child--input2').val()) || 0);
		childCntArray.push(parseInt($instance.find('.flight-container .ticket-child--input3').val()) || 0);

		infantCntArray.push(parseInt($instance.find('.flight-container .ticket-infant--input').val()) || 0);
		infantCntArray.push(parseInt($instance.find('.flight-container .ticket-infant--input2').val()) || 0);
		infantCntArray.push(parseInt($instance.find('.flight-container .ticket-infant--input3').val()) || 0);

		for (var k = 0; k < 3; k++) {
			var j = k + 1;
			var m = 0;
			if (adultCntArray[k] > 0) {
				$data['PaxInfos[' + k + '].AdultCount'] = adultCntArray[k];
				if (infantCntArray[k] > 0) {
					$data['PaxInfos[' + k + '].InfantCount'] = infantCntArray[k];
				}
				if (childCntArray[k] > 0) {
					$data['PaxInfos[' + k + '].ChildCount'] = childCntArray[k];
					$data['PaxInfos[' + k + '].ChildAges'] = [];
					var childcount = 0;
					for ($childSel = 1; $childSel <= childCntArray[k]; $childSel++) {

						var childAgeTemp = $('.room' + j + ' #childAgeInput' + $childSel).val();
						{
							$data['PaxInfos[' + k + '].ChildAges[' + childcount + ']'] = childAgeTemp;
							childcount++
						}
					}
				}
			}
		}

		let $tripFlowUrl = $.param($data);

		let $tripflow_encryptURL = mhholidaysTripFlowUrl + '?' + $tripFlowUrl;
		console.log("##Redirect URL: " + $tripflow_encryptURL);
		window.location.href = $tripflow_encryptURL;

	}

	mholidaysDeeplink($instance: any): any {
		let $departureStationCode = $instance.find('.mholidays-ibe-from--location').val().split('_')[0];
		let $arrivalCityCode = $instance.find('.mholidays-ibe-to--location').val();
		let $departureStationName = $instance.find('.mholidays-ibe-from--location option').text();
		let $arrivalCityName = $instance.find('.mholidays-ibe-to--location option').text();
		let $arrivalCityCodeArray: any = $arrivalCityCode.split('-');
		let $getDepartureDate: any;
		let currencyCode = $("#currencyCode").val();
		let mhholidaysTripFlowUrl = $("#mhholidaysTripFlowUrl").val();

		$getDepartureDate = $instance.find('.returnTrip .departureDate').val();

		let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
		let $getReturnDate = $instance.find('.returnTrip .returnDate').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');
		let $childSel: any, $infantSel: any;

		let $adultCount = parseInt($instance.find('.flight-container .passengersAdult').val());
		let $childCount = parseInt($instance.find('.flight-container .passengersChildren').val());

		let $data = {
			engine: 'package',
			DateType: 'exact',
			Adults: $adultCount,
			travelTypel: 'package',
			priceType: 'bothTotal',
			Price: '0-10000',
			RatingName: 'overallAverageRating',
			RatingOperator: 'ge',
			SortingOrder: 'categoryDESC',
			grouped: '1',
			init: '1',
			DurationMin: 'range'
		}

		if ($childCount > 0) {
			$data['Children'] = $childCount;
		}

		$departureStationName = $departureStationName.split(',');
		$departureStationName = $departureStationName[0];
		$departureStationName = $departureStationName.replace(/\s+/g, '+');
		$arrivalCityName = $arrivalCityName.split(',');
		$arrivalCityName = $arrivalCityName[0];
		$arrivalCityName = $arrivalCityName.replace(/\s+/g, '+');
		$data['DepartureAirports'] = {};
		$data['DepartureAirports'][$departureStationName] = $departureStationCode;

		//Set region for penang, Bali and Phuket
		if ($arrivalCityCode !== "") {
			if ($arrivalCityCodeArray[1] == 'PEN') {
				$data['Region'] = {};
				$data['Region'][$arrivalCityName] = $arrivalCityCodeArray[0];
			} else if ($arrivalCityCodeArray[1] === 'DPS') {
				$data['Region'] = {};
				$data['Region'][$arrivalCityName.split('-')[1]] = '1182';
			} else if ($arrivalCityCodeArray[1] === 'HKT') {
				$data['Region'] = {};
				$data['Region'][$arrivalCityName] = '10427222';
			} else {
				$data['City'] = {};
				$data['City'][$arrivalCityName] = $arrivalCityCodeArray[0];
			}
		}

		$data['Rating'] = {};
		$data['Child'] = {};
		for ($childSel = 1; $childSel <= $childCount; $childSel++) {
			$data['Child'][$childSel - 1] = $('.flight-container #childAgeInput' + $childSel).val();
		}

		let $tripFlowUrl = $.param($data);
		$tripFlowUrl = $tripFlowUrl.replace(/%2B/g, '+');
		$tripFlowUrl = $tripFlowUrl.replace(/-+/g, '%2C');

		let $tripflow_encryptURL = mhholidaysTripFlowUrl + currencyCode.toLowerCase() + '?DepartureDate=' + $departureDate + '&ReturnDate=' + $returnDate + '&' + $tripFlowUrl;
		console.log("##Redirect URL: " + $tripflow_encryptURL);
		window.location.href = $tripflow_encryptURL;

	}

	mobileMholidaysDeeplink($instance: any): any {
		let $departureStationCode = $instance.find('.ibe-mob-from--location').val().split('_')[0];
		let $arrivalCityCode = $instance.find('.ibe-mob-to--location').val();
		let $arrivalCityCodeArray: any = $arrivalCityCode.split('-');
		if ($arrivalCityCodeArray.length == 2) {
			$arrivalCityCode = $arrivalCityCodeArray[1];
		}
		else {
			$arrivalCityCode = $arrivalCityCodeArray[0];
		}
		let $getDepartureDate: any;
		let mhHolidaysDeeplinkBaseURL = $('#mhHolidaysDeeplinkBaseURL').val();
		let mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL + '/package/search';

		$getDepartureDate = $instance.find('.departureDateMobile').val();
		let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
		let $getReturnDate = $instance.find('.returnDateMobile').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');

		let $childSel: any, $infantSel: any;
		// Room count 
		let room2Adult: any = parseInt($instance.find('.mob-flight-container .ticket-adult--input2').val()) || 0;
		let room3Adult: any = parseInt($instance.find('.mob-flight-container .ticket-adult--input3').val()) || 0;
		let totalRoomCount: any = 1;
		if (room2Adult > 0) {
			totalRoomCount++;
		} if (room3Adult > 0) {
			totalRoomCount++;
		}
		let $cabinClass = $instance.find('.cabin-class-mob').val()
		if ($cabinClass == "CFFFIRST") {
			$cabinClass = "3"
		}
		else if ($cabinClass == "CFFBUS") {
			$cabinClass = "2"
		}
		else if ($cabinClass == "CFFECO") {
			$cabinClass = "1"
		}
		let $currencyCode = $("#currencyCode").val();
		let $data = {
			'From': $departureStationCode,
			'To': $arrivalCityCode,
			'DepartureDate': $departureDate,
			'ReturnDate': $returnDate,
			'CabinClass': $cabinClass,
			'CultureCode': 'en-US',
			'Currency': $currencyCode,
			'JourneyType': '1',
			'RoomCount': totalRoomCount,
			'ProductId': 'f4fc4fdf-39ef-4978-ac62-3be1a42267c7'
		}

		/* Room 1 ,2,3, Pax details*/
		let adultCntArray: Array<any> = [];
		let childCntArray: Array<any> = [];
		let infantCntArray: Array<any> = [];

		adultCntArray.push(parseInt($instance.find('.mob-flight-container .ticket-mob-adult--input').val()) || 0);
		adultCntArray.push(parseInt($instance.find('.mob-flight-container .ticket-mob-adult--input2').val()) || 0);
		adultCntArray.push(parseInt($instance.find('.mob-flight-container .ticket-mob-adult--input3').val()) || 0);

		childCntArray.push(parseInt($instance.find('.mob-flight-container .ticket-mob-child--input').val()) || 0);
		childCntArray.push(parseInt($instance.find('.mob-flight-container .ticket-mob-child--input2').val()) || 0);
		childCntArray.push(parseInt($instance.find('.mob-flight-container .ticket-mob-child--input3').val()) || 0);

		infantCntArray.push(parseInt($instance.find('.mob-flight-container .ticket-infant--input').val()) || 0);
		infantCntArray.push(parseInt($instance.find('.mob-flight-container .ticket-infant--input2').val()) || 0);
		infantCntArray.push(parseInt($instance.find('.mob-flight-container .ticket-infant--input3').val()) || 0);

		for (var k = 0; k < 3; k++) {
			var j = k + 1;
			var m = 0;
			if (adultCntArray[k] > 0) {
				$data['PaxInfos[' + k + '].AdultCount'] = adultCntArray[k];
				if (infantCntArray[k] > 0) {
					$data['PaxInfos[' + k + '].InfantCount'] = infantCntArray[k];
				}
				if (childCntArray[k] > 0) {
					$data['PaxInfos[' + k + '].ChildCount'] = childCntArray[k];
					$data['PaxInfos[' + k + '].ChildAges'] = [];
					var childcount = 0;
					for ($childSel = 1; $childSel <= childCntArray[k]; $childSel++) {

						var childAgeTemp = $('.room' + j + ' #childAgeInput' + $childSel).val();
						{
							$data['PaxInfos[' + k + '].ChildAges[' + childcount + ']'] = childAgeTemp;
							childcount++
						}
					}
				}
			}
		}

		let $tripFlowUrl = $.param($data);

		let $tripflow_encryptURL = mhholidaysTripFlowUrl + '?' + $tripFlowUrl;
		console.log("##Redirect URL: " + $tripflow_encryptURL);
		window.location.href = $tripflow_encryptURL;
	}

	mholidaysHotelDeeplink($instance: any): any {
		let $hotelInputtoVal: any = $instance.find('#hotelInputtoVal').val();
		let $hotelInputVal: any = $instance.find('#hotelInputVal').val();
		let $getDepartureDate = $instance.find('.checkinCheckout .departureDate').val();

		let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
		let $getReturnDate = $instance.find('.checkinCheckout .returnDate').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');
		let $childSel: any, $infantSel: any;
		let currencyCode = $("#currencyCode").val();
		let mhHolidaysDeeplinkBaseURL = $('#mhHolidaysDeeplinkBaseURL').val();
		let mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL + '/package/start-search';
		let $CultureCode = 'en-US';
		let $adultCount = parseInt($instance.find('.hotel-container .passengersAdult').val());
		let $childCount = parseInt($instance.find('.hotel-container .passengersChildren').val());

		var InfantCount = 0;
		var childCount = 0;
		let totalRoomCount: any = 1;
		let $currencyCode = $("#currencyCode").val();
		if (!$('.hotel-container #roomtwo_hoteldetails').hasClass('hide')) {
			totalRoomCount++;
		}
		if (!$('.hotel-container #roomthre_hoteldetails').hasClass('hide')) {
			totalRoomCount++;
		}
		let $data = {
			To: $hotelInputtoVal,
			CultureCode: $CultureCode,
			DepartureDate: $departureDate,
			ReturnDate: $returnDate,
			Currency: $currencyCode,
			'RoomCount': totalRoomCount,
			'hotelcode': $hotelInputVal,
			'ProductId': 'a3fe407a-2347-40cd-90b7-7d18b1a1fdc3'
		}

		/* Room 1 ,2,3, Pax details*/
		let adultCntArray: Array<any> = [];
		let childCntArray: Array<any> = [];
		let infantCntArray: Array<any> = [];

		adultCntArray.push(parseInt($instance.find('.hotel-container .ticket-adult--input1').val()) || 0);
		if (!$('.hotel-container #roomtwo_hoteldetails').hasClass('hide')) {
			adultCntArray.push(parseInt($instance.find('.hotel-container .ticket-adult--input2').val()) || 0);
		}
		if (!$('.hotel-container #roomthre_hoteldetails').hasClass('hide')) {
			adultCntArray.push(parseInt($instance.find('.hotel-container .ticket-adult--input3').val()) || 0);
		}



		childCntArray.push(parseInt($instance.find('.hotel-container .ticket-child--input').val()) || 0);
		childCntArray.push(parseInt($instance.find('.hotel-container .ticket-child--input2').val()) || 0);
		childCntArray.push(parseInt($instance.find('.hotel-container .ticket-child--input3').val()) || 0);

		infantCntArray.push(parseInt($instance.find('.hotel-container .ticket-infant--input').val()) || 0);
		infantCntArray.push(parseInt($instance.find('.hotel-container .ticket-infant--input2').val()) || 0);
		infantCntArray.push(parseInt($instance.find('.hotel-container .ticket-infant--input3').val()) || 0);

		for (var k = 0; k < 3; k++) {
			var j = k + 1;
			var m = 0;
			if (adultCntArray[k] > 0) {
				$data['PaxInfos[' + k + '].AdultCount'] = adultCntArray[k];
				if (infantCntArray[k] > 0) {
					$data['PaxInfos[' + k + '].InfantCount'] = infantCntArray[k];
				}
				if (childCntArray[k] > 0) {
					$data['PaxInfos[' + k + '].ChildCount'] = childCntArray[k];
					$data['PaxInfos[' + k + '].ChildAges'] = [];
					var childcount = 0;
					for ($childSel = 1; $childSel <= childCntArray[k]; $childSel++) {

						var childAgeTemp = $('.room' + j + ' #childAgeInput' + $childSel).val();
						{
							$data['PaxInfos[' + k + '].ChildAges'][childcount] = childAgeTemp;
							childcount++
						}
					}
				}
			}
		}

		let $tripFlowUrl = $.param($data);
		let $tripflow_encryptURL = mhholidaysTripFlowUrl + '?' + $tripFlowUrl;
		console.log("##Redirect URL: " + $tripflow_encryptURL);
		window.location.href = $tripflow_encryptURL;
	}
	mobileMholidaysHotelDeeplink($instance: any): any {
		let $hotelInputtoVal: any = $instance.find('#hotelInputtoVal').val();
		let $hotelInputVal: any = $instance.find('#hotelInputVal').val();
		let $CultureCode = 'en-US';
		let mhHolidaysDeeplinkBaseURL = $('#mhHolidaysDeeplinkBaseURL').val();
		let mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL + '/package/start-search';

		let $getDepartureDate = $('.mob-hotel-container .departureDateMobile').val()
		let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
		let $getReturnDate = $('.mob-hotel-container .returnDateMobile').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');
		let $childSel: any,
			$infantSel: any;
		let totalRoomCount: any = 1;
		let $currencyCode = $("#currencyCode").val();
		if (!$('.mob-hotel-container .room2').hasClass('hide')) {
			totalRoomCount++;
		}
		if (!$('.mob-hotel-container .room3').hasClass('hide')) {
			totalRoomCount++;
		}
		let $data = {
			To: $hotelInputtoVal,
			DepartureDate: $departureDate,
			ReturnDate: $returnDate,
			CultureCode: $CultureCode,
			Currency: $currencyCode,
			'hotelcode': $hotelInputVal,
			'RoomCount': totalRoomCount,
			'ProductId': 'a3fe407a-2347-40cd-90b7-7d18b1a1fdc3'
		}

		/* Room 1 ,2,3, Pax details*/
		let adultCntArray: Array<any> = [];
		let childCntArray: Array<any> = [];
		let infantCntArray: Array<any> = [];

		adultCntArray.push(parseInt($instance.find('.mob-hotel-container .ticket-mob-adult--input').val()) || 0);
		if (!$('.mob-hotel-container #roomone_details_hotelmob').hasClass('hide')) {
			adultCntArray.push(parseInt($instance.find('.mob-hotel-container .ticket-mob-adult--input2').val()) || 0);
		}
		if (!$('.mob-hotel-container #roomthre_hoteldetails').hasClass('hide')) {
			adultCntArray.push(parseInt($instance.find('.mob-hotel-container .ticket-mob-adult--input3').val()) || 0);
		}



		childCntArray.push(parseInt($instance.find('.mob-hotel-container .ticket-mob-child--input').val()) || 0);
		childCntArray.push(parseInt($instance.find('.mob-hotel-container .ticket-mob-child--input2').val()) || 0);
		childCntArray.push(parseInt($instance.find('.mob-hotel-container .ticket-mob-child--input3').val()) || 0);

		infantCntArray.push(parseInt($instance.find('.mob-hotel-container .ticket-infant--input').val()) || 0);
		infantCntArray.push(parseInt($instance.find('.mob-hotel-container .ticket-infant--input2').val()) || 0);
		infantCntArray.push(parseInt($instance.find('.mob-hotel-container .ticket-infant--input3').val()) || 0);

		for (var k = 0; k < 3; k++) {
			var j = k + 1;
			var m = 0;
			if (adultCntArray[k] > 0) {
				$data['PaxInfos[' + k + '].AdultCount'] = adultCntArray[k];
				if (infantCntArray[k] > 0) {
					$data['PaxInfos[' + k + '].InfantCount'] = infantCntArray[k];
				}
				if (childCntArray[k] > 0) {
					$data['PaxInfos[' + k + '].ChildCount'] = childCntArray[k];
					$data['PaxInfos[' + k + '].ChildAges'] = [];
					var childcount = 0;
					for ($childSel = 1; $childSel <= childCntArray[k]; $childSel++) {

						var childAgeTemp = $('.room' + j + ' #childAgeInput' + $childSel).val();
						{
							$data['PaxInfos[' + k + '].ChildAges'][childcount] = childAgeTemp;
							childcount++
						}
					}
				}
			}
		}
		let $tripFlowUrl = $.param($data);
		let $tripflow_encryptURL = mhholidaysTripFlowUrl + '?' + $tripFlowUrl;
		console.log("##Redirect URL: " + $tripflow_encryptURL);
		window.location.href = $tripflow_encryptURL;
	}
	/**
	 * Form submission for single trip booking
	 * - one way or return
	 * @return {any} [description]
	 */
	singleBookingFormSubmit($instance: any, directLogin: any, additionalParam: any, redemptionType: any, $officeCode: any): any {
		let _self = this;

		let formData: any = $instance.find('[data-form-booking--trip]').serializeArray();
		let formObj: any = {};
		if ($("#travel_pass").length == 0) {
			_self.adobeDataLayer.push('click', {
				'clickName': 'click:btn-click:flights-book-now',
				'componentType': 'btn',
				'componentName': 'Book Now',
				'componentID': null,
				'attributes': []
			});
		}

		$(formData).each(function (i: any, field: any) {
			formObj[field.name] = field.value;
		});

		// Get the user-defined values
		let $couponCode: string;
		let $fromLocation = $instance.find('.ibe-from--location').val().split('_')[0];
		let $toLocation = $instance.find('.ibe-to--location').val().split('|')[0];
		let $paramCug = $('#search-param-cug').val();
		let $tripType = $instance.find('.trip-type--container li.selected a').attr('data-triptype');
		let $getDepartureDate: any;

		if ($tripType == 'R') {
			if ($('.enrich-revamp .date-ipad-container').is(':visible')) {
				$getDepartureDate = $instance.find('.date-ipad-container .returnTrip .departureDate').val();
			}
			else {
				$getDepartureDate = $instance.find('.returnTrip .departureDate').val();
			}
		} else {
			if ($('.enrich-revamp .date-ipad-container').is(':visible')) {
				$getDepartureDate = $instance.find('.date-ipad-container .oneWayTrip .departureDate').val();
			}
			else {
				$getDepartureDate = $instance.find('.oneWayTrip .departureDate').val();
			}
		}

		let $departureDate = moment(new Date($getDepartureDate)).format('YYYYMMDDhhmm');
		let $getReturnDate: any;
		$getReturnDate = $instance.find('.returnDate').val();
		if ($('.enrich-revamp .date-ipad-container').is(':visible')) {
			$getReturnDate = $instance.find('.date-ipad-container .returnDate').val();
		}
		let $returnDate = moment(new Date($getReturnDate)).format('YYYYMMDDhhmm');
		let $cabinClass = $instance.find('.cabin-class').val()

		let $adultSel: any,
			$teenagerSel: any,
			$childSel: any,
			$infantSel: any;

		let $adultSelectedEle = parseInt($instance.find('.passengersAdult').val());
		let $teenageSelectedEle = parseInt($instance.find('input[name="passengersTeenager"]').val());
		let $childSelectedEle = parseInt($instance.find('.passengersChildren').val());
		let $infantSelectedEle = parseInt($instance.find('.passengersInfant').val());
		let $oneWayTripLink = $instance.find('.trip-type--container li.oneWayTrip');

		if ($oneWayTripLink.hasClass('selected')) {
			$returnDate = '';
		} else {
			if (!$getReturnDate) return;
		}

		let athleteId = document.cookie.match('(^|;)\\s*athleteId\\s*=\\s*([^;]+)');
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFSTUBUS"
			}
			if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFSTUECO"
			}
		}
		if (redemptionType == "cash_miles") {
			if ($cabinClass == "CFFFIRST") {
				$cabinClass = "CFFFMC"
			}
			else if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFJMC"
			}
			else if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFYMC"
			}
		} else if (redemptionType == "miles") {
			if ($cabinClass == "CFFFIRST") {
				$cabinClass = "CFFFMILES"
			}
			else if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFJMILES"
			}
			else if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFYMILES"
			}
		}

		// mh sports changes as per tkt no : 29941
		if (athleteId) {
			if ($cabinClass == "CFFFIRST") {
				$cabinClass = "CFFFSPORT";
			} else if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFJSPORT";
			} else if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFYSPORT";
			}
		}
		// end

		let couponCookieVal = document.cookie.match('(^|;)\\s*corpCode\\s*=\\s*([^;]+)');
		if (couponCookieVal != null) {
			$couponCode = couponCookieVal ? couponCookieVal.pop() : '';
			document.cookie = 'corpCode' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		} else {
			$couponCode = $instance.find('.couponcode-input').val();
		}
		let $targetVal = _self.getAdobeTargetValue();
		let $externalId;
		if ($targetVal) {
			$externalId = $targetVal;
		} else {
			$externalId = 'BOOKING';
		}

		let $data = {
			ARRANGE_BY: 'R',
			BOOKING_FLOW: 'REVENUE',
			B_ANY_TIME_1: 'TRUE',
			B_ANY_TIME_2: 'TRUE',
			B_DATE_1: ($departureDate == 'Invalid date' ? '' : $departureDate),
			B_DATE_2: ($returnDate == 'Invalid date' ? '' : $returnDate),
			B_LOCATION_1: $fromLocation,
			B_LOCATION_2: $toLocation,
			COMMERCIAL_FARE_FAMILY_1: $cabinClass,
			COMMERCIAL_FARE_FAMILY_2: '',
			COMMERCIAL_FARE_FAMILY_3: '',
			DATE_RANGE_QUALIFIER_1: 'C',
			DATE_RANGE_QUALIFIER_2: 'C',
			DATE_RANGE_VALUE_1: '3',
			DATE_RANGE_VALUE_2: '3',
			DISPLAY_TYPE: '2',
			EMBEDDED_TRANSACTION: 'FlexPricerAvailability',
			EXTERNAL_ID: $externalId,
			E_LOCATION_1: $toLocation,
			E_LOCATION_2: $fromLocation,
			HAS_INFANT_1: 'FALSE',
			HAS_INFANT_2: 'FALSE',
			HAS_INFANT_3: 'FALSE',
			HAS_INFANT_4: 'FALSE',
			HAS_INFANT_5: 'FALSE',
			HAS_INFANT_6: 'FALSE',
			HAS_INFANT_7: 'FALSE',
			HAS_INFANT_8: 'FALSE',
			HAS_INFANT_9: 'FALSE',
			PRICING_TYPE: 'O',
			REFRESH: '0',
			SITE: 'desktop',
			// SO_SITE_SI_1AXML_FROM: 'SEP_JCP',
			// SO_SITE_SI_PASSWORD: 'UNSET',
			// SO_SITE_SI_SAP: '1ASIXJCP',
			// SO_SITE_SI_SERVER_IP: '193.23.185.67',
			// SO_SITE_SI_SERVER_PORT: '18033',
			// SO_SITE_SI_USER: 'UNSET',
			// SO_SITE_APIV2_SERVER: '194.156.170.78',
			// SO_SITE_APIV2_SERVER_PWD: 'TAZ',
			// SO_SITE_APIV2_SERVER_USER_ID: 'GUEST',
			// SO_SITE_CORPORATE_ID: 'OCGPDT',
			// SO_SITE_EXT_MerchantID: '',
			// SO_SITE_EXT_PSPURL: '',
			// SO_SITE_FP_ELEM_LEV_FF_DISP: 'TRUE',
			// SO_SITE_FP_SEG_FLIGHT_TIME: 'TRUE',
			// SO_SITE_FP_TRACES_ON: 'FALSE',
			// SO_SITE_FQ_INTERFACE_ACTIVE: 'FALSE',
			// SO_SITE_HOST_TRACE_ACTIVE: 'TRUE',
			// SO_SITE_NEW_UI_ENABLED: 'TRUE',
			// SO_SITE_NEW_UI_LIST_TPLS_ON: 'ALL',
			SO_SITE_OFFICE_ID: $officeCode,
			// SO_SITE_PNR_SHARING: 'TRUE',
			// SO_SITE_RUI_AX_TIMR_ENABLED: 'TRUE',
			// SO_SITE_QUEUE_CATEGORY: '0C0',
			SO_SITE_QUEUE_OFFICE_ID: $officeCode,
			// SO_SITE_RUI_AX_CAL_ENABLED: 'TRUE',
			// SO_SITE_RUI_CAL_HORIZ_DEPAR: 'TRUE',
			// SO_SITE_RUI_ENABLE_IMPL_DATA: 'TRUE',
			// SO_SITE_RUI_FARE_VERTICAL: 'FALSE',
			// SO_SITE_RUI_HIDE_MDF_SRC: 'TRUE',
			// SO_SITE_SEATMAP_POPOVER_DISP: 'TRUE',
			// SO_SITE_SI_1AXML_FROM: 'SEP_JCP',
			// SO_SITE_SI_PASSWORD: 'UNSET',
			// SO_SITE_SI_SAP: '1ASIXJCP',
			// SO_SITE_SI_SERVER_IP: '193.23.185.67',
			// SO_SITE_SI_SERVER_PORT: '18033',
			// SO_SITE_SI_USER: 'UNSET',
			// SO_SITE_SPECIAL_REQ_NUMBER: '3',
			// SO_SITE_STORE_ITINERARIES: 'TRUE',
			TRAVELLER_TYPE_1: '',
			TRAVELLER_TYPE_2: '',
			TRAVELLER_TYPE_3: '',
			TRAVELLER_TYPE_4: '',
			TRAVELLER_TYPE_5: '',
			TRAVELLER_TYPE_6: '',
			TRAVELLER_TYPE_7: '',
			TRAVELLER_TYPE_8: '',
			TRAVELLER_TYPE_9: '',
			TRIP_FLOW: 'YES',
			TRIP_TYPE: $tripType,
			ADULT_COUNT: $adultSelectedEle,
			CHILD_COUNT: $childSelectedEle,
			// YOUTH_COUNT: $youthSelectedEle,
			INFANT_COUNT: $infantSelectedEle,
			param_cug: $paramCug,
			RDM_MEM_ID: formObj['redemption_member_id'],
			RDM_MEM_LN: formObj['redemption_member_lastname'],
			RDM_MEM_PIN: formObj['redemption_member_pin'],
			RDM_PAYMENT: $instance.find('input[name="cash_miles_type"]:checked').val()
		};
		let adobeCookieExist: any = Cookies.get('TeaserCategory');
		if (adobeCookieExist != undefined) {
			$data['TeaserCategory'] = adobeCookieExist;
		}
		let adobeCookieExistSiteMcpAvailDisp: any = Cookies.get('SO_SITE_MCP_AVAIL_DISP');
		if (adobeCookieExistSiteMcpAvailDisp != undefined) {
			$data['SO_SITE_MCP_AVAIL_DISP'] = adobeCookieExistSiteMcpAvailDisp;
		}
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			$data['SO_SITE_ALPI_DISA_FIELD'] = 'TRUE';
			if ($('#mab-bookingnav .navbar #bookingNav li.selected a').hasClass('flysiswa')) {
				$data['MOT'] = 'TRUE';
			}
		}
		if ($instance.find('input[name="cash_miles_type"]:checked').val() === "miles") {
			$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			$data['SO_SITE_MULTI_DIRECT_LOGIN'] = 'TRUE';
		}
		// if ((window.location.href.indexOf('enrich-portal') < 0) && (studentEnrichIdCookieVal ==null && studentDashboard ==null)){
		// 	let curPath:string 				= window.location.pathname;
		// 	let rawPathParams:Array<string> = curPath.split('/');
		// 	let langSel:string 				= rawPathParams[rawPathParams.length - 1].split('.html')[0];
		// 	if(langSel == 'ms'){
		// 		$data['SO_SITE_MANUAL_ETKT_CMD']	=	'TTP/ET/ITR-EMLA/la-ms';
		// 	}
		// }
		let $totalTraveller: number = $adultSelectedEle + $teenageSelectedEle + $childSelectedEle;
		let $index = 1;
		for ($adultSel = 1; $adultSel <= $adultSelectedEle; $adultSel++) {
			let $value = 'ADT';
			if (studentEnrichIdCookieVal != null && studentDashboard != null) {
				$value = 'STU';
			}
			if (athleteId != null) {
				$value = 'STU';
			}
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		for ($teenagerSel = 1; $teenagerSel <= $teenageSelectedEle; $teenagerSel++) {
			let $value = $('#teenagerValue').val();
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		if ($('.passenger-details-selected .teenager-cat').css('display') === "block") {
			$data['TEENAGER_COUNT'] = $teenageSelectedEle;
		}
		for ($childSel = 1; $childSel <= $childSelectedEle; $childSel++) {
			let $value = 'CHD';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}

		for ($infantSel = 1; $infantSel <= $infantSelectedEle; $infantSel++) {
			let $infant_value = 'TRUE';
			$data['HAS_INFANT_' + $infantSel] = $infant_value;
		}

		if ($couponCode != '') {
			$data['LIST_CORPORATE_NUMBER_1_1'] = $couponCode;
			$data['TYPE_OF_CORPORATE_FARE_1'] = '2';
			$data['IS_PRICE_BY_INPUT_1'] = 'TRUE';
		}

		if ($paramCug) {
			$data['partnerName'] = $('#cug-partner-name').val();
			$data['userName'] = $('#cug-user-name').val();
		}
		// TRAVEL PASS
		if ($("#travel_pass").length > 0) {
			$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			$data['SO_SITE_ALPI_DISA_FIELD'] = 'TRUE';
			$data['TRAVEL_PASS'] = 'TRUE';
			$data['TP_OFFICE_ID'] = $instance.find('.ibe-to--location').val().split('|')[1];
			let $TPEXPDATE = $('select.travel-pass--id option')[0].value.split('|')[6];
			$data['TPEXPDATE'] = $TPEXPDATE;
			let $TPID = $('select.travel-pass--id option')[0].value.split('|')[0];
			$data['TPID'] = $TPID;
			let $TP_QUOTA_VAL = $('select.travel-pass--id option')[0].value.split('|')[2];
			$data['TP_QUOTA_VAL'] = $TP_QUOTA_VAL;
			let $NVA = $('select.travel-pass--id option')[0].value.split('|')[4];
			$data['NVA'] = $NVA;
			let $SKUID = $('select.travel-pass--id option')[0].value.split('|')[5];
			$data['SKUID'] = $SKUID;
			let $COMMERCIAL_FARE_FAMILY_1 = $('select.travel-pass--id option')[0].value.split('|')[3];
			$data['ZONE'] = $COMMERCIAL_FARE_FAMILY_1;
			if ($COMMERCIAL_FARE_FAMILY_1 == 'ZONE1') {
				$data['COMMERCIAL_FARE_FAMILY_1'] = 'CFFTRVLD1'
			}
			else if ($COMMERCIAL_FARE_FAMILY_1 == 'ZONE2') {
				$data['COMMERCIAL_FARE_FAMILY_1'] = 'CFFTRVLD2'
			}
			else if ($COMMERCIAL_FARE_FAMILY_1 == 'ZONE3') {
				$data['COMMERCIAL_FARE_FAMILY_1'] = 'CFFTRVPD3'
			}
			_self.adobeDataLayer.push('click', {
				'pageName': '',
				'pageType': 'Enrich Fly Pass - User With Fly Pass',
				'clickName': 'click:btn-click:fly-pass-find-flight',
				'componentType': 'btn',
				'componentName': '',
				'componentID': '',
				'attributes': [
					{
						'key': $tripType === 'O' ? 'fly-pass-find-flights-oneway' : 'fly-pass-find-flights-return',
						'value': $tripType === 'O' ? 'oneway' : 'return'
					}, {
						'key': 'origin',
						'value': $fromLocation
					}, {
						'key': 'destination',
						'value': $toLocation
					}, {
						'key': 'departure',
						'value': $departureDate == 'Invalid date' ? '' : $departureDate
					}, {
						'key': 'return',
						'value': $returnDate == 'Invalid date' ? '' : $returnDate
					}, {
						'key': 'number-of-passengers',
						'value': $totalTraveller
					}, {
						'key': 'cabin-class',
						'value': $cabinClass
					}
				]
			});

		}
		/* Amadeus adobe partnership variable settings */

		if (typeof Visitor !== 'undefined') {
			let $amcvId;
			$amcvId = Visitor.getInstance("4D9676A8531512ED0A490D44").getMarketingCloudVisitorID();
			$data['AMCVID_ECID'] = $amcvId;
		} else {
			$data['AMCVID_ECID'] = '';
		}

		// matta fair cug campaign
		if ($('#search-param-cug-matta').length > 0) {
			if ($('#search-param-cug-matta').val() && $('#search-param-cug-matta').val() != null) {
				$data['MATTA_CUG'] = 'TRUE';
				$data['SO_SITE_ALPI_DISA_FIELD'] = 'TRUE';
				$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			}
		}
		if (!$(".enrichOnDiscountToggleContainer ").hasClass("hideclass")) {
			const enrichAlwaysonToggleButtonFlag = !$("#enrichAlwaysonToggleButtonFlag").hasClass("hideclass") && $("#enrichAlwaysonToggleButtonFlag").is(":checked") ? "TRUE" : 'FALSE';
			$data['ENRICH_ALWAYS_ON_FLAG'] = enrichAlwaysonToggleButtonFlag;
		}
		//Adding MHAthlete value for check
		let $mhAthleteVal = $('#mhAthleteVal').val();
		$data['mhAthleteVal'] = $mhAthleteVal;

		// check if flight is booked as cobrand
		if ($('#ibe-standalone_cobrand').length > 0 && !$('#ibe-standalone_cobrand').hasClass('mfp-hide')) {
			//Adding CO brand ibe value
			let $cobrandIbeVal = $('#cobrand_ibe_value').val();
			//alert("cobrandIbeVal"+$cobrandIbeVal);
			$data['cobrand_ibe_value'] = $cobrandIbeVal;
		}

		let $tripFlowUrl: any;

		if (redemptionType != "") {
			$tripFlowUrl = $.param($data) + "&" + directLogin + "" + additionalParam;
			let $tripflow_encryptURL = encodeURIComponent($tripFlowUrl);
			_self.bookingFormBackend.desktopSingleFormSubmitToServlet($instance, $tripflow_encryptURL);

		} else {
			let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
			if (loginTokenCookieVal != null) {
				// find login status here
				_self.bookingFormBackend.retrieveMemberInfoForCash($instance, $.param($data), "single");

			} else {
				$tripFlowUrl = $.param($data) + "&SO_GL=";
				let $tripflow_encryptURL = encodeURIComponent($tripFlowUrl);
				_self.bookingFormBackend.desktopSingleFormSubmitToServlet($instance, $tripflow_encryptURL);
			}
		}

	}
	/**
	 * Form submission for dx responsive booking
	 * - one way or return
	 * @return {any} [description]
	 */
	dxBookingFormSubmit($instance: any, directLogin: any, additionalParam: any, redemptionType: any, $officeCode: any): any {
		let _self = this;

		let formData: any = $instance.find('[data-form-booking--trip]').serializeArray();

		let formObj: any = {};
		$(formData).each(function (i: any, field: any) {
			formObj[field.name] = field.value;
		});
		if ($("#travel_pass").length == 0) {
			_self.adobeDataLayer.push('click', {
				'clickName': 'click:btn-click:flights-book-now',
				'componentType': 'btn',
				'componentName': 'Book Now',
				'componentID': null,
				'attributes': []
			});
		}

		// Get the user-defined values
		let $couponCode: string;
		let $fromLocation = $instance.find('.ibe-mob-from--location').val().split('_')[0];
		let $toLocation = $instance.find('.ibe-mob-to--location').val().split('|')[0];
		let $paramCug = $('#search-param-cug-mobile').val();
		//$linkURL = 'https://wav.bibi.amadeus.com/plnext/MASAirways/Override.action?EMBEDDED_TRANSACTION=FlexPricerAvailability&ENCT=1&LANGUAGE=GB&SITE=', $siteURL = this.$siteCode, $enc = '&ENC=', $webServiceURL = $linkURL + $siteURL + $enc,
		let $tripType = $instance.find('.trip-type--container li.selected a').attr('data-triptype');
		let $getDepartureDate: any;


		if ($tripType == 'R') {
			$getDepartureDate = $instance.find('.returnTrip .departureDateMobile').val();
		} else {
			$getDepartureDate = $instance.find('.oneWayTrip .departureDateMobile').val();
		}


		let $departureDate = moment(new Date($getDepartureDate)).format('YYYYMMDDhhmm');
		let $getReturnDate = $instance.find('.returnDateMobile').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYYMMDDhhmm');

		//$couponCode = $instance.find('.couponcode-input').val(),
		// $encTime                  = new Date($.now() + 364 * 24*3600*1000),
		let $cabinClass = $instance.find('.cabin-class-mob').val()

		let $adultSel: any,
			$childSel: any,
			$infantSel: any,
			$teenagerSel: any;
		let $adultSelectedEle = parseInt($instance.find('input[name="passengersAdult"]').val());
		let $teenageSelectedEle = parseInt($instance.find('input[name="passengersTeenager"]').val());
		// $youthSelectedEle = parseInt($instance.find('input[name="passengersYouth"]').val());
		let $childSelectedEle = parseInt($instance.find('input[name="passengersChildren"]').val());
		let $infantSelectedEle = parseInt($instance.find('input[name="passengersInfant"]').val());


		let $oneWayTripLink = $instance.find('.trip-type--container li.oneWayTrip');

		if ($oneWayTripLink.hasClass('selected')) {
			$returnDate = '';
		} else {
			if (!$getReturnDate) return;
		}
		let athleteId = document.cookie.match('(^|;)\\s*athleteId\\s*=\\s*([^;]+)');
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFSTUBUS"
			}
			if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFSTUECO"
			}
		}
		if (redemptionType == "cash_miles") {
			if ($cabinClass == "CFFFIRST") {
				$cabinClass = "CFFFMC"
			}
			else if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFJMC"
			}
			else if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFYMC"
			}
		} else if (redemptionType == "miles") {
			if ($cabinClass == "CFFFIRST") {
				$cabinClass = "CFFFMILES"
			}
			else if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFJMILES"
			}
			else if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFYMILES"
			}
		}
		// mh sports changes as per tkt no : 29941
		if (athleteId) {
			if ($cabinClass == "CFFFIRST") {
				$cabinClass = "CFFFSPORT";
			} else if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFJSPORT";
			} else if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFYSPORT";
			}
		}
		// end
		let couponCookieVal = document.cookie.match('(^|;)\\s*corpCode\\s*=\\s*([^;]+)');
		if (couponCookieVal != null) {
			$couponCode = couponCookieVal ? couponCookieVal.pop() : '';
			document.cookie = 'corpCode' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		} else {
			$couponCode = $instance.find('.couponcode-input-mob').val();
		}
		let $targetVal = _self.getAdobeTargetValue();
		let $externalId;
		if ($targetVal) {
			$externalId = $targetVal;
		} else {
			$externalId = 'BOOKING';
		}
		let $data = {
			ARRANGE_BY: 'R',
			BOOKING_FLOW: 'REVENUE',
			B_ANY_TIME_1: 'TRUE',
			B_ANY_TIME_2: 'TRUE',
			B_DATE_1: ($departureDate == 'Invalid date' ? '' : $departureDate),
			B_DATE_2: ($returnDate == 'Invalid date' ? '' : $returnDate),
			B_LOCATION_1: $fromLocation,
			B_LOCATION_2: $toLocation,
			COMMERCIAL_FARE_FAMILY_1: $cabinClass,
			COMMERCIAL_FARE_FAMILY_2: '',
			COMMERCIAL_FARE_FAMILY_3: '',
			DATE_RANGE_QUALIFIER_1: 'C',
			DATE_RANGE_QUALIFIER_2: 'C',
			DATE_RANGE_VALUE_1: '3',
			DATE_RANGE_VALUE_2: '3',
			DISPLAY_TYPE: '2',
			EMBEDDED_TRANSACTION: 'FlexPricerAvailability',
			EXTERNAL_ID: $externalId,
			E_LOCATION_1: $toLocation,
			E_LOCATION_2: $fromLocation,
			HAS_INFANT_1: 'FALSE',
			HAS_INFANT_2: 'FALSE',
			HAS_INFANT_3: 'FALSE',
			HAS_INFANT_4: 'FALSE',
			HAS_INFANT_5: 'FALSE',
			HAS_INFANT_6: 'FALSE',
			HAS_INFANT_7: 'FALSE',
			HAS_INFANT_8: 'FALSE',
			HAS_INFANT_9: 'FALSE',
			PRICING_TYPE: 'O',
			REFRESH: '0',
			SITE: 'desktop',
			// SO_SITE_SI_1AXML_FROM: 'SEP_JCP',
			// SO_SITE_SI_PASSWORD: 'UNSET',
			// SO_SITE_SI_SAP: '1ASIXJCP',
			// SO_SITE_SI_SERVER_IP: '193.23.185.67',
			// SO_SITE_SI_SERVER_PORT: '18033',
			// SO_SITE_SI_USER: 'UNSET',
			// SO_SITE_APIV2_SERVER: '194.156.170.78',
			// SO_SITE_APIV2_SERVER_PWD: 'TAZ',
			// SO_SITE_APIV2_SERVER_USER_ID: 'GUEST',
			// SO_SITE_CORPORATE_ID: 'OCGPDT',
			// SO_SITE_EXT_MerchantID: '',
			// SO_SITE_EXT_PSPURL: '',
			// SO_SITE_FP_ELEM_LEV_FF_DISP: 'TRUE',
			// SO_SITE_FP_SEG_FLIGHT_TIME: 'TRUE',
			// SO_SITE_FP_TRACES_ON: 'FALSE',
			// SO_SITE_FQ_INTERFACE_ACTIVE: 'FALSE',
			// SO_SITE_HOST_TRACE_ACTIVE: 'TRUE',
			// SO_SITE_NEW_UI_ENABLED: 'TRUE',
			// SO_SITE_NEW_UI_LIST_TPLS_ON: 'ALL',
			SO_SITE_OFFICE_ID: $officeCode,
			// SO_SITE_PNR_SHARING: 'TRUE',
			// SO_SITE_RUI_AX_TIMR_ENABLED: 'TRUE',
			// SO_SITE_QUEUE_CATEGORY: '0C0',
			SO_SITE_QUEUE_OFFICE_ID: $officeCode,
			// SO_SITE_RUI_AX_CAL_ENABLED: 'TRUE',
			// SO_SITE_RUI_CAL_HORIZ_DEPAR: 'TRUE',
			// SO_SITE_RUI_ENABLE_IMPL_DATA: 'TRUE',
			// SO_SITE_RUI_FARE_VERTICAL: 'FALSE',
			// SO_SITE_RUI_HIDE_MDF_SRC: 'TRUE',
			// SO_SITE_SEATMAP_POPOVER_DISP: 'TRUE',
			// SO_SITE_SI_1AXML_FROM: 'SEP_JCP',
			// SO_SITE_SI_PASSWORD: 'UNSET',
			// SO_SITE_SI_SAP: '1ASIXJCP',
			// SO_SITE_SI_SERVER_IP: '193.23.185.67',
			// SO_SITE_SI_SERVER_PORT: '18033',
			// SO_SITE_SI_USER: 'UNSET',
			// SO_SITE_SPECIAL_REQ_NUMBER: '3',
			// SO_SITE_STORE_ITINERARIES: 'TRUE',
			TRAVELLER_TYPE_1: '',
			TRAVELLER_TYPE_2: '',
			TRAVELLER_TYPE_3: '',
			TRAVELLER_TYPE_4: '',
			TRAVELLER_TYPE_5: '',
			TRAVELLER_TYPE_6: '',
			TRAVELLER_TYPE_7: '',
			TRAVELLER_TYPE_8: '',
			TRAVELLER_TYPE_9: '',
			TRIP_FLOW: 'YES',
			TRIP_TYPE: $tripType,
			ADULT_COUNT: $adultSelectedEle,
			CHILD_COUNT: $childSelectedEle,
			// YOUTH_COUNT: $youthSelectedEle,
			INFANT_COUNT: $infantSelectedEle,
			param_cug: $paramCug,
			RDM_MEM_ID: formObj['redemption_member_id'],
			RDM_MEM_LN: formObj['redemption_member_lastname'],
			RDM_MEM_PIN: formObj['redemption_member_pin'],
			RDM_PAYMENT: $instance.find('input[name="cash_miles_type"]:checked').val()
		};

		let adobeCookieExist: any = Cookies.get('TeaserCategory');
		if (adobeCookieExist != undefined) {
			$data['TeaserCategory'] = adobeCookieExist;
		}
		let adobeCookieExistSiteMcpAvailDisp: any = Cookies.get('SO_SITE_MCP_AVAIL_DISP');
		if (adobeCookieExistSiteMcpAvailDisp != undefined) {
			$data['SO_SITE_MCP_AVAIL_DISP'] = adobeCookieExistSiteMcpAvailDisp;
		}

		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			$data['SO_SITE_ALPI_DISA_FIELD'] = 'TRUE';
			if ($('#mab-bookingnav .navbar #bookingNav li.selected a').hasClass('mob-flysiswa')) {
				$data['MOT'] = 'TRUE';
			}
		}
		let $totalTraveller: number = $adultSelectedEle + $teenageSelectedEle + $childSelectedEle;
		let $index = 1;
		for ($adultSel = 1; $adultSel <= $adultSelectedEle; $adultSel++) {
			let $value = 'ADT';
			if (studentEnrichIdCookieVal != null && studentDashboard != null) {
				$value = 'STU';
			}
			if (athleteId != null) {
				$value = 'STU';
			}
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		for ($teenagerSel = 1; $teenagerSel <= $teenageSelectedEle; $teenagerSel++) {
			let $value = $('#teenagerValue').val();
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		if ($('.passenger-details-selected .teenager-cat').css('display') === "block") {
			$data['TEENAGER_COUNT'] = $teenageSelectedEle;
		}
		// for ($youthSel=1; $youthSel <= $youthSelectedEle; $youthSel++) {
		// 	let $value = 'B15';
		// 	$data['TRAVELLER_TYPE_'+$index] = $value;
		// 	$index++;
		// }

		for ($childSel = 1; $childSel <= $childSelectedEle; $childSel++) {
			let $value = 'CHD';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}

		for ($infantSel = 1; $infantSel <= $infantSelectedEle; $infantSel++) {
			let $infant_value = 'TRUE';
			$data['HAS_INFANT_' + $infantSel] = $infant_value;
		}

		if ($couponCode != '') {
			$data['LIST_CORPORATE_NUMBER_1_1'] = $couponCode;
			$data['TYPE_OF_CORPORATE_FARE_1'] = '2';
			$data['IS_PRICE_BY_INPUT_1'] = 'TRUE';
		}

		if ($paramCug) {
			$data['partnerName'] = $('#cug-partner-name').val();
			$data['userName'] = $('#cug-user-name').val();
		}

		// if ((window.location.href.indexOf('enrich-portal') < 0) && (studentEnrichIdCookieVal ==null && studentDashboard ==null)){
		// 	let curPath:string 				= window.location.pathname;
		// 	let rawPathParams:Array<string> = curPath.split('/');
		// 	let langSel:string 				= rawPathParams[rawPathParams.length - 1].split('.html')[0];
		// 	if(langSel == 'ms'){
		// 		$data['SO_SITE_MANUAL_ETKT_CMD']	=	'TTP/ET/ITR-EMLA/la-ms';
		// 	}
		// }

		// TRAVEL PASS


		if ($("#travel_pass").length > 0) {
			$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			$data['SO_SITE_ALPI_DISA_FIELD'] = 'TRUE';
			$data['TRAVEL_PASS'] = 'TRUE';
			$data['TP_OFFICE_ID'] = $instance.find('.ibe-mob-to--location').val().split('|')[1];
			let $TPEXPDATE = $('select.travel-pass--id option')[0].value.split('|')[6];
			$data['TPEXPDATE'] = $TPEXPDATE;
			let $TPID = $('select.travel-pass--id option')[0].value.split('|')[0];
			$data['TPID'] = $TPID;
			let $TP_QUOTA_VAL = $('select.travel-pass--id option')[0].value.split('|')[2];
			$data['TP_QUOTA_VAL'] = $TP_QUOTA_VAL;
			let $NVA = $('select.travel-pass--id option')[0].value.split('|')[4];
			$data['NVA'] = $NVA;
			let $SKUID = $('select.travel-pass--id option')[0].value.split('|')[5];
			$data['SKUID'] = $SKUID;
			let $COMMERCIAL_FARE_FAMILY_1 = $('select.travel-pass--id option')[0].value.split('|')[3];
			$data['ZONE'] = $COMMERCIAL_FARE_FAMILY_1;
			if ($COMMERCIAL_FARE_FAMILY_1 == 'ZONE1') {
				$data['COMMERCIAL_FARE_FAMILY_1'] = 'CFFTRVLD1'
			}
			else if ($COMMERCIAL_FARE_FAMILY_1 == 'ZONE2') {
				$data['COMMERCIAL_FARE_FAMILY_1'] = 'CFFTRVLD2'
			}
			else if ($COMMERCIAL_FARE_FAMILY_1 == 'ZONE3') {
				$data['COMMERCIAL_FARE_FAMILY_1'] = 'CFFTRVPD3'
			}
			_self.adobeDataLayer.push('click', {
				'pageName': '',
				'pageType': 'Enrich Fly Pass - User With Fly Pass',
				'clickName': 'click:btn-click:fly-pass-find-flight',
				'componentType': 'btn',
				'componentName': '',
				'componentID': '',
				'attributes': [
					{
						'key': $tripType === 'O' ? 'fly-pass-find-flights-oneway' : 'fly-pass-find-flights-return',
						'value': $tripType === 'O' ? 'oneway' : 'return'
					}, {
						'key': 'origin',
						'value': $fromLocation
					}, {
						'key': 'destination',
						'value': $toLocation
					}, {
						'key': 'departure',
						'value': $departureDate == 'Invalid date' ? '' : $departureDate
					}, {
						'key': 'return',
						'value': $returnDate == 'Invalid date' ? '' : $returnDate
					}, {
						'key': 'number-of-passengers',
						'value': $totalTraveller
					}, {
						'key': 'cabin-class',
						'value': $cabinClass
					}
				]
			});


		}
		if (typeof Visitor !== 'undefined') {
			/* Amadeus adobe partnership variable settings */
			let $amcvId;
			$amcvId = Visitor.getInstance("4D9676A8531512ED0A490D44").getMarketingCloudVisitorID();
			$data['AMCVID_ECID'] = $amcvId;
		}
		else {
			$data['AMCVID_ECID'] = '';
		}
		// matta fair cug campaign
		if ($('#search-param-cug-matta').length > 0) {
			if ($('#search-param-cug-matta').val() && $('#search-param-cug-matta').val() != null) {
				$data['MATTA_CUG'] = 'TRUE';
				$data['SO_SITE_ALPI_DISA_FIELD'] = 'TRUE';
				$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			}
		}
		if (!$(".enrichOnDiscountToggleContainer ").hasClass("hideclass")) {
			const enrichAlwaysonToggleButtonFlag = !$("#enrichAlwaysonToggleButtonFlag").hasClass("hideclass") && $("#enrichAlwaysonToggleButtonFlag").is(":checked") ? "TRUE" : 'FALSE';
			$data['ENRICH_ALWAYS_ON_FLAG'] = enrichAlwaysonToggleButtonFlag;
		}
		//Adding MHAthlete value for check in mobile
		let $mhAthleteVal = $('#mob_mhAthleteVal').val();
		$data['mhAthleteVal'] = $mhAthleteVal;

		//Adding Cobrand ibe value for mobile
		if ($('#ibe-standalone_cobrand').length > 0 && !$('#ibe-standalone_cobrand').hasClass('mfp-hide')) {
			let $cobrandIbeVal = $('#mob_cobrand_ibe_value').val();
			//alert("mobile cobrandIbeVal"+$cobrandIbeVal);
			$data['cobrand_ibe_value'] = $cobrandIbeVal;
		}

		let $tripFlowUrl: any;

		if (redemptionType != "") {
			$tripFlowUrl = $.param($data) + "&" + directLogin + "" + additionalParam;
			let $tripflow_encryptURL = encodeURIComponent($tripFlowUrl);
			_self.bookingFormBackend.desktopSingleFormSubmitToServlet($instance, $tripflow_encryptURL);

		} else {
			let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
			if (loginTokenCookieVal != null) {
				// find login status here
				_self.bookingFormBackend.retrieveMemberInfoForCash($instance, $.param($data), "single");

			} else {
				$tripFlowUrl = $.param($data) + "&SO_GL=";
				let $tripflow_encryptURL = encodeURIComponent($tripFlowUrl);
				_self.bookingFormBackend.desktopSingleFormSubmitToServlet($instance, $tripflow_encryptURL);
			}
		}

	}
	/**
	 * [multiBookingFormValidation description]
	 * @param {any} callback [description]
	 */
	multiBookingFormValidation($instance: any, $officeCode: any, callback: any) {
		let ieversion = new headerContent();
		ieversion.checkIEVersion_disablePupup();
		let _self = this;
		if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
			// console.log("Desktop Device");
			// this.$siteCode = 'J03UJ03U';

			/**
			 * perform validation here
			 */
			var formDestinationValid = false;
			var formDepDatesValid = false;
			var formItineraryValid: any = []; // each destination row added by the user to have its own validation
			var formAllDestValid = true; // overall validation for all destination rows
			var formPassengersValid = false;
			// get all currently active destination fieldsets
			var destFields = $instance.find('[data-form-booking--trip] fieldset[data-type="destination-input"][data-flight-enabled="1"]');
			var prevDate: any; // temp var for storing previous entry date
			var errorDiv = $instance.find('.validation-content'); // dom traversal to get error div
			var prevDate: any; // temp var for storing previous entry date
			var prevArray: any = [];
			// empty validation container
			if (errorDiv.find('li').length) {
				errorDiv.find('.validation--error-list').empty();
			}

			destFields.each(function (i: number) {
				var destFrom = $(this).find('select.depLocationBegin');
				var destTo = $(this).find('select.depLocationEnd');
				var depDate = $(this).find('input.dateDeparture');

				var destFromVal = destFrom.val();
				var destToVal = destTo.val();
				var depDateVal = moment(new Date(depDate.val())).unix();

				// validate destination fields
				// ===========================
				// 1. all fields filled in
				// 2. sequential dates
				// 3. no same from/to locations

				// validate empty fields
				var currInputEl = $(destFrom); // dom traversal to get error div
				if (!destFromVal) {
					formDestinationValid = false;
					errorMsg(currInputEl, errorDiv, 'emptyFlightFrom' + i, '<strong>From #' + (i + 1) + ':</strong> Select your origin');
				} else {
					clearError(currInputEl, errorDiv, 'emptyFlightFrom' + i);
				}

				var currInputEl = $(destTo); // dom traversal to get error div
				if (!destToVal) {
					formDestinationValid = false;
					errorMsg(currInputEl, errorDiv, 'emptyFlightTo' + i, '<strong>To #' + (i + 1) + ':</strong> Select your destination');
				} else {
					clearError(currInputEl, errorDiv, 'emptyFlightTo' + i);
				}

				// validate duplicate from/to destinations
				if (destFromVal && destToVal) { // validate if both fields are filled in
					var currInputEl = $(destTo); // dom traversal to get error div
					if (destFromVal === destToVal) {
						formDestinationValid = false;
						errorMsg(currInputEl, errorDiv, 'duplicateFlightDestinations' + i, '<strong>To #' + (i + 1) + ': </strong> Please select a different destination');
					} else {
						formDestinationValid = true;
						clearError(currInputEl, errorDiv, 'duplicateFlightDestinations' + i);
					}
				}

				var currInputEl = $(depDate); // dom traversal to get error div
				if (!depDateVal) {
					formDepDatesValid = false;
					errorMsg(currInputEl, errorDiv, 'emptyDepartureDate' + i, '<strong>Departure #' + (i + 1) + ':</strong> Select your departure date');
				} else {
					formDepDatesValid = true;
					clearError(currInputEl, errorDiv, 'emptyDepartureDate' + i);
				}

				if (depDateVal) {
					// validate sequential date
					if (prevDate) {
						var currInputEl = $(depDate); // dom traversal to get error div
						//if (prevDate > depDateVal) {

						if (prevArray.some(el => el > depDateVal)) {
							formDepDatesValid = false;
							errorMsg(currInputEl, errorDiv, 'prevFlightMoreCurrFlight' + i, '<strong>Destination #' + (i + 1) + ':</strong>Previous flight date cannot be later than current flight date');
						} else {
							formDepDatesValid = true;
							clearError(currInputEl, errorDiv, 'prevFlightMoreCurrFlight' + i);
						}
					} else {
						//prevDate = depDateVal;
					}
					prevDate = depDateVal;
					prevArray.push(depDateVal);
				}

				// console.log('formDestinationValid', formDestinationValid);
				// console.log('formDepDatesValid', formDepDatesValid);
				if (formDestinationValid && formDepDatesValid) {
					formItineraryValid[i] = true;
				} else {
					formItineraryValid[i] = false;
				}
			});

			// console.log(formItineraryValid);

			// check all itinerary rows for validity
			// once a row fails validation (arr[i] == false)
			// break out of loop and set validation = failed
			for (var j = 0; j < formItineraryValid.length; j++) {
				if (formItineraryValid[j] === false) {
					formAllDestValid = false;
					break;
				}
			}

			// validate passenger fields
			// =========================
			// 1. 1 adult to 1 infant (max 2 infants)
			var passAdults = $instance.find('[data-form-booking--trip] input[name="passengersAdult"]');
			var passTeenagers = $instance.find('[data-form-booking--trip] input[name="passengersTeenager"]');
			var passInfants = $instance.find('[data-form-booking--trip] input[name="passengersInfant"]');

			var passAdultsVal = parseInt(passAdults.val());
			var passTeenagersVal = parseInt(passTeenagers.val());
			var passInfantsVal = parseInt(passInfants.val());

			var ratioAdultInfant = (passAdultsVal / passInfantsVal) >= 1;
			var ratioAdultTeenager = (passAdultsVal / passTeenagersVal) >= 1;

			var currInputEl = $instance.find('[data-booking-passenger-details-selected]'); // dom traversal to get error div
			var $passengerDetailsContainer = $instance.find('[data-booking-passenger-details]');

			if (!ratioAdultInfant) {
				formPassengersValid = false;
				errorMsg(currInputEl, errorDiv, 'moreInfantsThanAdults', '<strong>' + $passengerDetailsContainer.find('.title-caption').text() + ' - ' + currInputEl.find('.infant-cat .booking-category').text() + ':</strong> Only 1 infant per adult is allowed');
			} else {
				formPassengersValid = true;
				clearError(currInputEl, errorDiv, 'moreInfantsThanAdults');
			}

			let formDataValid = formPassengersValid && formAllDestValid;

			let $cabinClass = $instance.find('.cabin-class').val();
			let $paymentMethod = $instance.find('input[name="cash_miles_type"]:checked').val();
			let $infantTicketValue = $instance.find('.ticket-infant--input').val();
			let $teenagerTicketValue = $instance.find('.ticket-teenager--input').val();
			let $infantAlertContainer: any = $('#infant-alert--container');
			let $warningAccepted: any = $infantAlertContainer.find('input[name="infant_warning"]');
			let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';

			// Validation: infant booking
			// multi booking form
			// open popup if these conditions are met:
			// - cabinclass = 'CFFFIRST'
			// - warning != 'accepted'
			// - infantTicketvalue > 0
			// - form submission is valid till this point
			if (formDataValid === true && $cabinClass == "CFFFIRST" && $warningAccepted.val() !== 'accepted' && $infantTicketValue > 0) {
				if ($paymentMethod === 'cash') {
					$instance.find('.error-validation').hide();
					if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
						$.magnificPopup.open({
							items: {
								src: '#infant-alert--container'
							},
							type: 'inline',
							midClick: true,
							callbacks: {
								open: function () {
									let instance = this;
									let $el: any = instance.content;
									// console.log('infant booking multi booking form', $instance, instance);
									_self.bookflightinfant.submitBtns($instance);

									// no need to check payment type since multicity only can pay in cash
									$el.find('input[name="tripflow"]').val('multi_desk');
									$el.find('input[name="payment_method"]').val('cash');

								}
							}
						}, 0);
					} else {
						$.magnificPopup.proto.close.call(this);
						$.magnificPopup.instance.close = function () {
							$.magnificPopup.open({
								items: {
									src: '#infant-alert--container'
								},
								type: 'inline',
								midClick: true,
								callbacks: {
									open: function () {
										let instance = this;
										let $el: any = instance.content;
										// console.log('infant booking multi booking form', $instance, instance);
										_self.bookflightinfant.submitBtns($instance);

										// no need to check payment type since multicity only can pay in cash
										$el.find('input[name="tripflow"]').val('multi_desk');
										$el.find('input[name="payment_method"]').val('cash');

									}
								}
							}, 0);
						};
					}
					return false;
				}
			}

			// redemption login fields validation
			let loginContainer = $instance.find('.container--redemption-login');
			let redemptionLoginValidation = true;
			if ($paymentMethod !== 'cash') {
				redemptionLoginValidation = _self.loginFieldsValidation($instance);

				if (loginContainer.hasClass('hidden')) {
					redemptionLoginValidation = true;
				}
			}

			// console.log('multi', redemptionLoginValidation);

			if (formAllDestValid && formPassengersValid && redemptionLoginValidation) {
				// proceed to retrieve input vars (callback fn)
				if (typeof callback === "function") {
					callback($officeCode);
				}
			} else {
				//console.log('%cValidation failed', 'color: red; font-weight: bold');
				displayErrors(errorDiv);
				// do error stuff here
				return false;
			}
		}

		/**
		 * Error msg display for from/to select fields
		 * @param  {jquery object} el   [error div element]
		 * @param  {[type]} msg  [error message]
		 */
		function errorMsg(el: any, error_div: any, errId: string, msg: string) {
			// display error message
			// console.log('%c'+msg, 'color: red');
			// find list element. if unable to find create one
			console.log(el, errId);
			var errorList = error_div.find('ul.validation--error-list');
			if (!errorList.length) {
				error_div.append('<ul class="validation--error-list"></ul>');
				var errorList = error_div.find('ul.validation--error-list');
			}

			if (!errorList.find('li[data-error="' + errId + '"]').length) {
				errorList.append('<li data-error="' + errId + '">' + msg + '</li>');
			}

			// apply error classes
			switch (el.prop('nodeName')) {
				case 'SELECT': {
					el.prev().addClass('has-error');
					el.next().children('.selectize-input').addClass('has-error');
					break;
				}
				case 'INPUT': {
					if (el.hasClass('hasDatepicker')) {
						el.parents().eq(1).addClass('has-error');
					}
					break;
				}
				case 'DIV': {
					if (el.hasClass('passenger-details-selected')) {
						el.parent().find('.passenger-details').addClass('has-error');
					}
					el.addClass('has-error');
					break;
				}
				default:
					break;
			}

			return;
		}

		/**
		 * Clear error message once error no longer present
		 * @param  {[type]} el [description]
		 * @return {[type]}    [description]
		 */
		function clearError(el: any, error_div: any, errId: string) {
			var errorItem = error_div.find('li[data-error="' + errId + '"]');
			var haveErrors = error_div.find('li').length;

			if (errorItem.length) {
				errorItem.remove();
			}

			// remove error classes
			switch (el.prop('nodeName')) {
				case 'SELECT': {
					el.prev().removeClass('has-error');
					el.next().children('.selectize-input').removeClass('has-error');
					break;
				}
				case 'INPUT': {
					if (el.hasClass('hasDatepicker')) {
						el.parents().eq(1).removeClass('has-error');
					}
					break;
				}
				case 'DIV': {
					if (el.hasClass('passenger-details-selected')) {
						el.parent().find('.passenger-details').removeClass('has-error');
					}
					el.removeClass('has-error');
					break;
				}
				default:
					break;
			}

			displayErrors(error_div);
			// el.fadeOut(250);
			// el.empty();
			// el.parent().removeClass('error_state');

			return;
		}

		function displayErrors(error_div: any) {
			var haveErrors = error_div.find('li').length;

			// hide error div if no errors present
			let $errorValidation: any = $instance.find('.error-validation');
			if (!haveErrors) {
				$errorValidation.hide();
			} else {
				$errorValidation.show();
			}
		}
	}

	/**
	 * [multiBookingGetOfficeCode description]
	 * @return {[type]} [description]
	 */
	multiBookingFormSubmit($instance: any, data: any, $officeCode: any): any {
		let _self = this;
		// Get the user-defined values
		// from location
		let $fromLocationMulticityOne = data['B_LOCATION_1'];
		let $fromLocationMulticityTwo = data['B_LOCATION_2'];
		let $fromLocationMulticityThree = data['B_LOCATION_3'];
		let $fromLocationMulticityFour = data['B_LOCATION_4'];
		let $fromLocationMulticityFive = data['B_LOCATION_5'];
		let $fromLocationMulticitySix = data['B_LOCATION_6'];
		// to location
		let $toLocationMulticityOne = data['E_LOCATION_1'];
		let $toLocationMulticityTwo = data['E_LOCATION_2'];
		let $toLocationMulticityThree = data['E_LOCATION_3'];
		let $toLocationMulticityFour = data['E_LOCATION_4'];
		let $toLocationMulticityFive = data['E_LOCATION_5'];
		let $toLocationMulticitySix = data['E_LOCATION_6'];
		// departure date
		let $getMulticityDeptDateOne = data['B_DATE_1'];
		let $getMulticityDeptDateTwo = data['B_DATE_2'];
		let $getMulticityDeptDateThree = data['B_DATE_3'];
		let $getMulticityDeptDateFour = data['B_DATE_4'];
		let $getMulticityDeptDateFive = data['B_DATE_5'];
		let $getMulticityDeptDateSix = data['B_DATE_6'];
		// departure date (parsed)
		let $multicityDeptDateOne = moment(new Date($getMulticityDeptDateOne)).format('YYYYMMDDhhmm');
		let $multicityDeptDateTwo = moment(new Date($getMulticityDeptDateTwo)).format('YYYYMMDDhhmm');
		let $multicityDeptDateThree = moment(new Date($getMulticityDeptDateThree)).format('YYYYMMDDhhmm');
		let $multicityDeptDateFour = moment(new Date($getMulticityDeptDateFour)).format('YYYYMMDDhhmm');
		let $multicityDeptDateFive = moment(new Date($getMulticityDeptDateFive)).format('YYYYMMDDhhmm');
		let $multicityDeptDateSix = moment(new Date($getMulticityDeptDateSix)).format('YYYYMMDDhhmm');
		// site details
		// let $linkURL                    = 'https://wav.bibi.amadeus.com/plnext/MASAirways/Override.action?EMBEDDED_TRANSACTION=AirComplexAvailability&ENCT=1&LANGUAGE=GB&SITE=';
		// let $siteURL                    = this.$siteCode;
		// let $enc                        = '&ENC=&';
		// let $webServiceURL              = $linkURL + $siteURL + $enc;
		// trip details
		let $tripType = 'M';
		let $cabinClass = data['cabinClass'];
		let $couponCode = $instance.find('.couponcode-input').val();
		//$encTime = new Date($.now() + 364 * 24*3600*1000),
		// passenger details
		let $adultSel: number;
		//$youthSel:number,
		let $childSel: number;
		let $teenagerSel: number;
		let $infantSel: number;
		let $adultSelectedEle = parseInt(data['passengersAdult']);
		let $teenagerSelectedEle = parseInt(data['passengersTeenager']);
		//$youthSelectedEle  = 0,
		let $childSelectedEle = parseInt(data['passengersChildren']);
		let $infantSelectedEle = data['passengersInfant'];

		if ($cabinClass == "CFFECO") {
			$cabinClass = "E";
		} else if ($cabinClass == "CFFBUS") {
			$cabinClass = "B";
		} else if ($cabinClass == "CFFFIRST") {
			$cabinClass = "F";
		}
		_self.adobeDataLayer.push('click', {
			'clickName': 'click:btn-click:flights-book-now',
			'componentType': 'btn',
			'componentName': 'Book Now',
			'componentID': null,
			'attributes': []
		});
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFSTUBUS"
			}
			if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFSTUECO"
			}
		}
		let $targetVal = _self.getAdobeTargetValue();
		let $externalId;
		if ($targetVal) {
			$externalId = $targetVal;
		} else {
			$externalId = '';
		}
		var $data = {
			B_ANY_TIME_1: 'TRUE',
			B_ANY_TIME_2: 'TRUE',
			B_ANY_TIME_3: 'TRUE',
			B_ANY_TIME_4: 'TRUE',
			B_ANY_TIME_5: 'TRUE',
			B_ANY_TIME_6: 'TRUE',
			B_DATE_1: ($multicityDeptDateOne == 'Invalid date' ? '' : $multicityDeptDateOne),
			B_DATE_2: ($multicityDeptDateTwo == 'Invalid date' ? '' : $multicityDeptDateTwo),
			B_DATE_3: ($multicityDeptDateThree == 'Invalid date' ? '' : $multicityDeptDateThree),
			B_DATE_4: ($multicityDeptDateFour == 'Invalid date' ? '' : $multicityDeptDateFour),
			B_DATE_5: ($multicityDeptDateFive == 'Invalid date' ? '' : $multicityDeptDateFive),
			B_DATE_6: ($multicityDeptDateSix == 'Invalid date' ? '' : $multicityDeptDateSix),
			B_LOCATION_1: ($fromLocationMulticityOne == '0' ? '' : $fromLocationMulticityOne),
			B_LOCATION_2: ($fromLocationMulticityTwo == '0' ? '' : $fromLocationMulticityTwo),
			B_LOCATION_3: ($fromLocationMulticityThree == '0' ? '' : $fromLocationMulticityThree),
			B_LOCATION_4: ($fromLocationMulticityFour == '0' ? '' : $fromLocationMulticityFour),
			B_LOCATION_5: ($fromLocationMulticityFive == '0' ? '' : $fromLocationMulticityFive),
			B_LOCATION_6: ($fromLocationMulticitySix == '0' ? '' : $fromLocationMulticitySix),
			E_LOCATION_1: ($toLocationMulticityOne == '0' ? '' : $toLocationMulticityOne),
			E_LOCATION_2: ($toLocationMulticityTwo == '0' ? '' : $toLocationMulticityTwo),
			E_LOCATION_3: ($toLocationMulticityThree == '0' ? '' : $toLocationMulticityThree),
			E_LOCATION_4: ($toLocationMulticityFour == '0' ? '' : $toLocationMulticityFour),
			E_LOCATION_5: ($toLocationMulticityFive == '0' ? '' : $toLocationMulticityFive),
			E_LOCATION_6: ($toLocationMulticitySix == '0' ? '' : $toLocationMulticitySix),
			CABIN: $cabinClass,
			EMBEDDED_TRANSACTION: 'AirComplexAvailability',
			// ENC_TIME             : '20171220165420',
			EXTERNAL_ID: $externalId,
			HAS_INFANT_1: 'FALSE',
			HAS_INFANT_2: 'FALSE',
			HAS_INFANT_3: 'FALSE',
			HAS_INFANT_4: 'FALSE',
			HAS_INFANT_5: 'FALSE',
			HAS_INFANT_6: 'FALSE',
			HAS_INFANT_7: 'FALSE',
			HAS_INFANT_8: 'FALSE',
			HAS_INFANT_9: 'FALSE',
			// LANGUAGE         : 'GB',
			SEVEN_DAY_SEARCH: 'TRUE',
			SITE: 'desktop',
			// SO_SITE_APIV2_SERVER         : '194.156.170.78',
			// SO_SITE_APIV2_SERVER_PWD     : 'TAZ',
			// SO_SITE_APIV2_SERVER_USER_ID : 'GUEST',
			// SO_SITE_CORPORATE_ID         : 'OCGPDT',
			// SO_SITE_FP_TRACES_ON         : 'FALSE',
			// SO_SITE_FQ_INTERFACE_ACTIVE  : 'FALSE',
			// SO_SITE_HOST_TRACE_ACTIVE    : 'TRUE',
			// SO_SITE_OFFICE_ID            : this.$officeCode,
			// SO_SITE_QUEUE_CATEGORY       : '0C0',
			// SO_SITE_QUEUE_OFFICE_ID      : 'KULMH08AA',
			// SO_SITE_SI_1AXML_FROM        : 'SEP_JCP',
			// SO_SITE_SI_PASSWORD          : 'UNSET',
			// SO_SITE_SI_SAP               : '1ASIXJCP',
			// SO_SITE_SI_SERVER_IP         : '193.23.185.67',
			// SO_SITE_SI_SERVER_PORT       : '18033',
			// SO_SITE_SI_USER              : 'UNSET',
			SO_SITE_OFFICE_ID: $officeCode,
			SO_SITE_QUEUE_OFFICE_ID: $officeCode,
			TRAVELLER_TYPE_1: '',
			TRAVELLER_TYPE_2: '',
			TRAVELLER_TYPE_3: '',
			TRAVELLER_TYPE_4: '',
			TRAVELLER_TYPE_5: '',
			TRAVELLER_TYPE_6: '',
			TRAVELLER_TYPE_7: '',
			TRAVELLER_TYPE_8: '',
			TRAVELLER_TYPE_9: '',
			TRIP_FLOW: 'YES',
			TRIP_TYPE: $tripType,
			RDM_MEM_ID: data.redemption_member_id,
			RDM_MEM_LN: data.redemption_member_lastname,
			RDM_MEM_PIN: data.redemption_member_pin,
			RDM_PAYMENT: $instance.find('input[name="cash_miles_type"]:checked').val()
		};
		let adobeCookieExist: any = Cookies.get('TeaserCategory');
		if (adobeCookieExist != undefined) {
			$data['TeaserCategory'] = adobeCookieExist;
		}
		let adobeCookieExistSiteMcpAvailDisp: any = Cookies.get('SO_SITE_MCP_AVAIL_DISP');
		if (adobeCookieExistSiteMcpAvailDisp != undefined) {
			$data['SO_SITE_MCP_AVAIL_DISP'] = adobeCookieExistSiteMcpAvailDisp;
		}
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			$data['SO_SITE_ALPI_DISA_FIELD'] = 'TRUE';
		}
		var $totalTraveller = $adultSelectedEle + $teenagerSelectedEle + $childSelectedEle;
		var $index = 1;

		// fill in values for each amadeus params based on number of travellers (adults)
		for ($adultSel = 1; $adultSel <= $adultSelectedEle; $adultSel++) {
			var $value = 'ADT';
			if (studentEnrichIdCookieVal != null && studentDashboard != null) {
				$value = 'STU';
			}
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		// fill in values for each amadeus params based on number of travellers (teenagers)
		for ($teenagerSel = 1; $teenagerSel <= $teenagerSelectedEle; $teenagerSel++) {
			var $value = $('#teenagerValue').val();
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		let $teenageSelectedEle = parseInt($instance.find('input[name="passengersTeenager"]').val());
		if ($('.passenger-details-selected .teenager-cat').css('display') === "block") {
			$data['TEENAGER_COUNT'] = $teenageSelectedEle;
		}
		// currently not in use
		// fill in values for each amadeus params based on number of travellers (youths)
		// for ($youthSel = 1; $youthSel <= $youthSelectedEle; $youthSel++) {
		//     var $value = 'B15';
		//     $data['TRAVELLER_TYPE_' + $index] = $value;
		//     $index++;
		// };

		// fill in values for each amadeus params based on number of travellers (children)
		for ($childSel = 1; $childSel <= $childSelectedEle; $childSel++) {
			var $value = 'CHD';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}

		// fill in values for each amadeus params based on number of travellers (infants)
		for ($infantSel = 1; $infantSel <= $infantSelectedEle; $infantSel++) {
			var $infant_value = 'TRUE';
			$data['HAS_INFANT_' + $infantSel] = $infant_value;
		}

		if ($couponCode != '') {
			$data['LIST_CORPORATE_NUMBER_1_1'] = $couponCode;
			$data['TYPE_OF_CORPORATE_FARE_1'] = '2';
			$data['IS_PRICE_BY_INPUT_1'] = 'TRUE';
		}

		if (typeof Visitor !== 'undefined') {
			/* Amadeus adobe partnership variable settings */
			let $amcvId;
			$amcvId = Visitor.getInstance("4D9676A8531512ED0A490D44").getMarketingCloudVisitorID();
			$data['AMCVID_ECID'] = $amcvId;
		}
		else {
			$data['AMCVID_ECID'] = '';
		}

		var $multiTripFlowUrl = $.param($data);

		// display url params (debug)
		// window.prompt($multiTripFlowUrl);
		// alert($multiTripFlowUrl);
		// console.log($multiTripFlowUrl);
		// console.log($data);

		let $tabularData: any = {};
		for (var dkey in $data) {
			$tabularData[dkey] = { 'value': $data[dkey] };
		}
		let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
		if (loginTokenCookieVal != null) {
			// find login status here
			_self.bookingFormBackend.retrieveMemberInfoForCash($instance, $.param($data), "multi");
		} else {
			let $tripflow_encryptURL = encodeURIComponent($multiTripFlowUrl);
			_self.bookingFormBackend.desktopMultiFormSubmitToServlet($instance, $tripflow_encryptURL);

		}

	}

	/* MobileSidetripflowSubmit
*/
	mobileSidetripflowSubmit($instance: any, data: any, $officeCode: any): any {
		let _self = this;
		// Get the user-defined values
		let $scopeSideTrip: any = $('[data-mob-ibe--book-flight]');
		let $scopeSideTrip_desk: any = $('[data-ibe--book-flight]');
		let $fromLocationMulticityOne: any;
		let $fromLocationMulticityTwo: any;
		let $fromLocationMulticityThree: any;
		let $toLocationMulticityOne: any;
		let $toLocationMulticityTwo: any;
		let $toLocationMulticityThree: any;

		let $multicityDeptDateOne: any;
		let $multicityDeptDateTwo: any;
		let $multicityDeptDateThree: any;

		if (($('.returnsideTrip').hasClass('selected') && !($('.mobile-sidetrip-submit').is(':visible')) && !($.magnificPopup.instance.isOpen)) || (($('#mobile-bookflight--container .returnTrip').hasClass('selected') && $('.mobile-sidetrip-submit').is(':visible')) && !($.magnificPopup.instance.isOpen)) || ($('.returnsideTrip').hasClass('selected') && ($.magnificPopup.instance.isOpen) && !($('.ibe-sidetrip-submit').is(':visible'))) || (($('#book-flight--container .returnTrip').hasClass('selected') && $('.ibe-sidetrip-submit').is(':visible')) && ($.magnificPopup.instance.isOpen))) {
			if ($('.sidetrip-from').css('pointer-events') == 'none') {
				$fromLocationMulticityOne = $('.container--side-trip .oneway-origin').first().text().split('_')[0];
				$fromLocationMulticityTwo = $('.container--side-trip .oneway-destination').last().text();
				$fromLocationMulticityThree = $('.domesticflight-space .visitloc').last().text();

				$toLocationMulticityOne = $('.container--side-trip .oneway-destination').last().text();
				$toLocationMulticityTwo = $('.domesticflight-space .visitloc').last().text();
				$toLocationMulticityThree = $('.container--side-trip .oneway-origin').first().text().split('_')[0];


				let $domesticreturn = $('.container--side-trip .returndate-sidetrip').text();
				let $domesticreturnArray = $domesticreturn.split('-');
				let $getMulticityDeptDateOne = $('.container--side-trip .onewaydate').last().text();
				let $getMulticityDeptDateTwo = $domesticreturnArray[0];
				let $getMulticityDeptDateThree = $domesticreturnArray[1];

				// departure date (parsed)
				$multicityDeptDateOne = moment(new Date($getMulticityDeptDateOne)).format('YYYYMMDDhhmm');
				$multicityDeptDateTwo = moment(new Date($getMulticityDeptDateTwo)).format('YYYYMMDDhhmm');
				$multicityDeptDateThree = moment(new Date($getMulticityDeptDateThree)).format('YYYYMMDDhhmm');

			} else {
				$fromLocationMulticityOne = $('.container--side-trip .oneway-origin').first().text().split('_')[0];
				////$instance.find('.ibe-sideTrip-from--location').val();
				$fromLocationMulticityTwo = $('.domesticflight-space .visitloc').first().text();
				$fromLocationMulticityThree = $('.container--side-trip .return-origin').first().text();

				$toLocationMulticityOne = $('.domesticflight-space .visitloc').first().text();
				$toLocationMulticityTwo = $('.container--side-trip .return-origin').last().text();
				$toLocationMulticityThree = $('.container--side-trip .return-destination').first().text().split('_')[0];

				let $domesticreturn = $('.container--side-trip .onewaydate-sidetrip').text();
				let $domesticreturnArray = $domesticreturn.split('-');
				let $getMulticityDeptDateOne = $domesticreturnArray[0];
				let $getMulticityDeptDateTwo = $domesticreturnArray[1];
				let $getMulticityDeptDateThree = $('.container--side-trip .returndate').last().text();
				if ($('.sidetrip-to').css('display') == 'none' || $('.sidetrip-from').css('display') == 'none') {
					$fromLocationMulticityThree = '';
					$toLocationMulticityThree = '';
					$getMulticityDeptDateThree = '';
				}

				// departure date (parsed)
				$multicityDeptDateOne = moment(new Date($getMulticityDeptDateOne)).format('YYYYMMDDhhmm');
				$multicityDeptDateTwo = moment(new Date($getMulticityDeptDateTwo)).format('YYYYMMDDhhmm');
				$multicityDeptDateThree = moment(new Date($getMulticityDeptDateThree)).format('YYYYMMDDhhmm');


			}
		} else {
			$fromLocationMulticityOne = $('.container--side-trip .oneway-origin').first().text().split('_')[0];
			$fromLocationMulticityTwo = $('.sidetrip-oneway-details-expanded .domesticflight-space .visitloc').last().text();
			$fromLocationMulticityThree = '';

			$toLocationMulticityOne = $('.sidetrip-oneway-details-expanded .domesticflight-space .visitloc').last().text();
			$toLocationMulticityTwo = $('.container--side-trip .oneway-destination').last().text();
			$toLocationMulticityThree = '';


			let $domesticreturn = $('.container--side-trip .onewaydate-sidetrip').text();
			let $domesticreturnArray = $domesticreturn.split('-');
			let $getMulticityDeptDateOne = $domesticreturnArray[0];
			let $getMulticityDeptDateTwo = $domesticreturnArray[1];

			// departure date (parsed)
			$multicityDeptDateOne = moment(new Date($getMulticityDeptDateOne)).format('YYYYMMDDhhmm');
			$multicityDeptDateTwo = moment(new Date($getMulticityDeptDateTwo)).format('YYYYMMDDhhmm');
			$multicityDeptDateThree = '';

		}
		// trip details
		let $tripType = 'M';
		let $cabinClass = data['cabinClass'];
		//$encTime = new Date($.now() + 364 * 24*3600*1000),
		// passenger details
		let $adultSel: number;
		//$youthSel:number,
		let $childSel: number;
		let $teenagerSel: number;
		let $infantSel: number;
		let $adultSelectedEle = parseInt(data['passengersAdult']);
		let $teenagerSelectedEle = parseInt(data['passengersTeenager']);
		//$youthSelectedEle  = 0,
		let $childSelectedEle = parseInt(data['passengersChildren']);
		let $infantSelectedEle = data['passengersInfant'];

		if ($('.mobile-sidetrip-submit').is(':visible')) {
			$cabinClass = $scopeSideTrip.find('.cabin-class-mob').val();
			$adultSelectedEle = parseInt($scopeSideTrip.find('input[name="passengersAdult"]').val());
			// $youthSelectedEle = parseInt($instance.find('input[name="passengersYouth"]').val());
			$childSelectedEle = parseInt($scopeSideTrip.find('input[name="passengersChildren"]').val());
			$infantSelectedEle = parseInt($scopeSideTrip.find('input[name="passengersInfant"]').val());
			$teenagerSelectedEle = parseInt($scopeSideTrip.find('input[name="passengersTeenager"]').val());

		}
		if ($('.ibe-sidetrip-submit').is(':visible')) {
			$cabinClass = $scopeSideTrip_desk.find('.cabin-class').val();
			$adultSelectedEle = parseInt($scopeSideTrip_desk.find('input[name="passengersAdult"]').val());
			// $youthSelectedEle = parseInt($instance.find('input[name="passengersYouth"]').val());
			$childSelectedEle = parseInt($scopeSideTrip_desk.find('input[name="passengersChildren"]').val());
			$infantSelectedEle = parseInt($scopeSideTrip_desk.find('input[name="passengersInfant"]').val());
			$teenagerSelectedEle = parseInt($scopeSideTrip_desk.find('input[name="passengersTeenager"]').val());

		}

		if ($cabinClass == "CFFECO") {
			$cabinClass = "E";
		} else if ($cabinClass == "CFFBUS") {
			$cabinClass = "B";
		} else if ($cabinClass == "CFFFIRST") {
			$cabinClass = "F";
		}

		let $targetVal = _self.getAdobeTargetValue();
		let $externalId;
		if ($targetVal) {
			$externalId = $targetVal;
		} else {
			$externalId = '';
		}
		var $data = {
			B_ANY_TIME_1: 'TRUE',
			B_ANY_TIME_2: 'TRUE',
			B_ANY_TIME_3: 'TRUE',
			B_ANY_TIME_4: 'TRUE',
			B_ANY_TIME_5: 'TRUE',
			B_ANY_TIME_6: 'TRUE',
			B_DATE_1: ($multicityDeptDateOne == 'Invalid date' ? '' : $multicityDeptDateOne),
			B_DATE_2: ($multicityDeptDateTwo == 'Invalid date' ? '' : $multicityDeptDateTwo),
			B_DATE_3: ($multicityDeptDateThree == 'Invalid date' ? '' : $multicityDeptDateThree),
			B_DATE_4: '',
			B_DATE_5: '',
			B_DATE_6: '',
			B_LOCATION_1: ($fromLocationMulticityOne == '0' ? '' : $fromLocationMulticityOne),
			B_LOCATION_2: ($fromLocationMulticityTwo == '0' ? '' : $fromLocationMulticityTwo),
			B_LOCATION_3: ($fromLocationMulticityThree == '0' ? '' : $fromLocationMulticityThree),
			B_LOCATION_4: '',
			B_LOCATION_5: '',
			B_LOCATION_6: '',
			E_LOCATION_1: ($toLocationMulticityOne == '0' ? '' : $toLocationMulticityOne),
			E_LOCATION_2: ($toLocationMulticityTwo == '0' ? '' : $toLocationMulticityTwo),
			E_LOCATION_3: ($toLocationMulticityThree == '0' ? '' : $toLocationMulticityThree),
			E_LOCATION_4: '',
			E_LOCATION_5: '',
			E_LOCATION_6: '',
			CABIN: $cabinClass,
			EMBEDDED_TRANSACTION: 'AirComplexAvailability',
			// ENC_TIME             : '20171220165420',
			EXTERNAL_ID: $externalId,
			HAS_INFANT_1: 'FALSE',
			HAS_INFANT_2: 'FALSE',
			HAS_INFANT_3: 'FALSE',
			HAS_INFANT_4: 'FALSE',
			HAS_INFANT_5: 'FALSE',
			HAS_INFANT_6: 'FALSE',
			HAS_INFANT_7: 'FALSE',
			HAS_INFANT_8: 'FALSE',
			HAS_INFANT_9: 'FALSE',
			// LANGUAGE         : 'GB',
			SEVEN_DAY_SEARCH: 'TRUE',
			SITE: 'desktop',
			// SO_SITE_APIV2_SERVER         : '194.156.170.78',
			// SO_SITE_SI_USER              : 'UNSET',
			SO_SITE_OFFICE_ID: $officeCode,
			SO_SITE_QUEUE_OFFICE_ID: $officeCode,
			TRAVELLER_TYPE_1: '',
			TRAVELLER_TYPE_2: '',
			TRAVELLER_TYPE_3: '',
			TRAVELLER_TYPE_4: '',
			TRAVELLER_TYPE_5: '',
			TRAVELLER_TYPE_6: '',
			TRAVELLER_TYPE_7: '',
			TRAVELLER_TYPE_8: '',
			TRAVELLER_TYPE_9: '',
			TRIP_FLOW: 'YES',
			TRIP_TYPE: $tripType,
			RDM_MEM_ID: data.redemption_member_id,
			RDM_MEM_LN: data.redemption_member_lastname,
			RDM_MEM_PIN: data.redemption_member_pin,
			RDM_PAYMENT: $instance.find('input[name="cash_miles_type"]:checked').val()
		};

		var $totalTraveller = $adultSelectedEle + $teenagerSelectedEle + $childSelectedEle;
		var $index = 1;

		// fill in values for each amadeus params based on number of travellers (adults)
		for ($adultSel = 1; $adultSel <= $adultSelectedEle; $adultSel++) {
			var $value = 'ADT';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		// fill in values for each amadeus params based on number of travellers (teenagers)
		for ($teenagerSel = 1; $teenagerSel <= $teenagerSelectedEle; $teenagerSel++) {
			var $value = $('#teenagerValue').val();
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		let $teenageSelectedEle = parseInt($instance.find('input[name="passengersTeenager"]').val());
		if ($('.mobile-sidetrip-submit').is(':visible')) {
			$teenageSelectedEle = parseInt($scopeSideTrip.find('input[name="passengersTeenager"]').val());
		}
		if ($('.ibe-sidetrip-submit').is(':visible')) {
			$teenageSelectedEle = parseInt($scopeSideTrip_desk.find('input[name="passengersTeenager"]').val());
		}

		if ($('.passenger-details-selected .fst_teenager-cat').css('display') === "block") {
			$data['TEENAGER_COUNT'] = $teenageSelectedEle;
		}

		// fill in values for each amadeus params based on number of travellers (children)
		for ($childSel = 1; $childSel <= $childSelectedEle; $childSel++) {
			var $value = 'CHD';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}

		// fill in values for each amadeus params based on number of travellers (infants)
		for ($infantSel = 1; $infantSel <= $infantSelectedEle; $infantSel++) {
			var $infant_value = 'TRUE';
			$data['HAS_INFANT_' + $infantSel] = $infant_value;
		}

		/* Amadeus adobe partnership variable settings */
		/*
			let $amcvId;
				$amcvId = Visitor.getInstance("4D9676A8531512ED0A490D44").getMarketingCloudVisitorID();
				$data['AMCVID_ECID'] = $amcvId;
			*/


		// matta fair cug campaign
		if ($('#search-param-cug-matta').length > 0) {
			if ($('#search-param-cug-matta').val() && $('#search-param-cug-matta').val() != null) {
				$data['MATTA_CUG'] = 'TRUE';
				$data['SO_SITE_ALPI_DISA_FIELD'] = 'TRUE';
				$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			}
		}

		$data['FST'] = true;
		var $multiTripFlowUrl = $.param($data);

		let $tabularData: any = {};
		for (var dkey in $data) {
			$tabularData[dkey] = { 'value': $data[dkey] };
		}
		let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
		if (loginTokenCookieVal != null) {
			// find login status here
			_self.bookingFormBackend.retrieveMemberInfoForCash($instance, $.param($data), "multi");
		} else {
			let $tripflow_encryptURL = encodeURIComponent($multiTripFlowUrl);
			_self.bookingFormBackend.desktopMultiFormSubmitToServlet($instance, $tripflow_encryptURL);

		}

	}

	mobileBookingFormValidation($instance: any, $officeCode: any, callback: any): any {
		let _self = this;
		let formDataValid = true;
		// formDataWhichFail = [];
		let $errorList: Array<any> = [];
		let $errorValidation = $instance.find('.error-validation').first();
		let $passengerDetails: any = $instance.find('[data-mob-booking-passenger-details]');
		let $passengerDetailsActive: any = $instance.find('[data-mob-booking-passenger-details-selected]');

		$errorValidation.show();

		// Validation: empty from location
		let $mobFromLocation: any = $instance.find('.ibe-mob-from--location');
		let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
		if ($mobFromLocation.val() == '') {
			if ($('#members-travel--subsidy').length < 1 && $('#ibe-standalone-travelpass').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
				$instance.find('.ibe-mob-from--location-input').parent().addClass('has-error');
				$instance.find('.ibe-mob-from--location-input').parent().find('.booking-form--title').addClass('has-error');
				let $mobileFromLocValidate: any = $instance.find('.ibe-mob-from--location-input').attr('data-mobiledepartloc');
				$errorList.push('<strong>' + $instance.find('.ibe-mob-from--location-input').parent().find('.booking-form--title').text() + '</strong>: ' + $mobileFromLocValidate);
			}
			else {
				$mobFromLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$mobFromLocation.parent().find('.booking-form--title').addClass('has-error');
				let $mobileFromLocValidate: any = $mobFromLocation.attr('data-mobiledepartloc');
				$errorList.push('<strong>' + $mobFromLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $mobileFromLocValidate);
			}
			formDataValid = false;
			// formDataWhichFail.push('emptyfromlocation');
		} else {
			if ($('#members-travel--subsidy').length < 1 && $('#ibe-standalone-travelpass').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
				$instance.find('.ibe-mob-from--location-input').parent().removeClass('has-error');
				$instance.find('.ibe-mob-from--location-input').parent().find('.booking-form--title').removeClass('has-error');
			} else {
				$mobFromLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$mobFromLocation.parent().find('.booking-form--title').removeClass('has-error');
			}
		}

		// Validation: empty to location
		let $mobToLocation: any = $instance.find('.ibe-mob-to--location');
		if ($mobToLocation.val() == '') {
			if ($('#members-travel--subsidy').length < 1 && $('#ibe-standalone-travelpass').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
				$instance.find('.ibe-mob-to--location-input').parent().addClass('has-error');
				$instance.find('.ibe-mob-to--location-input').parent().find('.booking-form--title').addClass('has-error');
				let $mobileToLocValidate: any = $instance.find('.ibe-mob-to--location-input').attr('data-mobiledestloc');
				$errorList.push('<strong>' + $instance.find('.ibe-mob-to--location-input').parent().find('.booking-form--title').text() + '</strong>: ' + $mobileToLocValidate);
			}
			else {
				$mobToLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$mobToLocation.parent().find('.booking-form--title').addClass('has-error');
				let $mobileToLocValidate: any = $mobToLocation.attr('data-mobiledestloc');
				$errorList.push('<strong>' + $mobToLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $mobileToLocValidate);
			}
			formDataValid = false;
			// formDataWhichFail.push('emptytolocation');
		} else {
			if ($('#members-travel--subsidy').length < 1 && $('#ibe-standalone-travelpass').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
				$instance.find('.ibe-mob-to--location-input').parent().removeClass('has-error');
				$instance.find('.ibe-mob-to--location-input').parent().find('.booking-form--title').removeClass('has-error');
			}
			else {
				$mobToLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$mobToLocation.parent().find('.booking-form--title').removeClass('has-error');
			}
		}

		// Validation: from and to location the same
		if ($mobFromLocation.val().split('_')[0] === $mobToLocation.val()) {
			if ($('#members-travel--subsidy').length < 1 && $('#ibe-standalone-travelpass').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
				$instance.find('.ibe-mob-to--location-input').parent().addClass('has-error');
				$instance.find('.ibe-mob-to--location-input').parent().find('.booking-form--title').addClass('has-error');
			}
			else {
				$mobToLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$mobToLocation.parent().find('.booking-form--title').addClass('has-error');
			}
			formDataValid = false;
			// formDataWhichFail.push('fromtosame');
			if (!($mobFromLocation.val() == '' || $mobToLocation.val() == '')) {
				if ($('#members-travel--subsidy').length < 1 && $('#ibe-standalone-travelpass').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
					let $mobileFromToLocValidate: any = $instance.find('.ibe-mob-to--location-input').attr('data-mobiledeptlestloc');
					$errorList.push('<strong>' + $instance.find('.ibe-mob-from--location-input').parent().find('.booking-form--title').text() + ', ' + $instance.find('.ibe-mob-to--location-input').parent().find('.booking-form--title').text() + '</strong>: ' + $mobileFromToLocValidate);
				}
				else {
					let $mobileFromToLocValidate: any = $mobToLocation.attr('data-mobiledeptlestloc');
					$errorList.push('<strong>' + $mobFromLocation.parent().find('.booking-form--title').text() + ', ' + $mobToLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $mobileFromToLocValidate);
				}
			}
		}

		let $oneWayTripEl: any = $instance.find('.trip-type--container .oneWayTrip'),
			$oneWayDepDate: any = $instance.find('.oneWayTrip .departureDateMobile'),
			$returnDepDate: any = $instance.find('.departureDateMobile'),
			$returnRetDate: any = $instance.find('.returnDateMobile');

		// Validation: One Way Trip Date empty field validation
		if ($oneWayTripEl.hasClass('selected')) {
			if ($oneWayDepDate.val() == '') {
				$oneWayDepDate.parent().parent().addClass('has-error');
				let $travelDateOne: any = $instance.find('.departureDateMobile.oneway-trip').attr('data-mobiletraveldateone');
				$errorList.push('<strong>' + $oneWayDepDate.parent().find('label.one-dep-title').text() + ':</strong> ' + $travelDateOne);
				formDataValid = false;
				// formDataWhichFail.push('onewayempty');
			} else {
				$oneWayDepDate.parent().parent().removeClass('has-error');
			}
		} else {
			// Validation: return way departure date missing
			if ($returnDepDate.val() == '') {
				$returnDepDate.parent().parent().addClass('has-error');
				let $mobileTravelDate: any = $returnDepDate.attr('data-mobiletravelDepdate');
				$errorList.push('<strong>' + $returnDepDate.parent().find('label.dep-title').text() + '</strong>: ' + $mobileTravelDate);
				formDataValid = false;
				// formDataWhichFail.push('returndepdatemissing');
			} else {
				$returnDepDate.parent().parent().removeClass('has-error');
			}

			// Validation: return return date missing
			if ($returnRetDate.val() == '') {
				$returnRetDate.parent().parent().addClass('has-error');
				let $travelEndDate: any = $returnRetDate.attr('data-mobiletravelRetdate');
				$errorList.push('<strong>' + $returnRetDate.parent().find('label.ret-title').text() + '</strong>: ' + $travelEndDate);
				formDataValid = false;
				// formDataWhichFail.push('returnretdatemissing');
			} else {
				$returnRetDate.parent().parent().removeClass('has-error');
			}
		}

		// Validation: no passengers selected
		if ($instance.find('input.total-tickets--value').val() == 0) {
			let $nopassengerMob: any = $instance.find('.total-tickets--value.mobile').attr('data-mob-passenger');
			$passengerDetails.addClass('has-errors');
			$errorList.push('<strong>' + $mobToLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $nopassengerMob);
			formDataValid = false;
			// formDataWhichFail.push('nopsgselected');
		} else {
			$passengerDetails.removeClass('has-errors');
		}

		// Validation: infant booking
		// infants > adults
		if ($instance.find('.infant-booking--error---mobile').css('display') == 'block') {
			$passengerDetails.addClass('has-error');
			let $mobileMoreInfant: any = $instance.find('.infant-booking--error---mobile').attr('data-mobilemoreinfant');
			$errorList.push('<strong>' + $passengerDetails.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.adult-cat .booking-category').text() + '</strong>: ' + $mobileMoreInfant);
			formDataValid = false;
			// formDataWhichFail.push('moreinfants');
		} else if ($instance.find('.adult-booking--error---mobile').css('display') == 'block') {
			// adults > infants
			$passengerDetails.addClass('has-error');
			let $mobileLessAdult: any = $instance.find('.adult-booking--error---mobile').attr('data-mobilelessadult');
			$errorList.push('<strong>' + $passengerDetails.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.infant-cat .booking-category').text() + +'</strong>: ' + $mobileLessAdult);
			formDataValid = false;
			// formDataWhichFail.push('moreadults');
		} else {
			$passengerDetails.removeClass('has-error');
		}

		let $cabinClass: any = $instance.find('.cabin-class-mob').val();
		let $paymentMethod = $instance.find('input[name="cash_miles_type"]:checked').val();
		let $infantTicketValue: any = $instance.find('.ticket-mob-infant--input').val();
		let $infantAlertContainer: any = $('#infant-alert--container');
		let $warningAccepted: any = $infantAlertContainer.find('input[name="infant_warning"]');

		// Validation: infant booking
		// mobile booking form
		// open popup if these conditions are met:
		// - cabinclass = 'CFFFIRST'
		// - warning != 'accepted'
		// - infantTicketvalue > 0
		// - form submission is valid till this point
		if (formDataValid === true && $cabinClass == "CFFFIRST" && $warningAccepted.val() !== 'accepted' && $infantTicketValue > 0) {
			$instance.find('.error-validation').hide();
			if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
				$.magnificPopup.open({
					items: {
						src: '#infant-alert--container'
					},
					type: 'inline',
					midClick: true,
					callbacks: {
						open: function () {
							let instance = this;
							let $el: any = instance.content;
							// console.log('infant booking mobile booking form', $instance, instance);
							_self.bookflightinfant.submitBtns($instance);

							if ($paymentMethod === 'cash') {
								$el.find('input[name="tripflow"]').val('single_mob');
								$el.find('input[name="payment_method"]').val('cash');
							} else if ($paymentMethod !== 'cash') {
								$el.find('input[name="tripflow"]').val('single_mob');
								$el.find('input[name="payment_method"]').val('miles');
							}

						}
					}
				}, 0);
			} else {
				$.magnificPopup.proto.close.call(this);
				$.magnificPopup.instance.close = function () {
					$.magnificPopup.open({
						items: {
							src: '#infant-alert--container'
						},
						type: 'inline',
						midClick: true,
						callbacks: {
							open: function () {
								let instance = this;
								let $el: any = instance.content;
								// console.log('infant booking mobile booking form', $instance, instance);
								_self.bookflightinfant.submitBtns($instance);

								if ($paymentMethod === 'cash') {
									$el.find('input[name="tripflow"]').val('single_mob');
									$el.find('input[name="payment_method"]').val('cash');
								} else if ($paymentMethod !== 'cash') {
									$el.find('input[name="tripflow"]').val('single_mob');
									$el.find('input[name="payment_method"]').val('miles');
								}

							}
						}
					}, 0);
				};
			}
			return false;
		}


		// Validation: cabin class error
		let $mobCabinClass: any = $instance.find('.cabin-class-mob');
		if ($mobCabinClass.val() == '') {
			$mobCabinClass.parent().find('.selectize-control .selectize-input').addClass('has-error');
			$mobCabinClass.parent().find('.booking-form--title').addClass('has-error');
			let $mobileCabin: any = $mobCabinClass.attr('data-mobilecabin');
			$errorList.push('<strong>' + $mobCabinClass.parent().find('.booking-form--title').text() + '</strong>: ' + $mobileCabin);
			formDataValid = false;
			// formDataWhichFail.push('cabinclasserror');
		} else {
			$mobCabinClass.parent().find('.selectize-control .selectize-input').removeClass('has-error');
			$mobCabinClass.parent().find('.booking-form--title').removeClass('has-error');
		}

		// Validation: invalid coupon code
		////// let $mobCouponCode = $instance.find('.couponcode-input-mob');
		////// if ($mobCouponCode.val() != '1234') {
		////// 	$mobCouponCode.parent().addClass('has-error');
		////// 	let $mobileCouponCodeError = $mobCouponCode.attr('data-mobilecouponcode');
		////// 	_$errorList.push('<strong>' + $mobCouponCode.parent().find('.booking-form--title').text() + '</strong>: ' + $mobileCouponCodeError);
		////// 	formDataValid = false;
		////// } else {
		////// 		$mobCouponCode.parent().removeClass('has-error');
		////// 	}

		// submit and parse errors
		let $validationContainer: any = $errorValidation.find(".mobile-validation--content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist: any = $validationContainer;

		for (var i = 0, len = $errorList.length; i < len; i++) {
			$validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
		}

		// workaround: validate all fields except redemption login
		// hide error validation container if everything up to this point
		// is valid.
		// this is because redemption login has its own error container.
		if (formDataValid) {
			$errorValidation.hide();
		}

		// console.log(formDataValid);
		// console.log(formDataWhichFail);

		// Validation: redemption login fields
		let loginContainer = $instance.find('.container--redemption-login');
		// console.log(loginContainer);
		let redemptionLoginValidation = _self.loginFieldsValidation($instance);

		if (loginContainer.hasClass('hidden')) {
			redemptionLoginValidation = true;
		}

		if (!redemptionLoginValidation) {
			formDataValid = false;
		}
		// travel pass balace check
		if ($("#travel_pass").length > 0 && formDataValid) {
			let $travelpass_id = $('select.travel-pass--id option')[0].value.split('|')[0];
			let $travelpassbalancecheckurl: string = $('[data-get-travel-pass-details]').attr('data-get-travel-pass-details');
			let $data = {
			}
			$data['TRAVELPASS_ID'] = $travelpass_id;
			$.ajax({
				type: 'GET',
				url: $travelpassbalancecheckurl,
				data: $data,
				success: function (msg: any) {
					let json: any = null;
					if (typeof msg === 'string') {
						json = JSON.parse(msg);
					} else {
						json = msg;
					}
					var success = json.travelPassInfo[0].remainingQuota;
					if (success > 0) {

						$errorValidation.hide();
						if (typeof callback === "function") {
							callback($officeCode);
						}
					}
					else {
						$errorValidation.find(".mobile-validation--content").html("Balance is in sufficient.Please check");
						$errorValidation.show();
					}
				},
				error: function (error: any) {
					$errorValidation.find(".validation-content").html("Please try after some time");
				}
			})
		}
		else {
			if (formDataValid && typeof callback === 'function') {
				callback($officeCode);
			} else { return false; }
		}
	}

	/**
	 * [mobileBookingFormSubmit description]
	 * @return {any} [description]
	 */
	mobileBookingFormSubmit($instance: any, directLogin: any, additionalParam: any, redemptionType: any, $officeCode: any): any {
		// console.log('mobileBookingFormSubmit', $officeCode);
		let _self = this;

		let formData: any = $instance.find('[data-form-booking--trip]').serializeArray();
		let formObj: any = {};

		$(formData).each(function (i: any, field: any) {
			formObj[field.name] = field.value;
		});

		// Get the user-defined values
		let $couponCodeMobile: any;
		let $fromLocation = $instance.find('.ibe-mob-from--location').val().split('_')[0];
		let $toLocation = $instance.find('.ibe-mob-to--location').val();
		// $linkURL = 'https://wav.bibi.amadeus.com/plnext/MHmobile/Override.action?UI_EMBEDDED_TRANSACTION=MAvailabilityFlowDispatcher&ENCT=1&LANGUAGE=GB&MT=A&SEARCH_PAGE=FP&SITE=', $siteURL = this.$siteCode, $enc = '&ENC=', $webServiceURL = $linkURL + $siteURL + $enc,
		// $couponCodeMobile = $instance.find('.couponcode-input-mob').val(),
		let $paramCugMobile = $instance.find('#search-param-cug-mobile').val();
		let $tripType = $instance.find('.trip-type--container li.selected a').attr('data-triptype');
		let $getDepartureDate: any;

		if ($tripType == 'R') {
			$getDepartureDate = $instance.find('.returnTrip .departureDateMobile').val();
		} else {
			$getDepartureDate = $instance.find('.oneWayTrip .departureDateMobile').val();
		}

		let $departureDate = moment(new Date($getDepartureDate)).format('YYYYMMDDhhmm');
		let $getReturnDate = $instance.find('.returnDateMobile').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYYMMDDhhmm');
		// $encTime = new Date($.now() + 364 * 24*3600*1000),
		let $cabinClass = $instance.find('.cabin-class-mob').val();

		// $youthSel,
		let $adultSel: any,
			$childSel: any,
			$infantSel: any,
			$teenagerSel

		let $adultSelectedEle = parseInt($instance.find('input[name="passengersAdult"]').val());
		// $youthSelectedEle = parseInt($instance.find('input[name="passengersYouth"]').val());
		let $childSelectedEle = parseInt($instance.find('input[name="passengersChildren"]').val());
		let $infantSelectedEle = parseInt($instance.find('input[name="passengersInfant"]').val());
		let $teenageSelectedEle = parseInt($instance.find('input[name="passengersTeenager"]').val());
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFSTUBUS"
			}
			if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFSTUECO"
			}
		}
		let couponCookieVal = document.cookie.match('(^|;)\\s*corpCode\\s*=\\s*([^;]+)');

		if (couponCookieVal != null) {
			$couponCodeMobile = couponCookieVal ? couponCookieVal.pop() : '';
			document.cookie = 'corpCode' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		} else {
			$couponCodeMobile = $instance.find('.couponcode-input-mob').val()
		}
		let hasInfant: string = 'FALSE';
		if ($instance.find('input[name="passengersInfant"]').val() && $instance.find('input[name="passengersInfant"]').val() != "" && $instance.find('input[name="passengersInfant"]').val() != "0") {
			hasInfant = 'TRUE';
		}
		let $targetVal = _self.getAdobeTargetValue();
		let $externalId;
		if ($targetVal) {
			$externalId = $targetVal;
		} else {
			$externalId = 'Mobile Booking';
		}

		let $data = {
			ALLOW_PRIMARY_ADT: 'Y',
			ALLOW_PRIMARY_CHD: 'Y',
			B_DATE_1: ($departureDate == 'Invalid date' ? '' : $departureDate),
			B_DATE_2: ($returnDate == 'Invalid date' ? '' : $returnDate),
			B_LOCATION_1: $fromLocation,
			B_LOCATION_2: $toLocation,
			COMMERCIAL_FARE_FAMILY_1: $cabinClass,
			DATE_RANGE_QUALIFIER_1: 'C',
			DATE_RANGE_QUALIFIER_2: 'C',
			DATE_RANGE_VALUE_1: '3',
			DATE_RANGE_VALUE_2: '3',
			// ENC_TIME: '20171220165420',
			EXTERNAL_ID: $externalId,
			E_LOCATION_1: $toLocation,
			E_LOCATION_2: $fromLocation,
			FIELD_ADT_NUMBER: $instance.find('input[name="passengersAdult"]').val(),
			FIELD_CHD_NUMBER: $instance.find('input[name="passengersChildren"]').val(),
			FIELD_INFANTS_NUMBER: $instance.find('input[name="passengersInfant"]').val(),
			HAS_INFANT_1: hasInfant,
			// LANGUAGE: 'GB',
			MAX_PAX_TYPES_VALUE: '9',
			MAX_PAX_VALUE: '9',
			MT: 'A',
			PLTG_FROMPAGE: 'ADVS',
			SEARCH_PAGE: 'FP',
			SEVEN_DAY_SEARCH: 'TRUE',
			SITE: 'mobile',
			// SO_SITE_FP_TRACES_ON: 'FALSE',
			// SO_SITE_FQ_INTERFACE_ACTIVE: 'FALSE',
			// SO_SITE_HOST_TRACE_ACTIVE: 'TRUE',
			// SO_SITE_SI_1AXML_FROM: 'SEP_JCP',
			// SO_SITE_SI_PASSWORD: 'UNSET',
			// SO_SITE_SI_SAP: '1ASIXJCP',
			// SO_SITE_SI_SERVER_IP: '193.23.185.67',
			// SO_SITE_SI_SERVER_PORT: '18033',
			// SO_SITE_SI_USER: 'UNSET',
			// SO_SITE_APIV2_SERVER: '194.156.170.78',
			// SO_SITE_APIV2_SERVER_PWD: 'TAZ',
			// SO_SITE_APIV2_SERVER_USER_ID: 'GUEST',
			// SO_SITE_CORPORATE_ID: 'OCGPDT',
			SO_SITE_ENABLE_ERR_REDIRECT: 'TRUE',
			SO_SITE_MATRIX_CALENDAR: 'FALSE',
			SO_SITE_MC_RBD_DISP_RVW: 'TRUE',
			SO_SITE_MOP_CREDIT_CARD: 'TRUE',
			SO_SITE_OFFICE_ID: $officeCode,
			SO_SITE_QUEUE_OFFICE_ID: 'KULMH08MM',
			// SO_SITE_POINT_OF_SALE: $fromLocation,
			// SO_SITE_POINT_OF_TICKETING: $fromLocation,
			TRAVELLER_TYPE_1: '',
			TRAVELLER_TYPE_2: '',
			UI_EMBEDDED_TRANSACTION: 'MAvailabilityFlowDispatcher',
			TRIP_TYPE: $tripType,
			ADULT_COUNT: $adultSelectedEle,
			CHILD_COUNT: $childSelectedEle,
			// YOUTH_COUNT: $youthSelectedEle,
			INFANT_COUNT: $infantSelectedEle,
			param_cug: $paramCugMobile,
			SO_SITE_DEPRECABLE_CTC_DUP: 'TRUE',
			SO_SITE_MC_ALLOW_SEAT_BOOK: 'FALSE',
			SO_SITE_SEATMAP_MODIF: 'FALSE',
			SO_SITE_USE_CTC_BASKET_MODE: 'TRUE'
		};
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			$data['SO_SITE_ALPI_DISA_FIELD'] = 'TRUE';
		}
		let $totalTraveller: number = $adultSelectedEle + $teenageSelectedEle + $childSelectedEle;
		let $index = 1;

		for ($adultSel = 1; $adultSel <= $adultSelectedEle; $adultSel++) {
			let $value = 'ADT';
			if (studentEnrichIdCookieVal != null && studentDashboard != null) {
				$value = 'STU';
			}
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}

		// for ($youthSel=1; $youthSel <= $youthSelectedEle; $youthSel++){
		// 	let $value = 'B15';
		// 	$data['TRAVELLER_TYPE_'+$index] = $value;
		// 	$index++;
		// }
		for ($teenagerSel = 1; $teenagerSel <= $teenageSelectedEle; $teenagerSel++) {
			let $value = $('#teenagerValue').val();
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		if ($('.passenger-details-selected .teenager-cat').css('display') === "block") {
			$data['TEENAGER_COUNT'] = $teenageSelectedEle;
		}
		for ($childSel = 1; $childSel <= $childSelectedEle; $childSel++) {
			let $value = 'CHD';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}

		for ($infantSel = 1; $infantSel <= $infantSelectedEle; $infantSel++) {
			let $infant_value = 'TRUE';
			$data['HAS_INFANT_' + $infantSel] = $infant_value;
		}

		if ($couponCodeMobile != '') {
			$data['LIST_CORPORATE_NUMBER_1_1'] = $couponCodeMobile;
			$data['TYPE_OF_CORPORATE_FARE_1'] = '2';
			$data['IS_PRICE_BY_INPUT_1'] = 'TRUE';
		}

		if ($paramCugMobile) {
			$data['partnerName'] = $('#cug-partner-name').val();
			$data['userName'] = $('#cug-user-name').val();
		}
		/* Amadeus adobe partnership variable settings */
		if (typeof Visitor !== 'undefined') {
			let $amcvId;
			$amcvId = Visitor.getInstance("4D9676A8531512ED0A490D44").getMarketingCloudVisitorID();
			$data['AMCVID_ECID'] = $amcvId;
		}
		else {
			$data['AMCVID_ECID'] = '';
		}

		// let $tripFlowUrl = ($.param($data).replace(/\+/g, "%20"));
		// console.log($tripFlowUrl);

		let $tripFlowUrl: any;

		if (redemptionType != "") {
			$tripFlowUrl = $.param($data) + "&" + directLogin + "" + additionalParam;
		} else {
			$tripFlowUrl = $.param($data) + "&SO_GL=";
		}
		if ($("#enrichAlwaysonToggleButtonFlag").hasClass("hideclass") === false) {
			const enrichAlwaysonToggleButtonFlag = $("#enrichAlwaysonToggleButtonFlag").is(":checked") ? "TRUE" : 'FALSE';
			$data['ENRICH_ALWAYS_ON_FLAG'] = enrichAlwaysonToggleButtonFlag;
		}

		let $tripflow_encryptURL = encodeURIComponent($tripFlowUrl);

		// console.log("tripFlowUrl:" + $tripFlowUrl);
		// alert($tripFlowUrl);
		// console.log($data);

		// let $tabularData:any = {};
		// for (var dkey in $data) {
		// 	$tabularData[dkey] = {'value': $data[dkey]};
		// }
		_self.bookingFormBackend.mobileFormSubmitToServlet($instance, $tripflow_encryptURL);
	}

	/**
	 * Form submission for single trip booking
	 * - one way or return
	 * @return {any} [description]
	 */
	mobileRedemptionBookingFormSubmit($instance: any, directLogin: any, additionalParam: any, redemptionType: any, $officeCode: any): any {
		let _self = this;

		let formData: any = $instance.find('[data-form-booking--trip]').serializeArray();
		let formObj: any = {};

		$(formData).each(function (i: any, field: any) {
			formObj[field.name] = field.value;
		});

		// Get the user-defined values
		let $couponCodeMobile: any;
		let $fromLocation = $instance.find('.ibe-mob-from--location').val().split('_')[0];
		let $toLocation = $instance.find('.ibe-mob-to--location').val();
		let $paramCug = $('#search-param-cug-mobile').val();
		//$linkURL = 'https://wav.bibi.amadeus.com/plnext/MASAirways/Override.action?EMBEDDED_TRANSACTION=FlexPricerAvailability&ENCT=1&LANGUAGE=GB&SITE=', $siteURL = this.$siteCode, $enc = '&ENC=', $webServiceURL = $linkURL + $siteURL + $enc,
		let $tripType = $instance.find('.trip-type--container li.selected a').attr('data-triptype');
		let $getDepartureDate: any;

		if ($tripType == 'R') {
			$getDepartureDate = $instance.find('.returnTrip .departureDateMobile').val();
		} else {
			$getDepartureDate = $instance.find('.oneWayTrip .departureDateMobile').val();
		}

		let $departureDate = moment(new Date($getDepartureDate)).format('YYYYMMDDhhmm');
		let $getReturnDate = $instance.find('.returnDateMobile').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYYMMDDhhmm');
		//$couponCode = $instance.find('.couponcode-input').val(),
		// $encTime                  = new Date($.now() + 364 * 24*3600*1000),
		let $cabinClass = $instance.find('.cabin-class-mob').val();

		let $adultSel: any,
			$childSel: any,
			$infantSel: any,
			$teenagerSel: any;
		let $adultSelectedEle = parseInt($instance.find('input[name="passengersAdult"]').val());
		// let $youthSelectedEle = parseInt($instance.find('.passengersYouth').val());
		let $childSelectedEle = parseInt($instance.find('input[name="passengersChildren"]').val());
		let $infantSelectedEle = parseInt($instance.find('input[name="passengersInfant"]').val());
		let $teenageSelectedEle = parseInt($instance.find('input[name="passengersTeenager"]').val());

		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFSTUBUS"
			}
			if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFSTUECO"
			}
		}
		if (redemptionType == "cash_miles") {
			if ($cabinClass == "CFFFIRST") {
				$cabinClass = "CFFFMC"
			}
			else if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFJMC"
			}
			else if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFYMC"
			}
		} else if (redemptionType == "miles") {
			if ($cabinClass == "CFFFIRST") {
				$cabinClass = "CFFFMILES"
			}
			else if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFJMILES"
			}
			else if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFYMILES"
			}
		}
		let couponCookieVal = document.cookie.match('(^|;)\\s*corpCode\\s*=\\s*([^;]+)');

		if (couponCookieVal != null) {
			$couponCodeMobile = couponCookieVal ? couponCookieVal.pop() : '';
			document.cookie = 'corpCode' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		} else {
			$couponCodeMobile = $instance.find('.couponcode-input-mob').val();
		}
		let $targetVal = _self.getAdobeTargetValue();
		let $externalId;
		if ($targetVal) {
			$externalId = $targetVal;
		} else {
			$externalId = 'BOOKING';
		}
		let $data = {
			ARRANGE_BY: 'R',
			BOOKING_FLOW: 'REVENUE',
			B_ANY_TIME_1: 'TRUE',
			B_ANY_TIME_2: 'TRUE',
			B_DATE_1: ($departureDate == 'Invalid date' ? '' : $departureDate),
			B_DATE_2: ($returnDate == 'Invalid date' ? '' : $returnDate),
			B_LOCATION_1: $fromLocation,
			B_LOCATION_2: $toLocation,
			COMMERCIAL_FARE_FAMILY_1: $cabinClass,
			COMMERCIAL_FARE_FAMILY_2: '',
			COMMERCIAL_FARE_FAMILY_3: '',
			DATE_RANGE_QUALIFIER_1: 'C',
			DATE_RANGE_QUALIFIER_2: 'C',
			DATE_RANGE_VALUE_1: '3',
			DATE_RANGE_VALUE_2: '3',
			DISPLAY_TYPE: '2',
			EMBEDDED_TRANSACTION: 'FlexPricerAvailability',
			EXTERNAL_ID: $externalId,
			E_LOCATION_1: $toLocation,
			E_LOCATION_2: $fromLocation,
			HAS_INFANT_1: 'FALSE',
			HAS_INFANT_2: 'FALSE',
			HAS_INFANT_3: 'FALSE',
			HAS_INFANT_4: 'FALSE',
			HAS_INFANT_5: 'FALSE',
			HAS_INFANT_6: 'FALSE',
			HAS_INFANT_7: 'FALSE',
			HAS_INFANT_8: 'FALSE',
			HAS_INFANT_9: 'FALSE',
			PRICING_TYPE: 'O',
			REFRESH: '0',
			SITE: 'desktop',
			// SO_SITE_SI_1AXML_FROM: 'SEP_JCP',
			// SO_SITE_SI_PASSWORD: 'UNSET',
			// SO_SITE_SI_SAP: '1ASIXJCP',
			// SO_SITE_SI_SERVER_IP: '193.23.185.67',
			// SO_SITE_SI_SERVER_PORT: '18033',
			// SO_SITE_SI_USER: 'UNSET',
			// SO_SITE_APIV2_SERVER: '194.156.170.78',
			// SO_SITE_APIV2_SERVER_PWD: 'TAZ',
			// SO_SITE_APIV2_SERVER_USER_ID: 'GUEST',
			// SO_SITE_CORPORATE_ID: 'OCGPDT',
			// SO_SITE_EXT_MerchantID: '',
			// SO_SITE_EXT_PSPURL: '',
			// SO_SITE_FP_ELEM_LEV_FF_DISP: 'TRUE',
			// SO_SITE_FP_SEG_FLIGHT_TIME: 'TRUE',
			// SO_SITE_FP_TRACES_ON: 'FALSE',
			// SO_SITE_FQ_INTERFACE_ACTIVE: 'FALSE',
			// SO_SITE_HOST_TRACE_ACTIVE: 'TRUE',
			// SO_SITE_NEW_UI_ENABLED: 'TRUE',
			// SO_SITE_NEW_UI_LIST_TPLS_ON: 'ALL',
			SO_SITE_OFFICE_ID: $officeCode,
			// SO_SITE_PNR_SHARING: 'TRUE',
			// SO_SITE_RUI_AX_TIMR_ENABLED: 'TRUE',
			// SO_SITE_QUEUE_CATEGORY: '0C0',
			SO_SITE_QUEUE_OFFICE_ID: $officeCode,
			// SO_SITE_RUI_AX_CAL_ENABLED: 'TRUE',
			// SO_SITE_RUI_CAL_HORIZ_DEPAR: 'TRUE',
			// SO_SITE_RUI_ENABLE_IMPL_DATA: 'TRUE',
			// SO_SITE_RUI_FARE_VERTICAL: 'FALSE',
			// SO_SITE_RUI_HIDE_MDF_SRC: 'TRUE',
			// SO_SITE_SEATMAP_POPOVER_DISP: 'TRUE',
			// SO_SITE_SI_1AXML_FROM: 'SEP_JCP',
			// SO_SITE_SI_PASSWORD: 'UNSET',
			// SO_SITE_SI_SAP: '1ASIXJCP',
			// SO_SITE_SI_SERVER_IP: '193.23.185.67',
			// SO_SITE_SI_SERVER_PORT: '18033',
			// SO_SITE_SI_USER: 'UNSET',
			// SO_SITE_SPECIAL_REQ_NUMBER: '3',
			// SO_SITE_STORE_ITINERARIES: 'TRUE',
			TRAVELLER_TYPE_1: '',
			TRAVELLER_TYPE_2: '',
			TRAVELLER_TYPE_3: '',
			TRAVELLER_TYPE_4: '',
			TRAVELLER_TYPE_5: '',
			TRAVELLER_TYPE_6: '',
			TRAVELLER_TYPE_7: '',
			TRAVELLER_TYPE_8: '',
			TRAVELLER_TYPE_9: '',
			TRIP_FLOW: 'YES',
			TRIP_TYPE: $tripType,
			ADULT_COUNT: $adultSelectedEle,
			TEENAGER_COUNT: $teenageSelectedEle,
			CHILD_COUNT: $childSelectedEle,
			// YOUTH_COUNT: $youthSelectedEle,
			INFANT_COUNT: $infantSelectedEle,
			param_cug: $paramCug,
			RDM_MEM_ID: formObj['redemption_member_id'],
			RDM_MEM_LN: formObj['redemption_member_lastname'],
			RDM_MEM_PIN: formObj['redemption_member_pin'],
			RDM_PAYMENT: $instance.find('input[name="cash_miles_type"]:checked').val()
		};
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			$data['SO_SITE_ALPI_DISA_FIELD'] = 'TRUE';
			if ($('#mab-bookingnav .navbar #bookingNav li.selected a').hasClass('mob-flysiswa')) {
				$data['MOT'] = 'TRUE';
			}
		}
		if ($instance.find('input[name="cash_miles_type"]:checked').val() === "miles") {
			$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			$data['SO_SITE_MULTI_DIRECT_LOGIN'] = 'TRUE';
		}
		let $totalTraveller: number = $adultSelectedEle + $teenageSelectedEle + $childSelectedEle;
		let $index = 1;
		for ($adultSel = 1; $adultSel <= $adultSelectedEle; $adultSel++) {
			let $value = 'ADT';
			if (studentEnrichIdCookieVal != null && studentDashboard != null) {
				$value = 'STU';
			}
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		for ($teenagerSel = 1; $teenagerSel <= $teenageSelectedEle; $teenagerSel++) {
			let $value = $('#teenagerValue').val();
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		// for ($youthSel=1; $youthSel <= $youthSelectedEle; $youthSel++) {
		// 	let $value = 'B15';
		// 	$data['TRAVELLER_TYPE_'+$index] = $value;
		// 	$index++;
		// }

		for ($childSel = 1; $childSel <= $childSelectedEle; $childSel++) {
			let $value = 'CHD';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}

		for ($infantSel = 1; $infantSel <= $infantSelectedEle; $infantSel++) {
			let $infant_value = 'TRUE';
			$data['HAS_INFANT_' + $infantSel] = $infant_value;
		}

		if ($couponCodeMobile != '') {
			$data['LIST_CORPORATE_NUMBER_1_1'] = $couponCodeMobile;
			$data['TYPE_OF_CORPORATE_FARE_1'] = '2';
			$data['IS_PRICE_BY_INPUT_1'] = 'TRUE';
		}

		if ($paramCug) {
			$data['partnerName'] = $('#cug-partner-name').val();
			$data['userName'] = $('#cug-user-name').val();
		}


		let $tripFlowUrl: any;

		if (redemptionType != "") {
			$tripFlowUrl = $.param($data) + "&" + directLogin + "" + additionalParam;
		} else {
			$tripFlowUrl = $.param($data) + "&SO_GL=";
		}

		/* Amadeus adobe partnership variable settings */
		if (typeof Visitor !== 'undefined') {
			let $amcvId;
			$amcvId = Visitor.getInstance("4D9676A8531512ED0A490D44").getMarketingCloudVisitorID();
			$data['AMCVID_ECID'] = $amcvId;
		}
		else {
			$data['AMCVID_ECID'] = '';
		}
		//Adding MHAthlete value for check in mobile
		let $mhAthleteVal = $('#mob_mhAthleteVal').val();
		$data['mhAthleteVal'] = $mhAthleteVal;

		//Adding Cobrand ibe value for mobile
		if ($('#ibe-standalone_cobrand').length > 0 && !$('#ibe-standalone_cobrand').hasClass('mfp-hide')) {
			let $cobrandIbeVal = $('#mob_cobrand_ibe_value').val();
			//alert("mobile cobrandIbeVal"+$cobrandIbeVal);
			$data['cobrand_ibe_value'] = $cobrandIbeVal;
		}

		// console.log("tripFlowUrl:" + $tripFlowUrl);
		// alert($tripFlowUrl);
		// console.log($data);

		// let $tabularData:any = {};
		// for (var dkey in $data) {
		// 	$tabularData[dkey] = {'value': $data[dkey]};
		// }
		if (!$(".enrichOnDiscountToggleContainer ").hasClass("hideclass")) {
			const enrichAlwaysonToggleButtonFlag = !$("#enrichAlwaysonToggleButtonFlag").hasClass("hideclass") && $("#enrichAlwaysonToggleButtonFlag").is(":checked") ? "TRUE" : 'FALSE';
			$data['ENRICH_ALWAYS_ON_FLAG'] = enrichAlwaysonToggleButtonFlag;
		}
		let $tripflow_encryptURL = encodeURIComponent($tripFlowUrl);
		_self.bookingFormBackend.desktopSingleFormSubmitToServlet($instance, $tripflow_encryptURL);
	}

	/**
	 * [loginFieldsValidation description]
	 * @param  {any} scope [description]
	 * @return {any}       [description]
	 */
	loginFieldsValidation(scope: any): any {
		let validationStatus = true;

		let loginValidationContainer = scope.find('.redemption-login-error-container');
		let loginValidationText = scope.find('.redemption-login-errors .validation--error-list');

		let fieldMemberID = scope.find('[data-ibe-redemption--login-id]');
		let fieldMemberLastName = scope.find('[data-ibe-redemption--lastname]');
		let fieldMemberPassword = scope.find('[data-ibe-redemption--login-pin]');

		// console.log(loginValidationContainer, fieldMemberID, fieldMemberLastName, fieldMemberPassword);

		// console.log('%cloginFieldsValidation', 'font-weight: bold; font-size: 24px; background-color: red; color: white');
		loginValidationText.empty();
		loginValidationContainer.hide();

		if (fieldMemberID.val() === '') {
			console.log('empty field member id', scope[0].id, fieldMemberID);
			fieldMemberID.parent().addClass('has-error');
			fieldMemberID.parent().find('.booking-form--title').addClass('has-error');
			loginValidationText.append('<li><strong>' + fieldMemberID.parent().find('.booking-form--title').text() + ': </strong>' + fieldMemberID[0].dataset.errorEmpty + '</li>').show();
			validationStatus = false;
		} else {
			fieldMemberID.parent().removeClass('has-error');
			fieldMemberID.parent().find('.booking-form--title').removeClass('has-error');
		}

		// if (fieldMemberLastName.val() === '') {
		// 	// console.log('mem_ln is blank');
		// 	fieldMemberLastName.parent().addClass('has-error');
		// 	fieldMemberLastName.parent().find('.booking-form--title').addClass('has-error');
		// 	loginValidationText.append('<li><strong>'+ fieldMemberLastName.parent().find('.booking-form--title').text() +': </strong>'+ fieldMemberLastName[0].dataset.errorEmpty+'</li>').show();
		// 	validationStatus = false;
		// } else {
		// 	fieldMemberLastName.parent().removeClass('has-error');
		// 	fieldMemberLastName.parent().find('.booking-form--title').removeClass('has-error');
		// }

		if (fieldMemberPassword.val() === '') {
			console.log('empty field pw', scope[0].id, fieldMemberPassword);
			// console.log('mem_pw is blank');
			fieldMemberPassword.parent().addClass('has-error');
			fieldMemberPassword.parent().find('.booking-form--title').addClass('has-error');
			loginValidationText.append('<li><strong>' + fieldMemberPassword.parent().find('.booking-form--title').text() + ': </strong>' + fieldMemberPassword[0].dataset.errorEmpty + '</li>').show();
			validationStatus = false;
		} else {
			fieldMemberPassword.parent().removeClass('has-error');
			fieldMemberPassword.parent().find('.booking-form--title').removeClass('has-error');
		}

		// console.log(Boolean(fieldMemberID.attr('disabled')), Boolean(fieldMemberLastName.attr('disabled')), Boolean(fieldMemberPassword.attr('disabled')));

		if (!validationStatus) {
			loginValidationContainer.show();
		}

		return validationStatus;
	}

	sidetripBookingFormValidation($instance: any, $officeCode: any, callback: any): any {
		let _self = this;
		let formDataValid = true;
		let $errorList: Array<any> = [];
		let $errorValidation = $instance.find('.error-validation').first();
		let $passengerDetails: any = $instance.find('[data-sidetrip-booking-passenger-details]');
		let $passengerDetailsActive: any = $instance.find('[data-sidetrip-booking-passenger-details-selected]');

		$errorValidation.show();

		// Validation: empty from location
		let $mobFromLocation: any = $instance.find('.ibe-sideTrip-from--location');
		if ($mobFromLocation.val() == '') {
			$mobFromLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
			$mobFromLocation.parent().find('.booking-form--title').addClass('has-error');
			let $mobileFromLocValidate: any = $mobFromLocation.attr('data-mobiledepartloc');
			$errorList.push('<strong>' + $mobFromLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $mobileFromLocValidate);
			formDataValid = false;
			// formDataWhichFail.push('emptyfromlocation');
		} else {
			$mobFromLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
			$mobFromLocation.parent().find('.booking-form--title').removeClass('has-error');
		}

		// Validation: empty to location
		let $mobToLocation: any = $instance.find('.ibe-sideTrip-to--location');
		if ($mobToLocation.val() == '') {
			$mobToLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
			$mobToLocation.parent().find('.booking-form--title').addClass('has-error');
			let $mobileToLocValidate: any = $mobToLocation.attr('data-mobiledestloc');
			$errorList.push('<strong>' + $mobToLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $mobileToLocValidate);
			formDataValid = false;
			// formDataWhichFail.push('emptytolocation');
		} else {
			$mobToLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
			$mobToLocation.parent().find('.booking-form--title').removeClass('has-error');
		}

		// Validation: from and to location the same
		if ($mobFromLocation.val() === $mobToLocation.val()) {
			$mobToLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
			$mobToLocation.parent().find('.booking-form--title').addClass('has-error');
			formDataValid = false;
			// formDataWhichFail.push('fromtosame');
			if (!($mobFromLocation.val() == '' || $mobToLocation.val() == '')) {
				let $mobileFromToLocValidate: any = $mobToLocation.attr('data-mobiledeptlestloc');
				$errorList.push('<strong>' + $mobFromLocation.parent().find('.booking-form--title').text() + ', ' + $mobToLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $mobileFromToLocValidate);
			}
		}

		let $oneWayTripEl: any = $instance.find('.trip-type--container .oneWaysideTrip'),
			$oneWayDepDate: any = $instance.find('.oneWaysideTrip .departureDateSideTrip'),
			$returnDepDate: any = $instance.find('.departureDateSideTrip'),
			$returnRetDate: any = $instance.find('.returnDateSideTrip');

		// Validation: One Way Trip Date empty field validation
		if ($oneWayTripEl.hasClass('selected')) {
			if ($oneWayDepDate.val() == '') {
				$oneWayDepDate.parent().parent().addClass('has-error');
				let $travelDateOne: any = $instance.find('.departureDateSideTrip.oneway-trip').attr('data-mobiletraveldateone');
				$errorList.push('<strong>' + $oneWayDepDate.parent().find('label.one-dep-title').text() + ':</strong> ' + $travelDateOne);
				formDataValid = false;
			} else {
				$oneWayDepDate.parent().parent().removeClass('has-error');
			}
		} else {
			// Validation: return way departure date missing
			if ($returnDepDate.val() == '') {
				$returnDepDate.parent().parent().addClass('has-error');
				let $mobileTravelDate: any = $returnDepDate.attr('data-mobiletravelDepdate');
				$errorList.push('<strong>' + $returnDepDate.parent().find('label.dep-title').text() + '</strong>: ' + $mobileTravelDate);
				formDataValid = false;
				// formDataWhichFail.push('returndepdatemissing');
			} else {
				$returnDepDate.parent().parent().removeClass('has-error');
			}

			// Validation: return return date missing
			if ($returnRetDate.val() == '') {
				$returnRetDate.parent().parent().addClass('has-error');
				let $travelEndDate: any = $returnRetDate.attr('data-mobiletravelRetdate');
				$errorList.push('<strong>' + $returnRetDate.parent().find('label.ret-title').text() + '</strong>: ' + $travelEndDate);
				formDataValid = false;
				// formDataWhichFail.push('returnretdatemissing');
			} else {
				$returnRetDate.parent().parent().removeClass('has-error');
			}
		}

		// Validation: no passengers selected
		if ($instance.find('input.total-tickets-sidetrip--value').val() == 0) {
			let $nopassengerMob: any = $instance.find('.total-tickets-sidetrip--value.mobile').attr('data-mob-passenger');
			$passengerDetails.addClass('has-errors');
			$errorList.push('<strong>' + $mobToLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $nopassengerMob);
			formDataValid = false;
		} else {
			$passengerDetails.removeClass('has-errors');
		}

		// Validation: infant booking
		// infants > adults
		if ($instance.find('.infant-booking--error---stbooking').css('display') == 'block') {
			$passengerDetails.addClass('has-error');
			let $mobileMoreInfant: any = $instance.find('.infant-booking--error---stbooking').attr('data-mobilemoreinfant');
			$errorList.push('<strong>' + $passengerDetails.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.adult-cat .booking-category').text() + '</strong>: ' + $mobileMoreInfant);
			formDataValid = false;
			// formDataWhichFail.push('moreinfants');
		} else if ($instance.find('.adult-booking--error---stbooking').css('display') == 'block') {
			// adults > infants
			$passengerDetails.addClass('has-error');
			let $mobileLessAdult: any = $instance.find('.adult-booking--error---stbooking').attr('data-mobilelessadult');
			$errorList.push('<strong>' + $passengerDetails.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.infant-cat .booking-category').text() + +'</strong>: ' + $mobileLessAdult);
			formDataValid = false;
			// formDataWhichFail.push('moreadults');
		} else {
			$passengerDetails.removeClass('has-error');
		}

		let $cabinClass: any = $instance.find('.cabin-class-sidetrip').val();
		let $paymentMethod = $instance.find('input[name="cash_miles_type"]:checked').val();
		let $infantTicketValue: any = $instance.find('.ticket-mob-infant--input').val();
		let $infantAlertContainer: any = $('#infant-alert--container');
		let $warningAccepted: any = $infantAlertContainer.find('input[name="infant_warning"]');

		// Validation: infant booking
		// mobile booking form
		// open popup if these conditions are met:
		// - cabinclass = 'CFFFIRST'
		// - warning != 'accepted'
		// - infantTicketvalue > 0
		// - form submission is valid till this point
		if (formDataValid === true && $cabinClass == "CFFFIRST" && $warningAccepted.val() !== 'accepted' && $infantTicketValue > 0) {
			$instance.find('.error-validation').hide();
			$.magnificPopup.open({
				items: {
					src: '#infant-alert--container'
				},
				type: 'inline',
				midClick: true,
				callbacks: {
					open: function () {
						let instance = this;
						let $el: any = instance.content;
						// console.log('infant booking mobile booking form', $instance, instance);
						_self.bookflightinfant.submitBtns($instance);

						if ($paymentMethod === 'cash') {
							$el.find('input[name="tripflow"]').val('single_mob');
							$el.find('input[name="payment_method"]').val('cash');
						} else if ($paymentMethod !== 'cash') {
							$el.find('input[name="tripflow"]').val('single_mob');
							$el.find('input[name="payment_method"]').val('miles');
						}

					}
				}
			}, 0);
			return false;
		}


		// Validation: cabin class error
		let $mobCabinClass: any = $instance.find('.cabin-class-sidetrip');
		if ($mobCabinClass.val() == '') {
			$mobCabinClass.parent().find('.selectize-control .selectize-input').addClass('has-error');
			$mobCabinClass.parent().find('.booking-form--title').addClass('has-error');
			let $mobileCabin: any = $mobCabinClass.attr('data-mobilecabin');
			$errorList.push('<strong>' + $mobCabinClass.parent().find('.booking-form--title').text() + '</strong>: ' + $mobileCabin);
			formDataValid = false;
			// formDataWhichFail.push('cabinclasserror');
		} else {
			$mobCabinClass.parent().find('.selectize-control .selectize-input').removeClass('has-error');
			$mobCabinClass.parent().find('.booking-form--title').removeClass('has-error');
		}


		let $validationContainer: any = $errorValidation.find(".mobile-validation--content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist: any = $validationContainer;

		for (var i = 0, len = $errorList.length; i < len; i++) {
			$validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
		}


		if (formDataValid) {
			$errorValidation.hide();
		}


		if (formDataValid && typeof callback === 'function') {
			callback($officeCode);
		} else { return false; }
	}
	DesktopSidetripEligibilityCheck($instance: any) {
		let _self = this;
		let $fromLocation = $instance.find('.ibe-from--location').val().split('_')[0];
		let $toLocation = $instance.find('.ibe-to--location').val();

		let $fromSelected = $instance.find('.ibe-from--location').find(":selected");
		let $fromSelected_text = $fromSelected.text();
		let $fromCountry: any;
		if ($fromSelected_text.includes('|')) {
			let countryText: any;
			if ($fromSelected_text.split('|')[0] === 'Recent') {
				countryText = $fromSelected_text.split('|')[9];
			} else {
				countryText = $fromSelected_text.split('|')[1];
			}
			if (countryText.indexOf(',') > -1) {
				$fromCountry = countryText.split(',')[1].trim();
			} else {
				$fromCountry = countryText;
			}

		} else {
			if ($fromSelected_text.match(/,/g).length > 1) {
				$fromCountry = $fromSelected_text.substring($fromSelected_text.indexOf(",") + 1, $fromSelected_text.indexOf("(")).trim();
			} else {
				$fromCountry = $fromSelected_text.substring($fromSelected_text.lastIndexOf(",") + 1, $fromSelected_text.indexOf("(")).trim();
			}
		}

		let $toSelected = $instance.find('.ibe-to--location').find(":selected");
		let $toSelected_text = $toSelected.text();
		let $toCountry: any;
		if ($toSelected_text.includes('|')) {
			let countryText: any = $toSelected_text.split('|')[1];
			if (countryText.indexOf(',') > -1) {
				$toCountry = countryText.split(',')[1].trim();
			} else {
				$toCountry = countryText;
			}

		} else {
			if ($toSelected_text.match(/,/g).length > 1) {
				$toCountry = $toSelected_text.substring($toSelected_text.indexOf(",") + 1, $toSelected_text.indexOf("(")).trim();
			}
			else {
				$toCountry = $toSelected_text.substring($toSelected_text.lastIndexOf(",") + 1, $toSelected_text.indexOf("(")).trim();
			}
		}

		let $tripType = $instance.find('.trip-type--container li.selected a').attr('data-triptype');
		let $getDepartureDate: any;

		if ($tripType == 'R') {
			$getDepartureDate = $instance.find('.returnTrip .departureDate').val();
		} else {
			$getDepartureDate = $instance.find('.oneWayTrip .departureDate').val();
		}

		let $departureDate = moment(new Date($getDepartureDate)).format('DD/MM/YYYY');
		let $getReturnDate = $instance.find('.returnDate').val();
		let $returnDate = moment(new Date($getReturnDate)).format('DD/MM/YYYY');
		let $cabinClass = $instance.find('.cabin-class').val();

		var $data: any = {
			tripType: $tripType,
			from: $fromLocation,
			fromCountry: $fromCountry,
			to: $toLocation,
			toCountry: $toCountry,
			departureDate: $departureDate,
			returnDate: $returnDate,
			cabinClass: $cabinClass
		};
		if ($instance.parent().attr('id') === 'ibe-standalone-travelpass') {
			_self.adobeDataLayer.push('click', {
				'pageName': '',
				'pageType': 'Enrich Fly Pass - User With Fly Pass',
				'clickName': 'click:btn-click:fly-pass-find-flight',
				'componentType': 'btn',
				'componentName': '',
				'componentID': '',
				'attributes': [
					{
						'key': $data.tripType === 'O' ? 'fly-pass-find-flights-oneway' : 'fly-pass-find-flights-return',
						'value': $data.tripType === 'O' ? 'oneway' : 'return'
					}, {
						'key': 'origin',
						'value': $data.from
					}, {
						'key': 'destination',
						'value': $data.to
					}, {
						'key': 'departure',
						'value': $data.departureDate
					}, {
						'key': 'return',
						'value': $data.returnDate
					}, {
						'key': 'number-of-passengers',
						'value': $($('#ibe-standalone-travelpass').find('.total-nos')[0]).html()
					}, {
						'key': 'cabin-class',
						'value': $data.cabinClass
					}
				]
			});
		}

		let response: any = _self.bookingFormBackend.sidetripEligibilityCheck($data);
		if ($tripType === 'O') {
			if (response['upDomestic'].validOND === 'Y') {
				$('.container--side-trip .sidetrip-from').show();
				$('.container--side-trip .sidetrip-or').hide();
				$('.container--side-trip .sidetrip-to').hide();
				let nextoneWayDay: any = new Date($instance.find('.departureDate.oneWay-trip').val().trim());
				let ibeNowDate: any = new Date();
				let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
				let maxLimitDate: any = new Date(ibeNowDate.getFullYear(), ibeNowDate.getMonth(), ibeNowDate.getDate() + maxDays, 0, 0, 0, 0);
				let returnDay: any = new Date(response['upDomestic'].travelPeriodTo) > maxLimitDate ? maxLimitDate : new Date(response['upDomestic'].travelPeriodTo);
				let airportListItem: any;
				$('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "minDate", nextoneWayDay);
				$('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "maxDate", returnDay);
				if (response['upDomestic'].domesticLocations.length) {
					let selectOptions: Array<any> = [];
					for (var key in response['upDomestic'].domesticLocations[0]) {
						airportListItem = response['upDomestic'].domesticLocations[0][key];
						selectOptions.push({
							text: airportListItem.airportName + "|" + airportListItem.countryName + "|" + airportListItem.airportCode,
							value: airportListItem.airportCode
						});
					}
					let selectizeOneWay = $('select.sidetrip-to--location')[0].selectize;
					selectizeOneWay.clearOptions();
					selectizeOneWay.renderCache = {};
					selectizeOneWay.load(function (callback: any) {
						callback(selectOptions);
					});
				}
				return true;

			} else {
				return false;
			}
		}
		if ($tripType === 'R') {
			if (response['upDomestic'].validOND === 'Y' && response['downDomestic'].validOND === 'Y') {
				$('.container--side-trip .sidetrip-or').show();
			} else {
				$('.container--side-trip .sidetrip-or').hide();
			}
			if (response['upDomestic'].validOND === 'Y' || response['downDomestic'].validOND === 'Y') {
				if (response['upDomestic'].validOND === 'Y') {
					$('.container--side-trip .sidetrip-from').show();
					let airportListItem: any;
					if (response['upDomestic'].domesticLocations.length) {
						let selectOptions: Array<any> = [];
						for (var key in response['upDomestic'].domesticLocations[0]) {
							airportListItem = response['upDomestic'].domesticLocations[0][key];
							selectOptions.push({
								text: airportListItem.airportName + "|" + airportListItem.countryName + "|" + airportListItem.airportCode,
								value: airportListItem.airportCode
							});
						}
						let selectizeOneWay = $('select.sidetrip-to--location')[0].selectize;
						selectizeOneWay.clearOptions();
						selectizeOneWay.renderCache = {};
						selectizeOneWay.load(function (callback: any) {
							callback(selectOptions);
						});
					}
				} else {
					$('.container--side-trip .sidetrip-from').hide();
				}
				if (response['downDomestic'].validOND === 'Y') {
					$('.container--side-trip .sidetrip-to').show();
					let airportListItemReturn: any;
					if (response['downDomestic'].domesticLocations.length) {
						let selectOptionsReturn: Array<any> = [];
						for (var key in response['downDomestic'].domesticLocations[0]) {
							airportListItemReturn = response['downDomestic'].domesticLocations[0][key];
							selectOptionsReturn.push({
								text: airportListItemReturn.airportName + "|" + airportListItemReturn.countryName + "|" + airportListItemReturn.airportCode,
								value: airportListItemReturn.airportCode
							});
						}
						let selectizeReturn = $('select.sidetrip-return-to--location')[0].selectize;
						selectizeReturn.clearOptions();
						selectizeReturn.renderCache = {};
						selectizeReturn.load(function (callback: any) {
							callback(selectOptionsReturn);
						});
					}
				} else {
					$('.container--side-trip .sidetrip-to').hide();
				}
				return true;
			} else {
				return false;
			}
		}
	}
	mobileSidetripEligibilityCheck($instance: any) {
		let _self = this;
		let $fromLocation = $instance.find('.ibe-mob-from--location').val().split('_')[0];
		let $toLocation = $instance.find('.ibe-mob-to--location').val();

		let $fromSelected = $instance.find('.ibe-mob-from--location').find(":selected");
		let $fromSelected_text = $fromSelected.text();
		let $fromCountry: any;
		if ($fromSelected_text.includes('|')) {
			let countryText: any;
			if ($fromSelected_text.split('|')[0] === 'Recent') {
				countryText = $fromSelected_text.split('|')[9];
			} else {
				countryText = $fromSelected_text.split('|')[1];
			}
			if (countryText.indexOf(',') > -1) {
				$fromCountry = countryText.split(',')[1].trim();
			} else {
				$fromCountry = countryText;
			}

		} else {
			if ($fromSelected_text.match(/,/g).length > 1) {
				$fromCountry = $fromSelected_text.substring($fromSelected_text.indexOf(",") + 1, $fromSelected_text.indexOf("(")).trim();
			} else {
				$fromCountry = $fromSelected_text.substring($fromSelected_text.lastIndexOf(",") + 1, $fromSelected_text.indexOf("(")).trim();
			}
		}

		let $toSelected = $instance.find('.ibe-mob-to--location').find(":selected");
		let $toSelected_text = $toSelected.text();
		let $toCountry: any;
		if ($toSelected_text.includes('|')) {
			let countryText: any = $toSelected_text.split('|')[1];
			if (countryText.indexOf(',') > -1) {
				$toCountry = countryText.split(',')[1].trim();
			} else {
				$toCountry = countryText;
			}

		} else {
			if ($toSelected_text.match(/,/g).length > 1) {
				$toCountry = $toSelected_text.substring($toSelected_text.indexOf(",") + 1, $toSelected_text.indexOf("(")).trim();
			}
			else {
				$toCountry = $toSelected_text.substring($toSelected_text.lastIndexOf(",") + 1, $toSelected_text.indexOf("(")).trim();
			}
		}

		let $tripType = $instance.find('.trip-type--container li.selected a').attr('data-triptype');
		let $getDepartureDate: any;

		if ($tripType == 'R') {
			$getDepartureDate = $instance.find('.returnTrip .departureDateMobile').val();
		} else {
			$getDepartureDate = $instance.find('.oneWayTrip .departureDateMobile').val();
		}

		let $departureDate = moment(new Date($getDepartureDate)).format('DD/MM/YYYY');
		let $getReturnDate = $instance.find('.returnDateMobile').val();
		let $returnDate = moment(new Date($getReturnDate)).format('DD/MM/YYYY');
		let $cabinClass = $instance.find('.cabin-class-mob').val();

		var $data: any = {
			tripType: $tripType,
			from: $fromLocation,
			fromCountry: $fromCountry,
			to: $toLocation,
			toCountry: $toCountry,
			departureDate: $departureDate,
			returnDate: $returnDate,
			cabinClass: $cabinClass
		};
		if ($instance.parent().attr('id') === 'ibe-standalone-travelpass') {
			_self.adobeDataLayer.push('click', {
				'pageName': '',
				'pageType': 'Enrich Fly Pass - User With Fly Pass',
				'clickName': 'click:btn-click:fly-pass-find-flight',
				'componentType': 'btn',
				'componentName': '',
				'componentID': '',
				'attributes': [
					{
						'key': $data.tripType === 'O' ? 'fly-pass-find-flights-oneway' : 'fly-pass-find-flights-return',
						'value': $data.tripType === 'O' ? 'oneway' : 'return'
					}, {
						'key': 'origin',
						'value': $data.from
					}, {
						'key': 'destination',
						'value': $data.to
					}, {
						'key': 'departure',
						'value': $data.departureDate
					}, {
						'key': 'return',
						'value': $data.returnDate
					}, {
						'key': 'number-of-passengers',
						'value': $($('#ibe-standalone-travelpass').find('.total-nos')[0]).html()
					}, {
						'key': 'cabin-class',
						'value': $data.cabinClass
					}
				]
			});
		}

		let response: any = _self.bookingFormBackend.sidetripEligibilityCheck($data);
		if ($tripType === 'O') {
			if (response['upDomestic'].validOND === 'Y') {
				$('.container--side-trip .sidetrip-from').show();
				$('.container--side-trip .sidetrip-or').hide();
				$('.container--side-trip .sidetrip-to').hide();
				let nextoneWayDay: any = new Date($instance.find('.departureDateMobile.oneway-trip').val().trim());
				let ibeNowDate: any = new Date();
				let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
				let maxLimitDate: any = new Date(ibeNowDate.getFullYear(), ibeNowDate.getMonth(), ibeNowDate.getDate() + maxDays, 0, 0, 0, 0);
				let returnDay: any = new Date(response['upDomestic'].travelPeriodTo) > maxLimitDate ? maxLimitDate : new Date(response['upDomestic'].travelPeriodTo);
				let airportListItem: any;
				$instance.find('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "minDate", nextoneWayDay);
				$instance.find('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "maxDate", returnDay);
				if (response['upDomestic'].domesticLocations.length) {
					let selectOptions: Array<any> = [];
					for (var key in response['upDomestic'].domesticLocations[0]) {
						airportListItem = response['upDomestic'].domesticLocations[0][key];
						selectOptions.push({
							text: airportListItem.airportName + "|" + airportListItem.countryName + "|" + airportListItem.airportCode,
							value: airportListItem.airportCode
						});
					}
					let selectizeOneWay = $instance.find('select.sidetrip-to--location')[0].selectize;
					selectizeOneWay.clearOptions();
					selectizeOneWay.renderCache = {};
					selectizeOneWay.load(function (callback: any) {
						callback(selectOptions);
					});
				}
				return true;

			} else {
				return false;
			}
		}
		if ($tripType === 'R') {
			if (response['upDomestic'].validOND === 'Y' && response['downDomestic'].validOND === 'Y') {
				$('.container--side-trip .sidetrip-or').show();
			} else {
				$('.container--side-trip .sidetrip-or').hide();
			}
			if (response['upDomestic'].validOND === 'Y' || response['downDomestic'].validOND === 'Y') {
				if (response['upDomestic'].validOND === 'Y') {
					$('.container--side-trip .sidetrip-from').show();
					let airportListItem: any;
					if (response['upDomestic'].domesticLocations.length) {
						let selectOptions: Array<any> = [];
						for (var key in response['upDomestic'].domesticLocations[0]) {
							airportListItem = response['upDomestic'].domesticLocations[0][key];
							selectOptions.push({
								text: airportListItem.airportName + "|" + airportListItem.countryName + "|" + airportListItem.airportCode,
								value: airportListItem.airportCode
							});
						}
						let selectizeOneWay = $instance.find('select.sidetrip-to--location')[0].selectize;
						selectizeOneWay.clearOptions();
						selectizeOneWay.renderCache = {};
						selectizeOneWay.load(function (callback: any) {
							callback(selectOptions);
						});
					}
				} else {
					$('.container--side-trip .sidetrip-from').hide();
				}
				if (response['downDomestic'].validOND === 'Y') {
					$('.container--side-trip .sidetrip-to').show();
					let airportListItemReturn: any;
					if (response['downDomestic'].domesticLocations.length) {
						let selectOptionsReturn: Array<any> = [];
						for (var key in response['downDomestic'].domesticLocations[0]) {
							airportListItemReturn = response['downDomestic'].domesticLocations[0][key];
							selectOptionsReturn.push({
								text: airportListItemReturn.airportName + "|" + airportListItemReturn.countryName + "|" + airportListItemReturn.airportCode,
								value: airportListItemReturn.airportCode
							});
						}
						let selectizeReturn = $instance.find('select.sidetrip-return-to--location')[0].selectize;
						selectizeReturn.clearOptions();
						selectizeReturn.renderCache = {};
						selectizeReturn.load(function (callback: any) {
							callback(selectOptionsReturn);
						});
					}
				} else {
					$('.container--side-trip .sidetrip-to').hide();
				}
				return true;
			} else {
				return false;
			}
		}

	}

	mobileSidetripPanelEligibilityCheck($instance: any) {
		let _self = this;
		let $fromLocation = $instance.find('.ibe-sideTrip-from--location').val();
		let $toLocation = $instance.find('.ibe-sideTrip-to--location').val();

		let $fromSelected = $instance.find('.ibe-sideTrip-from--location').find(":selected");
		let $fromSelected_text = $fromSelected.text();
		let $fromCountry: any;
		if ($fromSelected_text.includes('|')) {
			let countryText: any;
			if ($fromSelected_text.split('|')[0] === 'Recent') {
				countryText = $fromSelected_text.split('|')[9];
			} else {
				countryText = $fromSelected_text.split('|')[1];
			}
			if (countryText.indexOf(',') > -1) {
				$fromCountry = countryText.split(',')[1].trim();
			} else {
				$fromCountry = countryText;
			}
		} else {
			if ($fromSelected_text.match(/,/g).length > 1) {
				$fromCountry = $fromSelected_text.substring($fromSelected_text.indexOf(",") + 1, $fromSelected_text.indexOf("(")).trim();
			} else {
				$fromCountry = $fromSelected_text.substring($fromSelected_text.lastIndexOf(",") + 1, $fromSelected_text.indexOf("(")).trim();
			}
		}

		let $toSelected = $instance.find('.ibe-sideTrip-to--location').find(":selected");
		let $toSelected_text = $toSelected.text();
		let $toCountry: any;
		if ($toSelected_text.includes('|')) {
			let countryText: any = $toSelected_text.split('|')[1];
			if (countryText.indexOf(',') > -1) {
				$toCountry = countryText.split(',')[1].trim();
			} else {
				$toCountry = countryText;
			}

		} else {
			if ($toSelected_text.match(/,/g).length > 1) {
				$toCountry = $toSelected_text.substring($toSelected_text.indexOf(",") + 1, $toSelected_text.indexOf("(")).trim();
			}
			else {
				$toCountry = $toSelected_text.substring($toSelected_text.lastIndexOf(",") + 1, $toSelected_text.indexOf("(")).trim();
			}
		}

		let $tripType = $instance.find('.trip-sidetrip-container .trip-type--container li.selected a').attr('data-triptype');
		let $getDepartureDate: any;

		if ($tripType == 'R') {
			$getDepartureDate = $instance.find('.returnsideTrip .departureDateSideTrip').val();
		} else {
			$getDepartureDate = $instance.find('.oneWaysideTrip .departureDateSideTrip').val();
		}

		let $departureDate = moment(new Date($getDepartureDate)).format('DD/MM/YYYY');
		let $getReturnDate = $instance.find('.returnDateSideTrip').val();
		let $returnDate = moment(new Date($getReturnDate)).format('DD/MM/YYYY');
		let $cabinClass = $instance.find('.cabin-class-sidetrip').val();

		var $data: any = {
			tripType: $tripType,
			from: $fromLocation,
			fromCountry: $fromCountry,
			to: $toLocation,
			toCountry: $toCountry,
			departureDate: $departureDate,
			returnDate: $returnDate,
			cabinClass: $cabinClass
		};

		let response: any = _self.bookingFormBackend.sidetripEligibilityCheck($data);
		if ($tripType === 'O') {
			if (response['upDomestic'].validOND === 'Y') {
				$('.container--side-trip .sidetrip-from').show();
				$('.container--side-trip .sidetrip-or').hide();
				$('.container--side-trip .sidetrip-to').hide();
				let nextoneWayDay: any = new Date($instance.find('.departureDateSideTrip.oneway-trip').val().trim());
				let ibeNowDate: any = new Date();
				let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
				let maxLimitDate: any = new Date(ibeNowDate.getFullYear(), ibeNowDate.getMonth(), ibeNowDate.getDate() + maxDays, 0, 0, 0, 0);
				let returnDay: any = new Date(response['upDomestic'].travelPeriodTo) > maxLimitDate ? maxLimitDate : new Date(response['upDomestic'].travelPeriodTo);
				let airportListItem: any;
				$instance.find('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "minDate", nextoneWayDay);
				$instance.find('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "maxDate", returnDay);
				if (response['upDomestic'].domesticLocations.length) {
					let selectOptions: Array<any> = [];
					for (var key in response['upDomestic'].domesticLocations[0]) {
						airportListItem = response['upDomestic'].domesticLocations[0][key];
						selectOptions.push({
							text: airportListItem.airportName + "|" + airportListItem.countryName + "|" + airportListItem.airportCode,
							value: airportListItem.airportCode
						});
					}
					let selectizeOneWay = $instance.find('select.sidetrip-to--location')[0].selectize;
					selectizeOneWay.clearOptions();
					selectizeOneWay.renderCache = {};
					selectizeOneWay.load(function (callback: any) {
						callback(selectOptions);
					});
				}
				return true;

			} else {
				return false;
			}
		}
		if ($tripType === 'R') {
			if (response['upDomestic'].validOND === 'Y' && response['downDomestic'].validOND === 'Y') {
				$('.container--side-trip .sidetrip-or').show();
			} else {
				$('.container--side-trip .sidetrip-or').hide();
			}
			if (response['upDomestic'].validOND === 'Y' || response['downDomestic'].validOND === 'Y') {
				if (response['upDomestic'].validOND === 'Y') {
					$('.container--side-trip .sidetrip-from').show();
					let airportListItem: any;
					if (response['upDomestic'].domesticLocations.length) {
						let selectOptions: Array<any> = [];
						for (var key in response['upDomestic'].domesticLocations[0]) {
							airportListItem = response['upDomestic'].domesticLocations[0][key];
							selectOptions.push({
								text: airportListItem.airportName + "|" + airportListItem.countryName + "|" + airportListItem.airportCode,
								value: airportListItem.airportCode
							});
						}
						let selectizeOneWay = $instance.find('select.sidetrip-to--location')[0].selectize;
						selectizeOneWay.clearOptions();
						selectizeOneWay.renderCache = {};
						selectizeOneWay.load(function (callback: any) {
							callback(selectOptions);
						});
					}
				} else {
					$('.container--side-trip .sidetrip-from').hide();
				}
				if (response['downDomestic'].validOND === 'Y') {
					$('.container--side-trip .sidetrip-to').show();
					let airportListItemReturn: any;
					if (response['downDomestic'].domesticLocations.length) {
						let selectOptionsReturn: Array<any> = [];
						for (var key in response['downDomestic'].domesticLocations[0]) {
							airportListItemReturn = response['downDomestic'].domesticLocations[0][key];
							selectOptionsReturn.push({
								text: airportListItemReturn.airportName + "|" + airportListItemReturn.countryName + "|" + airportListItemReturn.airportCode,
								value: airportListItemReturn.airportCode
							});
						}
						let selectizeReturn = $instance.find('select.sidetrip-return-to--location')[0].selectize;
						selectizeReturn.clearOptions();
						selectizeReturn.renderCache = {};
						selectizeReturn.load(function (callback: any) {
							callback(selectOptionsReturn);
						});
					}
				} else {
					$('.container--side-trip .sidetrip-to').hide();
				}
				return true;
			} else {
				return false;
			}
		}
	}
	/**
 * [mobileMultiBookingFormValidation description]
 * @param {any} callback [description]
 */
	mobileMultiBookingFormValidation($instance: any, $officeCode: any, callback: any) {
		let _self = this;

		var formDestinationValid = false;
		var formDepDatesValid = false;
		var formItineraryValid: any = []; // each destination row added by the user to have its own validation
		var formAllDestValid = true; // overall validation for all destination rows
		var formPassengersValid = false;
		// get all currently active destination fieldsets
		var destFields = $instance.find('.mobile-multi-cityTrip--Container fieldset[data-type="destination-input"][data-flight-enabled="1"]');
		var prevDate: any; // temp var for storing previous entry date
		var errorDiv = $instance.find('.mobile-validation--content'); // dom traversal to get error div
		var prevDate: any; // temp var for storing previous entry date
		var prevArray: any = [];
		// empty validation container
		if (errorDiv.find('li').length) {
			errorDiv.find('.validation--error-list').empty();
		}

		destFields.each(function (i: number) {
			var destFrom = $(this).find('select.depLocationBegin');
			var destTo = $(this).find('select.depLocationEnd');
			var depDate = $(this).find('input.dateDeparture');

			var destFromVal = destFrom.val();
			var destToVal = destTo.val();
			var depDateVal = moment(new Date(depDate.val())).unix();

			// validate destination fields
			// ===========================
			// 1. all fields filled in
			// 2. sequential dates
			// 3. no same from/to locations

			// validate empty fields
			var currInputEl = $(destFrom); // dom traversal to get error div
			if (!destFromVal) {
				formDestinationValid = false;
				errorMsg(currInputEl, errorDiv, 'emptyFlightFrom' + i, '<strong>From #' + (i + 1) + ':</strong> Select your origin');
			} else {
				clearError(currInputEl, errorDiv, 'emptyFlightFrom' + i);
			}

			var currInputEl = $(destTo); // dom traversal to get error div
			if (!destToVal) {
				formDestinationValid = false;
				errorMsg(currInputEl, errorDiv, 'emptyFlightTo' + i, '<strong>To #' + (i + 1) + ':</strong> Select your destination');
			} else {
				clearError(currInputEl, errorDiv, 'emptyFlightTo' + i);
			}

			// validate duplicate from/to destinations
			if (destFromVal && destToVal) { // validate if both fields are filled in
				var currInputEl = $(destTo); // dom traversal to get error div
				if (destFromVal === destToVal) {
					formDestinationValid = false;
					errorMsg(currInputEl, errorDiv, 'duplicateFlightDestinations' + i, '<strong>To #' + (i + 1) + ': </strong> Please select a different destination');
				} else {
					formDestinationValid = true;
					clearError(currInputEl, errorDiv, 'duplicateFlightDestinations' + i);
				}
			}

			var currInputEl = $(depDate); // dom traversal to get error div
			if (!depDateVal) {
				formDepDatesValid = false;
				errorMsg(currInputEl, errorDiv, 'emptyDepartureDate' + i, '<strong>Departure #' + (i + 1) + ':</strong> Select your departure date');
			} else {
				formDepDatesValid = true;
				clearError(currInputEl, errorDiv, 'emptyDepartureDate' + i);
			}

			if (depDateVal) {
				// validate sequential date
				if (prevDate) {
					var currInputEl = $(depDate); // dom traversal to get error div
					//if (prevDate > depDateVal) {

					if (prevArray.some(el => el > depDateVal)) {
						formDepDatesValid = false;
						errorMsg(currInputEl, errorDiv, 'prevFlightMoreCurrFlight' + i, '<strong>Destination #' + (i + 1) + ':</strong>Previous flight date cannot be later than current flight date');
					} else {
						formDepDatesValid = true;
						clearError(currInputEl, errorDiv, 'prevFlightMoreCurrFlight' + i);
					}
				} else {
					//prevDate = depDateVal;
				}
				prevDate = depDateVal;
				prevArray.push(depDateVal);
			}

			// console.log('formDestinationValid', formDestinationValid);
			// console.log('formDepDatesValid', formDepDatesValid);
			if (formDestinationValid && formDepDatesValid) {
				formItineraryValid[i] = true;
			} else {
				formItineraryValid[i] = false;
			}
		});

		// console.log(formItineraryValid);

		// check all itinerary rows for validity
		// once a row fails validation (arr[i] == false)
		// break out of loop and set validation = failed
		for (var j = 0; j < formItineraryValid.length; j++) {
			if (formItineraryValid[j] === false) {
				formAllDestValid = false;
				break;
			}
		}

		// validate passenger fields
		// =========================
		// 1. 1 adult to 1 infant (max 2 infants)
		var passAdults = $instance.find('.mobile-flight-widget input[name="passengersAdult"]');
		var passTeenagers = $instance.find('.mobile-flight-widget input[name="passengersTeenager"]');
		var passInfants = $instance.find('.mobile-flight-widget input[name="passengersInfant"]');

		var passAdultsVal = parseInt(passAdults.val());
		var passTeenagersVal = parseInt(passTeenagers.val());
		var passInfantsVal = parseInt(passInfants.val());

		var ratioAdultInfant = (passAdultsVal / passInfantsVal) >= 1;
		var ratioAdultTeenager = (passAdultsVal / passTeenagersVal) >= 1;

		var currInputEl = $instance.find('.mobile-flight-widget [data-mob-booking-passenger-details-selected]'); // dom traversal to get error div
		var $passengerDetailsContainer = $instance.find('.mobile-flight-widget [data-mob-booking-passenger-details]');

		if (!ratioAdultInfant) {
			formPassengersValid = false;
			errorMsg(currInputEl, errorDiv, 'moreInfantsThanAdults', '<strong>' + $passengerDetailsContainer.find('.title-caption').text() + ' - ' + currInputEl.find('.infant-cat .booking-category').text() + ':</strong> Only 1 infant per adult is allowed');
		} else {
			formPassengersValid = true;
			clearError(currInputEl, errorDiv, 'moreInfantsThanAdults');
		}

		let formDataValid = formPassengersValid && formAllDestValid;

		let $cabinClass = $instance.find('.cabin-class-mob').val();
		let $paymentMethod = $instance.find('input[name="cash_miles_type"]:checked').val();
		let $infantTicketValue = $instance.find('.mobile-flight-widget .ticket-mob-infant--input').val();
		let $teenagerTicketValue = $instance.find('.mobile-flight-widget .ticket-mob-teenager--input').val();
		let $infantAlertContainer: any = $('#infant-alert--container');
		let $warningAccepted: any = $infantAlertContainer.find('input[name="infant_warning"]');

		// Validation: infant booking
		// multi booking form
		// open popup if these conditions are met:
		// - cabinclass = 'CFFFIRST'
		// - warning != 'accepted'
		// - infantTicketvalue > 0
		// - form submission is valid till this point
		if (formDataValid === true && $cabinClass == "CFFFIRST" && $warningAccepted.val() !== 'accepted' && $infantTicketValue > 0) {
			if ($paymentMethod === 'cash') {
				$instance.find('.error-validation').hide();
				$.magnificPopup.open({
					items: {
						src: '#infant-alert--container'
					},
					type: 'inline',
					midClick: true,
					callbacks: {
						open: function () {
							let instance = this;
							let $el: any = instance.content;
							// console.log('infant booking multi booking form', $instance, instance);
							_self.bookflightinfant.submitBtns($instance);

							// no need to check payment type since multicity only can pay in cash
							$el.find('input[name="tripflow"]').val('multi_mob');
							$el.find('input[name="payment_method"]').val('cash');

						}
					}
				}, 0);
				return false;
			}
		}

		// redemption login fields validation
		let loginContainer = $instance.find('.container--redemption-login');
		let redemptionLoginValidation = true;
		if ($paymentMethod !== 'cash') {
			redemptionLoginValidation = _self.loginFieldsValidation($instance);

			if (loginContainer.hasClass('hidden')) {
				redemptionLoginValidation = true;
			}
		}

		// console.log('multi', redemptionLoginValidation);

		if (formAllDestValid && formPassengersValid && redemptionLoginValidation) {
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback($officeCode);
			}
		} else {
			//console.log('%cValidation failed', 'color: red; font-weight: bold');
			displayErrors(errorDiv);
			// do error stuff here
			return false;
		}


		/**
		 * Error msg display for from/to select fields
		 * @param  {jquery object} el   [error div element]
		 * @param  {[type]} msg  [error message]
		 */
		function errorMsg(el: any, error_div: any, errId: string, msg: string) {
			// display error message
			// console.log('%c'+msg, 'color: red');
			// find list element. if unable to find create one
			console.log(el, errId);
			var errorList = error_div.find('ul.validation--error-list');
			if (!errorList.length) {
				error_div.append('<ul class="validation--error-list"></ul>');
				var errorList = error_div.find('ul.validation--error-list');
			}

			if (!errorList.find('li[data-error="' + errId + '"]').length) {
				errorList.append('<li data-error="' + errId + '">' + msg + '</li>');
			}

			// apply error classes
			switch (el.prop('nodeName')) {
				case 'SELECT': {
					el.prev().addClass('has-error');
					el.next().children('.selectize-input').addClass('has-error');
					if (el.hasClass('multicity-from--location') || el.hasClass('multicity-to--location')) {
						el.parents().eq(4).addClass('has-error');
						el.parents().eq(4).children().eq(0).addClass('has-error');
					}
					break;
				}
				case 'INPUT': {
					if (el.hasClass('hasDatepicker')) {
						el.parents().eq(1).addClass('has-error');
					}
					break;
				}
				case 'DIV': {
					if (el.hasClass('passenger-details-selected')) {
						el.parent().find('.passenger-details').addClass('has-error');
					}
					el.addClass('has-error');
					break;
				}
				default:
					break;
			}

			return;
		}

		/**
		 * Clear error message once error no longer present
		 * @param  {[type]} el [description]
		 * @return {[type]}    [description]
		 */
		function clearError(el: any, error_div: any, errId: string) {
			var errorItem = error_div.find('li[data-error="' + errId + '"]');
			var haveErrors = error_div.find('li').length;

			if (errorItem.length) {
				errorItem.remove();
			}

			// remove error classes
			switch (el.prop('nodeName')) {
				case 'SELECT': {
					el.prev().removeClass('has-error');
					el.next().children('.selectize-input').removeClass('has-error');
					if (el.hasClass('multicity-from--location') || el.hasClass('multicity-to--location')) {
						el.parents().eq(4).removeClass('has-error');
						el.parents().eq(4).children().eq(0).removeClass('has-error');
					}
					break;
				}
				case 'INPUT': {
					if (el.hasClass('hasDatepicker')) {
						el.parents().eq(1).removeClass('has-error');
					}
					break;
				}
				case 'DIV': {
					if (el.hasClass('passenger-details-selected')) {
						el.parent().find('.passenger-details').removeClass('has-error');
					}
					el.removeClass('has-error');
					break;
				}
				default:
					break;
			}

			displayErrors(error_div);
			// el.fadeOut(250);
			// el.empty();
			// el.parent().removeClass('error_state');

			return;
		}

		function displayErrors(error_div: any) {
			var haveErrors = error_div.find('li').length;

			// hide error div if no errors present
			let $errorValidation: any = $instance.find('.error-validation');
			if (!haveErrors) {
				$errorValidation.hide();
			} else {
				$errorValidation.show();
			}
		}
	}

	/**
	 * [multiBookingGetOfficeCode description]
	 * @return {[type]} [description]
	 */
	mobileMultiBookingFormSubmit($instance: any, data: any, $officeCode: any): any {
		let _self = this;
		// Get the user-defined values
		// from location
		let $fromLocationMulticityOne = data['B_LOCATION_1'];
		let $fromLocationMulticityTwo = data['B_LOCATION_2'];
		let $fromLocationMulticityThree = data['B_LOCATION_3'];
		let $fromLocationMulticityFour = data['B_LOCATION_4'];
		let $fromLocationMulticityFive = data['B_LOCATION_5'];
		let $fromLocationMulticitySix = data['B_LOCATION_6'];
		// to location
		let $toLocationMulticityOne = data['E_LOCATION_1'];
		let $toLocationMulticityTwo = data['E_LOCATION_2'];
		let $toLocationMulticityThree = data['E_LOCATION_3'];
		let $toLocationMulticityFour = data['E_LOCATION_4'];
		let $toLocationMulticityFive = data['E_LOCATION_5'];
		let $toLocationMulticitySix = data['E_LOCATION_6'];
		// departure date
		let $getMulticityDeptDateOne = data['B_DATE_1'];
		let $getMulticityDeptDateTwo = data['B_DATE_2'];
		let $getMulticityDeptDateThree = data['B_DATE_3'];
		let $getMulticityDeptDateFour = data['B_DATE_4'];
		let $getMulticityDeptDateFive = data['B_DATE_5'];
		let $getMulticityDeptDateSix = data['B_DATE_6'];
		// departure date (parsed)
		let $multicityDeptDateOne = moment(new Date($getMulticityDeptDateOne)).format('YYYYMMDDhhmm');
		let $multicityDeptDateTwo = moment(new Date($getMulticityDeptDateTwo)).format('YYYYMMDDhhmm');
		let $multicityDeptDateThree = moment(new Date($getMulticityDeptDateThree)).format('YYYYMMDDhhmm');
		let $multicityDeptDateFour = moment(new Date($getMulticityDeptDateFour)).format('YYYYMMDDhhmm');
		let $multicityDeptDateFive = moment(new Date($getMulticityDeptDateFive)).format('YYYYMMDDhhmm');
		let $multicityDeptDateSix = moment(new Date($getMulticityDeptDateSix)).format('YYYYMMDDhhmm');
		// site details
		// let $linkURL                    = 'https://wav.bibi.amadeus.com/plnext/MASAirways/Override.action?EMBEDDED_TRANSACTION=AirComplexAvailability&ENCT=1&LANGUAGE=GB&SITE=';
		// let $siteURL                    = this.$siteCode;
		// let $enc                        = '&ENC=&';
		// let $webServiceURL              = $linkURL + $siteURL + $enc;
		// trip details
		let $tripType = 'M';
		let $cabinClass = $instance.find('.cabin-class-mob').val();
		let $couponCode = $instance.find('.couponcode-input-mob').val();
		//$encTime = new Date($.now() + 364 * 24*3600*1000),
		// passenger details
		let $adultSel: number;
		//$youthSel:number,
		let $childSel: number;
		let $teenagerSel: number;
		let $infantSel: number;
		let $adultSelectedEle = parseInt($instance.find('input[name="passengersAdult"]').val());
		let $teenagerSelectedEle = parseInt($instance.find('input[name="passengersTeenager"]').val());
		//$youthSelectedEle  = 0,
		let $childSelectedEle = parseInt($instance.find('input[name="passengersChildren"]').val());
		let $infantSelectedEle = parseInt($instance.find('input[name="passengersInfant"]').val());

		if ($cabinClass == "CFFECO") {
			$cabinClass = "E";
		} else if ($cabinClass == "CFFBUS") {
			$cabinClass = "B";
		} else if ($cabinClass == "CFFFIRST") {
			$cabinClass = "F";
		}

		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			if ($cabinClass == "CFFBUS") {
				$cabinClass = "CFFSTUBUS"
			}
			if ($cabinClass == "CFFECO") {
				$cabinClass = "CFFSTUECO"
			}
		}
		let $targetVal = _self.getAdobeTargetValue();
		let $externalId;
		if ($targetVal) {
			$externalId = $targetVal;
		} else {
			$externalId = '';
		}
		var $data = {
			B_ANY_TIME_1: 'TRUE',
			B_ANY_TIME_2: 'TRUE',
			B_ANY_TIME_3: 'TRUE',
			B_ANY_TIME_4: 'TRUE',
			B_ANY_TIME_5: 'TRUE',
			B_ANY_TIME_6: 'TRUE',
			B_DATE_1: ($multicityDeptDateOne == 'Invalid date' ? '' : $multicityDeptDateOne),
			B_DATE_2: ($multicityDeptDateTwo == 'Invalid date' ? '' : $multicityDeptDateTwo),
			B_DATE_3: ($multicityDeptDateThree == 'Invalid date' ? '' : $multicityDeptDateThree),
			B_DATE_4: ($multicityDeptDateFour == 'Invalid date' ? '' : $multicityDeptDateFour),
			B_DATE_5: ($multicityDeptDateFive == 'Invalid date' ? '' : $multicityDeptDateFive),
			B_DATE_6: ($multicityDeptDateSix == 'Invalid date' ? '' : $multicityDeptDateSix),
			B_LOCATION_1: ($fromLocationMulticityOne == '0' ? '' : $fromLocationMulticityOne),
			B_LOCATION_2: ($fromLocationMulticityTwo == '0' ? '' : $fromLocationMulticityTwo),
			B_LOCATION_3: ($fromLocationMulticityThree == '0' ? '' : $fromLocationMulticityThree),
			B_LOCATION_4: ($fromLocationMulticityFour == '0' ? '' : $fromLocationMulticityFour),
			B_LOCATION_5: ($fromLocationMulticityFive == '0' ? '' : $fromLocationMulticityFive),
			B_LOCATION_6: ($fromLocationMulticitySix == '0' ? '' : $fromLocationMulticitySix),
			E_LOCATION_1: ($toLocationMulticityOne == '0' ? '' : $toLocationMulticityOne),
			E_LOCATION_2: ($toLocationMulticityTwo == '0' ? '' : $toLocationMulticityTwo),
			E_LOCATION_3: ($toLocationMulticityThree == '0' ? '' : $toLocationMulticityThree),
			E_LOCATION_4: ($toLocationMulticityFour == '0' ? '' : $toLocationMulticityFour),
			E_LOCATION_5: ($toLocationMulticityFive == '0' ? '' : $toLocationMulticityFive),
			E_LOCATION_6: ($toLocationMulticitySix == '0' ? '' : $toLocationMulticitySix),
			CABIN: $cabinClass,
			EMBEDDED_TRANSACTION: 'AirComplexAvailability',
			// ENC_TIME             : '20171220165420',
			EXTERNAL_ID: $externalId,
			HAS_INFANT_1: 'FALSE',
			HAS_INFANT_2: 'FALSE',
			HAS_INFANT_3: 'FALSE',
			HAS_INFANT_4: 'FALSE',
			HAS_INFANT_5: 'FALSE',
			HAS_INFANT_6: 'FALSE',
			HAS_INFANT_7: 'FALSE',
			HAS_INFANT_8: 'FALSE',
			HAS_INFANT_9: 'FALSE',
			// LANGUAGE         : 'GB',
			SEVEN_DAY_SEARCH: 'TRUE',
			SITE: 'desktop',
			// SO_SITE_APIV2_SERVER         : '194.156.170.78',
			// SO_SITE_APIV2_SERVER_PWD     : 'TAZ',
			// SO_SITE_APIV2_SERVER_USER_ID : 'GUEST',
			// SO_SITE_CORPORATE_ID         : 'OCGPDT',
			// SO_SITE_FP_TRACES_ON         : 'FALSE',
			// SO_SITE_FQ_INTERFACE_ACTIVE  : 'FALSE',
			// SO_SITE_HOST_TRACE_ACTIVE    : 'TRUE',
			// SO_SITE_OFFICE_ID            : this.$officeCode,
			// SO_SITE_QUEUE_CATEGORY       : '0C0',
			// SO_SITE_QUEUE_OFFICE_ID      : 'KULMH08AA',
			// SO_SITE_SI_1AXML_FROM        : 'SEP_JCP',
			// SO_SITE_SI_PASSWORD          : 'UNSET',
			// SO_SITE_SI_SAP               : '1ASIXJCP',
			// SO_SITE_SI_SERVER_IP         : '193.23.185.67',
			// SO_SITE_SI_SERVER_PORT       : '18033',
			// SO_SITE_SI_USER              : 'UNSET',
			SO_SITE_OFFICE_ID: $officeCode,
			SO_SITE_QUEUE_OFFICE_ID: $officeCode,
			TRAVELLER_TYPE_1: '',
			TRAVELLER_TYPE_2: '',
			TRAVELLER_TYPE_3: '',
			TRAVELLER_TYPE_4: '',
			TRAVELLER_TYPE_5: '',
			TRAVELLER_TYPE_6: '',
			TRAVELLER_TYPE_7: '',
			TRAVELLER_TYPE_8: '',
			TRAVELLER_TYPE_9: '',
			TRIP_FLOW: 'YES',
			TRIP_TYPE: $tripType,
			RDM_MEM_ID: data.redemption_member_id,
			RDM_MEM_LN: data.redemption_member_lastname,
			RDM_MEM_PIN: data.redemption_member_pin,
			RDM_PAYMENT: $instance.find('input[name="cash_miles_type"]:checked').val()
		};
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			$data['SO_SITE_ALPI_AUTOPREFIL'] = 'TRUE';
			$data['SO_SITE_ALPI_DISA_FIELD'] = 'TRUE';
		}
		var $totalTraveller = $adultSelectedEle + $teenagerSelectedEle + $childSelectedEle;
		var $index = 1;

		// fill in values for each amadeus params based on number of travellers (adults)
		for ($adultSel = 1; $adultSel <= $adultSelectedEle; $adultSel++) {
			var $value = 'ADT';
			if (studentEnrichIdCookieVal != null && studentDashboard != null) {
				$value = 'STU';
			}
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		// fill in values for each amadeus params based on number of travellers (teenagers)
		for ($teenagerSel = 1; $teenagerSel <= $teenagerSelectedEle; $teenagerSel++) {
			var $value = $('#teenagerValue').val();
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		let $teenageSelectedEle = parseInt($instance.find('input[name="passengersTeenager"]').val());
		if ($('.passenger-details-selected .teenager-cat').css('display') === "block") {
			$data['TEENAGER_COUNT'] = $teenageSelectedEle;
		}
		// currently not in use
		// fill in values for each amadeus params based on number of travellers (youths)
		// for ($youthSel = 1; $youthSel <= $youthSelectedEle; $youthSel++) {
		//     var $value = 'B15';
		//     $data['TRAVELLER_TYPE_' + $index] = $value;
		//     $index++;
		// };

		// fill in values for each amadeus params based on number of travellers (children)
		for ($childSel = 1; $childSel <= $childSelectedEle; $childSel++) {
			var $value = 'CHD';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}

		// fill in values for each amadeus params based on number of travellers (infants)
		for ($infantSel = 1; $infantSel <= $infantSelectedEle; $infantSel++) {
			var $infant_value = 'TRUE';
			$data['HAS_INFANT_' + $infantSel] = $infant_value;
		}

		if ($couponCode != '') {
			$data['LIST_CORPORATE_NUMBER_1_1'] = $couponCode;
			$data['TYPE_OF_CORPORATE_FARE_1'] = '2';
			$data['IS_PRICE_BY_INPUT_1'] = 'TRUE';
		}

		/* Amadeus adobe partnership variable settings */
		if (typeof Visitor !== 'undefined') {
			let $amcvId;
			$amcvId = Visitor.getInstance("4D9676A8531512ED0A490D44").getMarketingCloudVisitorID();
			$data['AMCVID_ECID'] = $amcvId;
		}
		else {
			$data['AMCVID_ECID'] = '';
		}

		var $multiTripFlowUrl = $.param($data);

		// display url params (debug)
		// window.prompt($multiTripFlowUrl);
		// alert($multiTripFlowUrl);
		// console.log($multiTripFlowUrl);
		// console.log($data);

		let $tabularData: any = {};
		for (var dkey in $data) {
			$tabularData[dkey] = { 'value': $data[dkey] };
		}
		let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
		if (loginTokenCookieVal != null) {
			// find login status here
			_self.bookingFormBackend.retrieveMemberInfoForCash($instance, $.param($data), "multi");
		} else {
			let $tripflow_encryptURL = encodeURIComponent($multiTripFlowUrl);
			_self.bookingFormBackend.desktopMultiFormSubmitToServlet($instance, $tripflow_encryptURL);

		}
	}
	enrichHotelEarnFormValidation($instance: any, callback: any): any {
		let _self = this;
		let $errorList: Array<string> = [];

		let $errorValidation = $instance.find('.enrich-validation').first();
		let formDataValid = true;
		let $hotelInputVal: any = $instance.find('#enrichHotelEarnInputVal');
		let $hotelInputClass: any = $instance.find('.enrichHotelEarnInputClass');

		if ($hotelInputVal.val() == '') {
			//	$fromSelectize.addClass('has-error');
			$hotelInputClass.addClass('has-error');
			let $hotelValidate: any = $hotelInputVal.attr('data-hotelMsg');
			$errorList.push('<strong>' + $hotelInputVal.parent().find('label').text() + ':</strong> ' + $hotelValidate);
			formDataValid = false;
		} else {
			$hotelInputClass.removeClass('has-error');
			//	$fromBookingTitle.removeClass('has-error');
		}

		let $passengerDetailsActive: any = $('#enrich-earn-points--container [data-booking-passenger-details-selected]');
		// Validation: IBE One Way Trip Date empty field
		let $checkinDate: any = $instance.find('#enrich-earn-points--container .departureDate');
		let $checkoutDate: any = $instance.find('#enrich-earn-points--container .returnDate');


		// /** IBE Return Trip Departure Date empty field validation */
		if ($checkinDate.val() == '') {
			$checkinDate.parent().parent().parent().addClass('has-error');
			let $travelDate: any = $checkinDate.attr('data-travelDepdate');
			$errorList.push('<strong>' + $checkinDate.parent().find('label.dep-title').text() + ':</strong> ' + $travelDate);
			formDataValid = false;
		} else {
			$checkinDate.parent().removeClass('has-error');
		}
		/** IBE Return Trip Return Date empty field validation */
		if ($checkoutDate.val() == '') {
			$checkoutDate.parent().parent().parent().addClass('has-error');
			let $travelEndDate: any = $instance.find('#enrich-earn-points--container .returnDate').attr('data-travelRetdate');
			$errorList.push('<strong>' + $checkoutDate.parent().find('label.ret-title').text() + ':</strong> ' + $travelEndDate);
			formDataValid = false;
		} else {
			$checkoutDate.parent().removeClass('has-error');
		}

		let $totalTicketsEl: any = $instance.find('#enrich-earn-points--container input.total-tickets--value'),
			$passengerDetailsContainer: any = $instance.find('#enrich-earn-points--container [data-booking-passenger-details]');

		// Validation: total ticket value input
		if ($totalTicketsEl.val() == 0) {
			let $nopassenger: any = $totalTicketsEl.attr('data-passenger');
			$passengerDetailsContainer.addClass('has-errors');
			$errorList.push('<strong>' + $totalTicketsEl.parent().find('label').text() + ':</strong> ' + $nopassenger);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-errors');
		}

		// Validation: Passenger type input
		let $adultBookingError: any = $instance.find('.adult-booking--error'),
			$infantBookingError: any = $instance.find('.infant-booking--error'),
			$childBookingError: any = $instance.find('.child-age-error');

		if ($adultBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $lessAdult: any = $adultBookingError.attr('data-lessadult');
			$errorList.push('<strong>' + $passengerDetailsContainer.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.adult-cat .booking-category').text() + ':</strong> ' + $lessAdult);
			formDataValid = false;
		} else if ($infantBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $moreInfant: any = $infantBookingError.attr('data-moreinfant');
			$errorList.push('<strong>' + $passengerDetailsContainer.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.infant-cat .booking-category').text() + ':</strong> ' + $moreInfant);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-error');
		}

		let $infantTicketValue = $instance.find('#enrich-earn-points--container .ticket-infant--input').val();
		let $infantAlertContainer: any = $('#infant-alert--container');
		let $warningAccepted: any = $infantAlertContainer.find('input[name="infant_warning"]');
		// let $childSelectedEle    = parseInt($instance.find('.hotel-container .passengersChildren').val());
		// if($childSelectedEle){
		// 	let $childAgeMsg =0;
		// 	for(var i= 1; i<= $childSelectedEle ; i++){
		// 		let $childAgeVal = $('.hotel-container #childAgeInput'+i).val();
		// 		if($childAgeVal<=0 && $childAgeMsg ==0){
		// 			$passengerDetailsContainer.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge');
		// 			$errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}else if(($childAgeVal<1 || $childAgeVal >17) && $childAgeMsg ==0) {
		// 			$passengerDetailsContainer.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge-limit');
		// 			$errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}
		// 		else{
		// 			$passengerDetailsContainer.removeClass('has-error');
		// 		}
		// 	}
		// }

		/* Adult infant limit check */
		let $adultCount = parseInt($instance.find('#enrich-earn-points--container .passengersAdult').val());
		let $childrenCount = parseInt($instance.find('#enrich-earn-points--container .passengersChildren').val());
		var adultChildComb = 0;
		var $childSel;
		for ($childSel = 1; $childSel <= $childrenCount; $childSel++) {
			var childAgeTemp = parseInt($('#enrich-earn-points--container #childAgeInput' + $childSel).val());
			if (childAgeTemp < 2) {
				adultChildComb++;
			}
		}
		if ($childrenCount > 0) {
			if (adultChildComb > $adultCount) {
				$instance.find('#enrich-earn-points--container .passenger-details').addClass('has-error');
				let $lessAdultInfant: any = $adultBookingError.attr('data-adult-infant-limit');
				$errorList.push('<strong>' + $('#enrich-earn-points--container [data-booking-passenger-details]').find('.title-caption').text() + ':</strong> ' + $lessAdultInfant);
				formDataValid = false;
			} else {
				$instance.find('#enrich-earn-points--container .passenger-details').removeClass('has-error');
			}
		}

		if (formDataValid) {
			$errorValidation.hide();
		}


		let $validationContainer: any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist: any = $validationContainer;

		for (var i = 0, len = $errorList.length; i < len; i++) {
			$validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback();
			}
		} else {
			return false;
		}
	}
	enrichHotelEarnDeeplink($instance: any): any {
		let $hotelInputtoVal: any = $instance.find('#enrichHotelEarnInputtoVal').val();
		let $hotelInputVal: any = $instance.find('#enrichHotelEarnInputVal').val();
		let $getDepartureDate = $instance.find('#enrich-earn-points--container .departureDate').val();

		let $departureDate = moment(new Date($getDepartureDate)).format('MM/DD/YYYY');
		let $getReturnDate = $instance.find('#enrich-earn-points--container .returnDate').val();
		let $returnDate = moment(new Date($getReturnDate)).format('MM/DD/YYYY');
		let $childSel: any, $infantSel: any;
		let currencyCode = $("#currencyCode").val();
		let enrichHotelEarnLink = "https://www.enrichhotels.com/search";
		let $CultureCode = 'en-US';
		let $adultCount = parseInt($instance.find('#enrich-earn-points--container .passengersAdult').val());
		let $childCount = parseInt($instance.find('#enrich-earn-points--container .passengersChildren').val());
		let $roomCount = parseInt($instance.find('#enrich-earn-points--container .passengersRoom').val());

		let $data = {
			query: $hotelInputVal,
			placeId: $hotelInputtoVal,
			checkIn: $departureDate,
			checkOut: $returnDate,
			currency: 'MYR',
			'rooms': $roomCount,
			'program': "enrich",
			'mode': "earn",
			'adults': $adultCount,
			'children': $childCount,
			'language': 'en'

		}

		let $tripFlowUrl = $.param($data);
		let $tripflow_encryptURL = enrichHotelEarnLink + '?' + $tripFlowUrl;
		console.log("##Redirect URL: " + $tripflow_encryptURL);
		//    window.location.href = $tripflow_encryptURL;
		window.open($tripflow_encryptURL, '_blank');
	}

	enrichHotelRedeemFormValidation($instance: any, callback: any): any {
		let _self = this;
		let $errorList: Array<string> = [];

		let $errorValidation = $instance.find('.enrich-validation').first();
		let formDataValid = true;
		let $hotelInputVal: any = $instance.find('#enrichHotelRedeemInputVal');
		let $hotelInputClass: any = $instance.find('.enrichHotelRedeemInputClass');

		if ($hotelInputVal.val() == '') {
			//	$fromSelectize.addClass('has-error');
			$hotelInputClass.addClass('has-error');
			let $hotelValidate: any = $hotelInputVal.attr('data-hotelMsg');
			$errorList.push('<strong>' + $hotelInputVal.parent().find('label').text() + ':</strong> ' + $hotelValidate);
			formDataValid = false;
		} else {
			$hotelInputClass.removeClass('has-error');
			//	$fromBookingTitle.removeClass('has-error');
		}

		let $passengerDetailsActive: any = $('#enrich-redeem-points--container [data-booking-passenger-details-selected]');
		// Validation: IBE One Way Trip Date empty field
		let $checkinDate: any = $instance.find('#enrich-redeem-points--container .departureDate');
		let $checkoutDate: any = $instance.find('#enrich-redeem-points--container .returnDate');


		// /** IBE Return Trip Departure Date empty field validation */
		if ($checkinDate.val() == '') {
			$checkinDate.parent().parent().parent().addClass('has-error');
			let $travelDate: any = $checkinDate.attr('data-travelDepdate');
			$errorList.push('<strong>' + $checkinDate.parent().find('label.dep-title').text() + ':</strong> ' + $travelDate);
			formDataValid = false;
		} else {
			$checkinDate.parent().removeClass('has-error');
		}
		/** IBE Return Trip Return Date empty field validation */
		if ($checkoutDate.val() == '') {
			$checkoutDate.parent().parent().parent().addClass('has-error');
			let $travelEndDate: any = $instance.find('#enrich-redeem-points--container .returnDate').attr('data-travelRetdate');
			$errorList.push('<strong>' + $checkoutDate.parent().find('label.ret-title').text() + ':</strong> ' + $travelEndDate);
			formDataValid = false;
		} else {
			$checkoutDate.parent().removeClass('has-error');
		}

		let $totalTicketsEl: any = $instance.find('#enrich-redeem-points--container input.total-tickets--value'),
			$passengerDetailsContainer: any = $instance.find('#enrich-redeem-points--container [data-booking-passenger-details]');

		// Validation: total ticket value input
		if ($totalTicketsEl.val() == 0) {
			let $nopassenger: any = $totalTicketsEl.attr('data-passenger');
			$passengerDetailsContainer.addClass('has-errors');
			$errorList.push('<strong>' + $totalTicketsEl.parent().find('label').text() + ':</strong> ' + $nopassenger);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-errors');
		}

		// Validation: Passenger type input
		let $adultBookingError: any = $instance.find('.adult-booking--error'),
			$infantBookingError: any = $instance.find('.infant-booking--error'),
			$childBookingError: any = $instance.find('.child-age-error');

		if ($adultBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $lessAdult: any = $adultBookingError.attr('data-lessadult');
			$errorList.push('<strong>' + $passengerDetailsContainer.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.adult-cat .booking-category').text() + ':</strong> ' + $lessAdult);
			formDataValid = false;
		} else if ($infantBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $moreInfant: any = $infantBookingError.attr('data-moreinfant');
			$errorList.push('<strong>' + $passengerDetailsContainer.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.infant-cat .booking-category').text() + ':</strong> ' + $moreInfant);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-error');
		}

		let $infantTicketValue = $instance.find('#enrich-redeem-points--container .ticket-infant--input').val();
		let $infantAlertContainer: any = $('#infant-alert--container');
		let $warningAccepted: any = $infantAlertContainer.find('input[name="infant_warning"]');
		// let $childSelectedEle    = parseInt($instance.find('.hotel-container .passengersChildren').val());
		// if($childSelectedEle){
		// 	let $childAgeMsg =0;
		// 	for(var i= 1; i<= $childSelectedEle ; i++){
		// 		let $childAgeVal = $('.hotel-container #childAgeInput'+i).val();
		// 		if($childAgeVal<=0 && $childAgeMsg ==0){
		// 			$passengerDetailsContainer.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge');
		// 			$errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}else if(($childAgeVal<1 || $childAgeVal >17) && $childAgeMsg ==0) {
		// 			$passengerDetailsContainer.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge-limit');
		// 			$errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}
		// 		else{
		// 			$passengerDetailsContainer.removeClass('has-error');
		// 		}
		// 	}
		// }

		/* Adult infant limit check */
		let $adultCount = parseInt($instance.find('#enrich-redeem-points--container .passengersAdult').val());
		let $childrenCount = parseInt($instance.find('#enrich-redeem-points--container .passengersChildren').val());
		var adultChildComb = 0;
		var $childSel;
		for ($childSel = 1; $childSel <= $childrenCount; $childSel++) {
			var childAgeTemp = parseInt($('#enrich-redeem-points--container #childAgeInput' + $childSel).val());
			if (childAgeTemp < 2) {
				adultChildComb++;
			}
		}
		if ($childrenCount > 0) {
			if (adultChildComb > $adultCount) {
				$instance.find('#enrich-redeem-points--container .passenger-details').addClass('has-error');
				let $lessAdultInfant: any = $adultBookingError.attr('data-adult-infant-limit');
				$errorList.push('<strong>' + $('#enrich-redeem-points--container [data-booking-passenger-details]').find('.title-caption').text() + ':</strong> ' + $lessAdultInfant);
				formDataValid = false;
			} else {
				$instance.find('#enrich-redeem-points--container .passenger-details').removeClass('has-error');
			}
		}

		if (formDataValid) {
			$errorValidation.hide();
		}


		let $validationContainer: any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist: any = $validationContainer;

		for (var i = 0, len = $errorList.length; i < len; i++) {
			$validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback();
			}
		} else {
			return false;
		}
	}
	enrichHotelRedeemDeeplink($instance: any): any {
		let $hotelInputtoVal: any = $instance.find('#enrichHotelRedeemInputtoVal').val();
		let $hotelInputVal: any = $instance.find('#enrichHotelRedeemInputVal').val();
		let $getDepartureDate = $instance.find('#enrich-redeem-points--container .departureDate').val();

		let $departureDate = moment(new Date($getDepartureDate)).format('MM/DD/YYYY');
		let $getReturnDate = $instance.find('#enrich-redeem-points--container .returnDate').val();
		let $returnDate = moment(new Date($getReturnDate)).format('MM/DD/YYYY');
		let $childSel: any, $infantSel: any;
		let currencyCode = $("#currencyCode").val();
		let enrichHotelEarnLink = "https://www.enrichhotels.com/search";
		let $CultureCode = 'en-US';
		let $adultCount = parseInt($instance.find('#enrich-redeem-points--container .passengersAdult').val());
		let $childCount = parseInt($instance.find('#enrich-redeem-points--container .passengersChildren').val());
		let $roomCount = parseInt($instance.find('#enrich-redeem-points--container .passengersRoom').val());
		// var InfantCount = 0;
		// var childCount = 0;
		// let totalRoomCount:any = 1;
		let $currencyCode = $("#currencyCode").val();

		let $data = {
			query: $hotelInputVal,
			placeId: $hotelInputtoVal,
			checkIn: $departureDate,
			checkOut: $returnDate,
			currency: 'MYR',
			'rooms': $roomCount,
			'program': "enrich",
			'mode': "burn",
			'adults': $adultCount,
			'children': $childCount,
			'language': 'en'

		}

		let $tripFlowUrl = $.param($data);
		let $tripflow_encryptURL = enrichHotelEarnLink + '?' + $tripFlowUrl;
		console.log("##Redirect URL: " + $tripflow_encryptURL);
		//    window.location.href = $tripflow_encryptURL;
		window.open($tripflow_encryptURL, '_blank');
	}
	mobEnrichHotelEarnFormValidation($instance: any, callback: any): any {
		let _self = this;
		let $errorList: Array<string> = [];

		let $errorValidation = $instance.find('.enrich-validation').first();
		let formDataValid = true;
		let $hotelInputVal: any = $instance.find('#mobEnrichHotelEarnInputVal');
		let $hotelInputClass: any = $instance.find('.mobEnrichHotelEarnInputClass');

		if ($hotelInputVal.val() == '') {
			//	$fromSelectize.addClass('has-error');
			$hotelInputClass.addClass('has-error');
			let $hotelValidate: any = $hotelInputVal.attr('data-hotelMsg');
			$errorList.push('<strong>' + $hotelInputVal.parent().find('label').text() + ':</strong> ' + $hotelValidate);
			formDataValid = false;
		} else {
			$hotelInputClass.removeClass('has-error');
			//	$fromBookingTitle.removeClass('has-error');
		}

		let $passengerDetailsActive: any = $('#mob-enrich-earn-points--container [mob-data-booking-passenger-details-selected]');
		// Validation: IBE One Way Trip Date empty field
		let $checkinDate: any = $instance.find('#mob-enrich-earn-points--container .departureDateMobile');
		let $checkoutDate: any = $instance.find('#mob-enrich-earn-points--container .returnDateMobile');


		// /** IBE Return Trip Departure Date empty field validation */
		if ($checkinDate.val() == '') {
			$checkinDate.parent().parent().parent().addClass('has-error');
			let $travelDate: any = $checkinDate.attr('data-travelDepdate');
			$errorList.push('<strong>' + $checkinDate.parent().find('label.dep-title').text() + ':</strong> ' + $travelDate);
			formDataValid = false;
		} else {
			$checkinDate.parent().removeClass('has-error');
		}
		/** IBE Return Trip Return Date empty field validation */
		if ($checkoutDate.val() == '') {
			$checkoutDate.parent().parent().parent().addClass('has-error');
			let $travelEndDate: any = $instance.find('.returnDateMobile').attr('data-travelRetdate');
			$errorList.push('<strong>' + $checkoutDate.parent().find('label.ret-title').text() + ':</strong> ' + $travelEndDate);
			formDataValid = false;
		} else {
			$checkoutDate.parent().removeClass('has-error');
		}

		let $totalTicketsEl: any = $instance.find('#mob-enrich-earn-points--container input.total-tickets--value'),
			$passengerDetailsContainer: any = $instance.find('#mob-enrich-earn-points--container [mob-data-booking-passenger-details]');

		// Validation: total ticket value input
		if ($totalTicketsEl.val() == 0) {
			let $nopassenger: any = $totalTicketsEl.attr('data-passenger');
			$passengerDetailsContainer.addClass('has-errors');
			// $errorList.push('<strong>'+$totalTicketsEl.parent().find('label').text()+':</strong> '+$nopassenger);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-errors');
		}

		// Validation: Passenger type input
		let $adultBookingError: any = $instance.find('.adult-booking--error'),
			$infantBookingError: any = $instance.find('.infant-booking--error'),
			$childBookingError: any = $instance.find('.child-age-error');

		if ($adultBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $lessAdult: any = $adultBookingError.attr('data-lessadult');
			// $errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.adult-cat .booking-category').text()+':</strong> '+$lessAdult);
			formDataValid = false;
		} else if ($infantBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $moreInfant: any = $infantBookingError.attr('data-moreinfant');
			// $errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.infant-cat .booking-category').text()+':</strong> '+$moreInfant);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-error');
		}

		let $infantTicketValue = $instance.find('#mob-enrich-earn-points--container .ticket-infant--input').val();
		let $infantAlertContainer: any = $('#infant-alert--container');
		let $warningAccepted: any = $infantAlertContainer.find('input[name="infant_warning"]');
		// let $childSelectedEle    = parseInt($instance.find('.hotel-container .passengersChildren').val());
		// if($childSelectedEle){
		// 	let $childAgeMsg =0;
		// 	for(var i= 1; i<= $childSelectedEle ; i++){
		// 		let $childAgeVal = $('.hotel-container #childAgeInput'+i).val();
		// 		if($childAgeVal<=0 && $childAgeMsg ==0){
		// 			$passengerDetailsContainer.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge');
		// 			$errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}else if(($childAgeVal<1 || $childAgeVal >17) && $childAgeMsg ==0) {
		// 			$passengerDetailsContainer.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge-limit');
		// 			$errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}
		// 		else{
		// 			$passengerDetailsContainer.removeClass('has-error');
		// 		}
		// 	}
		// }

		/* Adult infant limit check */
		let $adultCount = parseInt($instance.find('#mob-enrich-earn-points--container .passengersAdult').val());
		let $childrenCount = parseInt($instance.find('#mob-enrich-earn-points--container .passengersChildren').val());
		var adultChildComb = 0;
		var $childSel;
		for ($childSel = 1; $childSel <= $childrenCount; $childSel++) {
			var childAgeTemp = parseInt($('#mob-enrich-earn-points--container #childAgeInput' + $childSel).val());
			if (childAgeTemp < 2) {
				adultChildComb++;
			}
		}
		if ($childrenCount > 0) {
			if (adultChildComb > $adultCount) {
				$instance.find('#mob-enrich-earn-points--container .passenger-details').addClass('has-error');
				let $lessAdultInfant: any = $adultBookingError.attr('data-adult-infant-limit');
				// $errorList.push('<strong>'+$('#mob-enrich-earn-points--container [mob-data-booking-passenger-details]').find('.title-caption').text() +':</strong> '+$lessAdultInfant);
				formDataValid = false;
			} else {
				$instance.find('#mob-enrich-earn-points--container .passenger-details').removeClass('has-error');
			}
		}

		if (formDataValid) {
			$errorValidation.hide();
		}


		let $validationContainer: any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist: any = $validationContainer;

		for (var i = 0, len = $errorList.length; i < len; i++) {
			$validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback();
			}
		} else {
			return false;
		}
	}
	mobEnrichHotelEarnDeeplink($instance: any): any {
		let $hotelInputtoVal: any = $instance.find('#mobEnrichHotelEarnInputtoVal').val();
		let $hotelInputVal: any = $instance.find('#mobEnrichHotelEarnInputVal').val();
		let $getDepartureDate = $instance.find('#mob-enrich-earn-points--container .departureDateMobile').val();

		let $departureDate = moment(new Date($getDepartureDate)).format('MM/DD/YYYY');
		let $getReturnDate = $instance.find('#mob-enrich-earn-points--container .returnDateMobile').val();
		let $returnDate = moment(new Date($getReturnDate)).format('MM/DD/YYYY');
		let $childSel: any, $infantSel: any;
		let currencyCode = $("#currencyCode").val();
		let enrichHotelEarnLink = "https://www.enrichhotels.com/search";
		let $CultureCode = 'en-US';

		let $adultCount = parseInt($instance.find('#mob-enrich-earn-points--container .ticket-mob-adult--input').val());
		let $childCount = parseInt($instance.find('#mob-enrich-earn-points--container .ticket-mob-child--input').val());
		let $roomCount = parseInt($instance.find('#mob-enrich-earn-points--container .ticket-mob-room--input').val());

		var InfantCount = 0;
		// var childCount = 0;
		let totalRoomCount: any = 1;
		let $currencyCode = $("#currencyCode").val();
		let $data = {
			query: $hotelInputVal,
			placeId: $hotelInputtoVal,
			checkIn: $departureDate,
			checkOut: $returnDate,
			currency: 'MYR',
			'rooms': $roomCount,
			'program': "enrich",
			'mode': "earn",
			'adults': $adultCount,
			'children': $childCount,
			'language': 'en'

		}

		let $tripFlowUrl = $.param($data);
		let $tripflow_encryptURL = enrichHotelEarnLink + '?' + $tripFlowUrl;
		//    console.log("##Redirect URL: "+ $tripflow_encryptURL);
		//    window.location.href = $tripflow_encryptURL;
		window.open($tripflow_encryptURL, '_blank');
	}
	mobEnrichHotelRedeemFormValidation($instance: any, callback: any): any {
		let _self = this;
		let $errorList: Array<string> = [];

		let $errorValidation = $instance.find('.enrich-validation').first();
		let formDataValid = true;
		let $hotelInputVal: any = $instance.find('#mobEnrichHotelRedeemInputVal');
		let $hotelInputClass: any = $instance.find('.mobEnrichHotelRedeemInputClass');

		if ($hotelInputVal.val() == '') {
			//	$fromSelectize.addClass('has-error');
			$hotelInputClass.addClass('has-error');
			let $hotelValidate: any = $hotelInputVal.attr('data-hotelMsg');
			$errorList.push('<strong>' + $hotelInputVal.parent().find('label').text() + ':</strong> ' + $hotelValidate);
			formDataValid = false;
		} else {
			$hotelInputClass.removeClass('has-error');
			//	$fromBookingTitle.removeClass('has-error');
		}

		let $passengerDetailsActive: any = $('#mob-enrich-redeem-points--container [mob-data-booking-passenger-details-selected]');
		// Validation: IBE One Way Trip Date empty field
		let $checkinDate: any = $instance.find('#mob-enrich-redeem-points--container .departureDateMobile');
		let $checkoutDate: any = $instance.find('#mob-enrich-redeem-points--container .returnDateMobile');


		// /** IBE Return Trip Departure Date empty field validation */
		if ($checkinDate.val() == '') {
			$checkinDate.parent().parent().parent().addClass('has-error');
			let $travelDate: any = $checkinDate.attr('data-travelDepdate');
			$errorList.push('<strong>' + $checkinDate.parent().find('label.dep-title').text() + ':</strong> ' + $travelDate);
			formDataValid = false;
		} else {
			$checkinDate.parent().removeClass('has-error');
		}
		/** IBE Return Trip Return Date empty field validation */
		if ($checkoutDate.val() == '') {
			$checkoutDate.parent().parent().parent().addClass('has-error');
			let $travelEndDate: any = $instance.find('.returnDateMobile').attr('data-travelRetdate');
			$errorList.push('<strong>' + $checkoutDate.parent().find('label.ret-title').text() + ':</strong> ' + $travelEndDate);
			formDataValid = false;
		} else {
			$checkoutDate.parent().removeClass('has-error');
		}

		let $totalTicketsEl: any = $instance.find('#mob-enrich-redeem-points--container input.total-tickets--value'),
			$passengerDetailsContainer: any = $instance.find('#mob-enrich-redeem-points--container [mob-data-booking-passenger-details]');

		// Validation: total ticket value input
		if ($totalTicketsEl.val() == 0) {
			let $nopassenger: any = $totalTicketsEl.attr('data-passenger');
			$passengerDetailsContainer.addClass('has-errors');
			// $errorList.push('<strong>'+$totalTicketsEl.parent().find('label').text()+':</strong> '+$nopassenger);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-errors');
		}

		// Validation: Passenger type input
		let $adultBookingError: any = $instance.find('.adult-booking--error'),
			$infantBookingError: any = $instance.find('.infant-booking--error'),
			$childBookingError: any = $instance.find('.child-age-error');

		if ($adultBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $lessAdult: any = $adultBookingError.attr('data-lessadult');
			// $errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.adult-cat .booking-category').text()+':</strong> '+$lessAdult);
			formDataValid = false;
		} else if ($infantBookingError.css('display') == 'block') {
			$passengerDetailsContainer.addClass('has-error');
			let $moreInfant: any = $infantBookingError.attr('data-moreinfant');
			// $errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.infant-cat .booking-category').text()+':</strong> '+$moreInfant);
			formDataValid = false;
		} else {
			$passengerDetailsContainer.removeClass('has-error');
		}

		let $infantTicketValue = $instance.find('#mob-enrich-redeem-points--container .ticket-infant--input').val();
		let $infantAlertContainer: any = $('#infant-alert--container');
		let $warningAccepted: any = $infantAlertContainer.find('input[name="infant_warning"]');
		// let $childSelectedEle    = parseInt($instance.find('.hotel-container .passengersChildren').val());
		// if($childSelectedEle){
		// 	let $childAgeMsg =0;
		// 	for(var i= 1; i<= $childSelectedEle ; i++){
		// 		let $childAgeVal = $('.hotel-container #childAgeInput'+i).val();
		// 		if($childAgeVal<=0 && $childAgeMsg ==0){
		// 			$passengerDetailsContainer.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge');
		// 			$errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}else if(($childAgeVal<1 || $childAgeVal >17) && $childAgeMsg ==0) {
		// 			$passengerDetailsContainer.addClass('has-error');
		// 			let $inputChildAge:any = $childBookingError.attr('data-childAge-limit');
		// 			$errorList.push('<strong>'+$passengerDetailsContainer.find('.title-caption').text() +' - '+ $passengerDetailsActive.find('.child-age-label').text()+':</strong> '+$inputChildAge);		
		// 			formDataValid = false;
		// 			$childAgeMsg =1;
		// 		}
		// 		else{
		// 			$passengerDetailsContainer.removeClass('has-error');
		// 		}
		// 	}
		// }

		/* Adult infant limit check */
		let $adultCount = parseInt($instance.find('#mob-enrich-redeem-points--container .passengersAdult').val());
		let $childrenCount = parseInt($instance.find('#mob-enrich-redeem-points--container .passengersChildren').val());
		var adultChildComb = 0;
		var $childSel;
		for ($childSel = 1; $childSel <= $childrenCount; $childSel++) {
			var childAgeTemp = parseInt($('#mob-enrich-redeem-points--container #childAgeInput' + $childSel).val());
			if (childAgeTemp < 2) {
				adultChildComb++;
			}
		}
		if ($childrenCount > 0) {
			if (adultChildComb > $adultCount) {
				$instance.find('#mob-enrich-redeem-points--container .passenger-details').addClass('has-error');
				let $lessAdultInfant: any = $adultBookingError.attr('data-adult-infant-limit');
				// $errorList.push('<strong>'+$('#mob-enrich-redeem-points--container [mob-data-booking-passenger-details]').find('.title-caption').text() +':</strong> '+$lessAdultInfant);
				formDataValid = false;
			} else {
				$instance.find('#mob-enrich-redeem-points--container .passenger-details').removeClass('has-error');
			}
		}

		if (formDataValid) {
			$errorValidation.hide();
		}


		let $validationContainer: any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist: any = $validationContainer;

		for (var i = 0, len = $errorList.length; i < len; i++) {
			$validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback();
			}
		} else {
			return false;
		}
	}
	mobEnrichHotelRedeemDeeplink($instance: any): any {
		let $hotelInputtoVal: any = $instance.find('#mobEnrichHotelRedeemInputtoVal').val();
		let $hotelInputVal: any = $instance.find('#mobEnrichHotelRedeemInputVal').val();
		let $getDepartureDate = $instance.find('#mob-enrich-redeem-points--container .departureDateMobile').val();

		let $departureDate = moment(new Date($getDepartureDate)).format('MM/DD/YYYY');
		let $getReturnDate = $instance.find('#mob-enrich-redeem-points--container .returnDateMobile').val();
		let $returnDate = moment(new Date($getReturnDate)).format('MM/DD/YYYY');
		let $childSel: any, $infantSel: any;
		let currencyCode = $("#currencyCode").val();
		let enrichHotelRedeemLink = "https://www.enrichhotels.com/search";
		let $CultureCode = 'en-US';
		let $adultCount = parseInt($instance.find('#mob-enrich-redeem-points--container .ticket-mob-adult--input').val());
		let $childCount = parseInt($instance.find('#mob-enrich-redeem-points--container .ticket-mob-child--input').val());
		let $roomCount = parseInt($instance.find('#mob-enrich-redeem-points--container .ticket-mob-room--input').val());
		var InfantCount = 0;
		// var childCount = 0;

		let $data = {
			query: $hotelInputVal,
			placeId: $hotelInputtoVal,
			checkIn: $departureDate,
			checkOut: $returnDate,
			currency: 'MYR',
			'rooms': $roomCount,
			'program': "enrich",
			'mode': "burn",
			'adults': $adultCount,
			'children': $childCount,
			'language': 'en'

		}

		let $tripFlowUrl = $.param($data);
		let $tripflow_encryptURL = enrichHotelRedeemLink + '?' + $tripFlowUrl;
		//    console.log("##Redirect URL: "+ $tripflow_encryptURL);
		//    window.location.href = $tripflow_encryptURL;
		window.open($tripflow_encryptURL, '_blank');
	}
}
